export const translationsFrFR = {
  "admin.discussion.searchTools.title.online": "Recherche sur le Web public",
  "admin.discussion.searchTools.title.onlineRead": "Lecture d’une page Web",
  "admin.discussion.searchTools.title.indexedDocuments": "Recherche dans les documents indexés",
  "admin.discussion.searchTools.title.unreadable": "Réponse de recherche non reconnue",
  "admin.discussion.searchTools.outcome.FOUND": "Résultats trouvés",
  "admin.discussion.searchTools.outcome.NO_RESULTS": "Aucun résultat",
  "admin.discussion.searchTools.outcome.UNAVAILABLE": "Recherche indisponible",
  "admin.discussion.searchTools.recordedMessage": "Contenu du message outil enregistré dans cette discussion et préparé pour le modèle. Ce message seul ne prouve pas qu’un appel au modèle a ensuite abouti.",
  "admin.discussion.searchTools.request": "Demande de l’Agent",
  "admin.discussion.searchTools.rawResponse": "Voir le message JSON enregistré",
  "admin.discussion.searchTools.callId": "Identifiant de l’appel :",
  "admin.discussion.searchTools.missingContent": "Le contenu de ce message n’est pas disponible.",
  "admin.discussion.searchTools.unreadable": "Le contenu est absent ou son format n’est pas reconnu. Le message d’origine reste consultable lorsqu’il est conservé ; aucune recherche n’est relancée.",
  "admin.discussion.searchTools.unavailable": "Cet appel n’a pas fourni de contenu utilisable. Cela ne signifie pas que l’information recherchée n’existe pas.",
  "admin.discussion.searchTools.noResults": "Aucun résultat n’a été renvoyé pour cette demande.",
  "admin.discussion.searchTools.previewsOnly": "Liens et aperçus renvoyés par le moteur de recherche. Ces pages n’ont pas été téléchargées par cet appel.",
  "admin.discussion.searchTools.partialSearch": "La liste d’aperçus renvoyée est partielle.",
  "admin.discussion.searchTools.requestedUrl": "Adresse demandée :",
  "admin.discussion.searchTools.fetchedAt": "Page téléchargée le",
  "admin.discussion.searchTools.partialBlock": "Cette portion contient seulement une partie de ce bloc de texte.",
  "admin.discussion.searchTools.pageLinks": "Liens présents dans la réponse ({count})",
  "admin.discussion.searchTools.hasMore": "Il reste du texte dans la copie téléchargée. L’Agent a reçu un repère pour demander la suite ; cela ne prouve pas qu’il l’a demandée.",
  "admin.discussion.searchTools.endOfCopy": "Cette portion atteint la fin du texte de la copie téléchargée.",
  "admin.discussion.searchTools.continuationRequest": "Suite demandée avec le repère :",
  "admin.discussion.searchTools.degraded": "Résultat dégradé : une partie de la recherche ou du classement n’a pas pu être utilisée.",
  "admin.discussion.searchTools.scoreHelp": "Les notes concernent les chunks trouvés, pas les voisins ajoutés au texte. Leur nature est indiquée : cosine, bm25, rrf, etc. Ce ne sont pas des pourcentages de certitude comparables entre méthodes.",
  "admin.discussion.searchTools.passage": "Passage {number}",
  "admin.discussion.searchTools.partialContext": "Le texte retourné pour ce passage est partiel.",
  "admin.discussion.searchTools.threshold": "seuil",
  "admin.discussion.searchTools.retrievalId": "Identifiant de la recherche :",
  "myAccount.myChatbot.readiness.onlineSearch.notConfigured": "La recherche Web attend sa configuration sécurisée. Contactez votre administrateur pour terminer la préparation.",
  "myAccount.myChatbot.readiness.onlineSearch.settingsRequired": "La connexion au moteur de recherche et la protection des services internes restent à configurer.",
  "myAccount.myChatbot.readiness.indexedDocuments.notConfigured":
    "La recherche documentaire a besoin de droits de lecture et d’une configuration de recherche. Contactez votre administrateur pour terminer la préparation.",
  "myAccount.myChatbot.readiness.indexedDocuments.settingsRequired":
    "Les droits de lecture des documents et les paramètres de recherche restent à configurer.",
  "knowledge.progress.title": "Imports de connaissances",
  "knowledge.progress.description": "Retrouvez vos derniers imports et suivez la préparation de chaque source.",
  "knowledge.progress.detail": "Avancement de l’import",
  "knowledge.progress.back": "Tous les imports",
  "knowledge.progress.refresh": "Actualiser",
  "knowledge.progress.refreshing": "Actualisation…",
  "knowledge.progress.loading": "Chargement de vos imports…",
  "knowledge.progress.error": "Vos imports ne sont pas disponibles pour le moment. Réessayez avec Actualiser.",
  "knowledge.progress.detailError": "Cet import est indisponible ou n’appartient pas à votre entreprise. Revenez à la liste ou actualisez.",
  "knowledge.progress.empty": "Aucun import pour le moment. Les demandes préparées pour votre entreprise apparaîtront ici.",
  "knowledge.progress.recent": "Les 50 dernières demandes de votre entreprise, de la plus récente à la plus ancienne.",
  "knowledge.progress.target": "Préparation demandée jusqu’à :",
  "knowledge.progress.open": "Voir les sources",
  "knowledge.progress.publication": "Cet écran suit la préparation des sources. Un import terminé ne signifie pas encore que ces connaissances sont publiées auprès de vos Agents.",
  "knowledge.progress.count.total": "sources",
  "knowledge.progress.count.completed": "terminées",
  "knowledge.progress.count.failed": "à vérifier",
  "knowledge.progress.noSources": "Aucune source enregistrée dans cette demande.",
  "knowledge.progress.source": "Source {number}",
  "knowledge.progress.current": "Étape actuelle",
  "knowledge.progress.notRequested": "Non demandée",
  "knowledge.progress.failureAdvice": "Cette source nécessite une vérification. Contactez votre interlocuteur avec la date de l’import et la source concernée ; le diagnostic détaillé est disponible dans le back-office.",
  "knowledge.progress.stage.acquisition": "Lecture de la source",
  "knowledge.progress.stage.normalization": "Nettoyage du contenu",
  "knowledge.progress.stage.chunking": "Organisation du texte",
  "knowledge.progress.stage.embedding": "Préparation de la recherche",
  "knowledge.progress.stage.indexing": "Index de recherche",
  "knowledge.progress.status.QUEUED": "En attente",
  "knowledge.progress.status.RUNNING": "En cours",
  "knowledge.progress.status.WAITING": "En attente de résultat",
  "knowledge.progress.status.RESUMABLE": "En attente de reprise",
  "knowledge.progress.status.SUCCEEDED": "Traitement terminé",
  "knowledge.progress.status.FAILED": "À vérifier",
  "knowledge.progress.status.CANCELLED": "Annulé",
  "knowledge.progress.status.INTERRUPTED": "Interrompu",
  "admin.knowledge.recent.title": "Les {limit} dernières demandes d’ingestion",
  "admin.knowledge.recent.applyFilter": "Filtrer par entreprise",
  "admin.knowledge.recent.allCompanies": "Toutes les entreprises",
  "admin.knowledge.recent.selectedCompany": "Entreprise : {name}",
  "admin.knowledge.recent.loading":
    "Chargement des dernières demandes d’ingestion…",
  "admin.knowledge.inspection.title": "Suivi de l’ingestion",
  "admin.knowledge.inspection.back": "Demandes d’ingestion",
  "admin.knowledge.inspection.refresh": "Actualiser",
  "admin.knowledge.inspection.companyNumber": "Entreprise {number}",
  "admin.knowledge.inspection.target": "Jusqu’à",
  "admin.knowledge.inspection.totalDuration": "Durée totale",
  "admin.knowledge.inspection.capturedAddress": "URL capturée",
  "admin.knowledge.inspection.capturedAt": "Capture enregistrée le",
  "admin.knowledge.inspection.successCount": "{count, plural, one {# source réussie} other {# sources réussies}} sur {total}",
  "admin.knowledge.inspection.failureCount": "{count, plural, one {# échec} other {# échecs}}",
  "admin.knowledge.inspection.remainingCount": "{count} en cours ou en attente",
  "admin.knowledge.inspection.interruptedCount": "{count, plural, one {# résultat inconnu} other {# résultats inconnus}}",
  "admin.knowledge.inspection.cancelledCount": "{count, plural, one {# annulée} other {# annulées}}",
  "admin.knowledge.inspection.notStartedShort": "Pas commencée",
  "admin.knowledge.inspection.previousAttempt": "Vous consultez une tentative précédente. Les cinq étapes au-dessus montrent le traitement actuel.",
  "admin.knowledge.inspection.associatedOutput": "Cette sortie est associée à la tentative choisie ; elle est distincte de son résultat principal.",
  "admin.knowledge.inspection.frozenSettings": "Paramètres utilisés pour cette demande",
  "admin.knowledge.inspection.sourceList": "Sources",
  "admin.knowledge.inspection.findSource": "Rechercher une URL",
  "admin.knowledge.inspection.filter": "État des sources",
  "admin.knowledge.inspection.allSources": "Toutes les sources",
  "admin.knowledge.inspection.sourceNumber": "Source {number} — URL non renseignée",
  "admin.knowledge.inspection.noSources": "Aucune source ne correspond à cette sélection.",
  "admin.knowledge.inspection.stageList": "Les cinq étapes d’ingestion",
  "admin.knowledge.inspection.stageOutput": "Contenu produit par l’étape",
  "admin.knowledge.inspection.attempt": "Tentative",
  "admin.knowledge.inspection.currentRevision": "Traitement actuel",
  "admin.knowledge.inspection.invalidSelection": "Cette source, cette tentative ou cette sortie n’appartient pas à la sélection. Choisissez une source puis une étape dans la liste.",
  "admin.knowledge.inspection.stageFailed": "Cette étape a rencontré une erreur. Le code ci-dessous permet de retrouver sa cause dans les détails techniques.",
  "admin.knowledge.inspection.noOutput": "Cette tentative n’a pas de contenu sauvegardé à consulter. Son état et ses événements restent disponibles dans les détails techniques.",
  "admin.knowledge.inspection.notStarted": "Aucune tentative de cette étape n’est enregistrée pour le traitement sélectionné.",
  "admin.knowledge.inspection.technicalDetails": "Détails techniques · tentatives, événements et identifiants",
  "admin.knowledge.inspection.rawJson": "JSON original de la sortie",
  "admin.knowledge.inspection.actions": "Historique et actions sur cette demande",
  "admin.knowledge.inspection.invalidContext": "Choisissez une entreprise depuis la liste des demandes pour ouvrir ce suivi.",
  "admin.knowledge.inspection.accessDenied": "Votre session ne permet pas de consulter cette demande. Reconnectez-vous avec votre accès administrateur.",
  "admin.knowledge.inspection.notFound": "Cette demande n’a pas été trouvée dans l’entreprise sélectionnée.",
  "admin.knowledge.inspection.readFailed": "La lecture a échoué. Réessayez avec Actualiser ; cela ne relancera aucun traitement.",
  "admin.knowledge.inspection.findText": "Rechercher dans ce contenu",
  "admin.knowledge.inspection.nextMatch": "Occurrence suivante",
  "admin.knowledge.inspection.noMatch": "Aucune autre occurrence. Cliquez à nouveau pour reprendre au début.",
  "admin.knowledge.inspection.capturedHtml": "HTML capturé, affiché comme texte",
  "admin.knowledge.inspection.capturedText": "Texte capturé",
  "admin.knowledge.inspection.failedWithoutContent": "Cette tentative a échoué sans produire de contenu exploitable. Son code d’erreur et les diagnostics conservés permettent d’en examiner la cause.",
  "admin.knowledge.inspection.htmlIsText": "Capture privée sauvegardée : ce HTML est affiché comme du texte, sans scripts ni chargement du site.",
  "admin.knowledge.inspection.scrapingDuration": "Durée du scraping",
  "admin.knowledge.inspection.scrapingDiagnostics": "Téléchargements et erreurs du navigateur",
  "admin.knowledge.inspection.downloadCount": "{count} téléchargements suivis",
  "admin.knowledge.inspection.scriptErrorCount": "{count} erreurs JavaScript signalées",
  "admin.knowledge.inspection.unsupportedCapture": "Ce format n’a pas encore d’aperçu texte. Le résultat original reste disponible dans les détails techniques.",
  "admin.knowledge.inspection.unreadableOutput": "Ce résultat ne peut pas être affiché dans cette vue. Consultez le JSON original dans les détails techniques ; aucune sortie n’est recréée.",
  "admin.knowledge.inspection.blockCount": "{count, plural, one {# bloc normalisé} other {# blocs normalisés}}",
  "admin.knowledge.inspection.compareAcquisition": "Comparer avec la capture HTML",
  "admin.knowledge.inspection.normalizedText": "Texte normalisé",
  "admin.knowledge.inspection.orderedBlocks": "Blocs dans l’ordre du document",
  "admin.knowledge.inspection.warnings": "Points à vérifier dans l’extraction",
  "admin.knowledge.inspection.warning.BODY_FALLBACK": "Aucune zone principale reconnue : le corps de la page a été utilisé.",
  "admin.knowledge.inspection.warning.IMAGE_WITHOUT_TEXT": "Une image ne possède pas de texte exploitable.",
  "admin.knowledge.inspection.warning.STATIC_STREAM_ASSEMBLY": "Des fragments HTML ont été regroupés avant l’extraction.",
  "admin.knowledge.inspection.showMore": "Afficher la suite",
  "admin.knowledge.inspection.chunkCount": "{count, plural, one {# passage conservé} other {# passages conservés}}",
  "admin.knowledge.inspection.passage": "Passage",
  "admin.knowledge.inspection.tokenCount": "{count} tokens pour l’embedding",
  "admin.knowledge.inspection.chunkText": "Texte du passage",
  "admin.knowledge.inspection.chunkTextHelp": "Le texte du document normalisé, sans titres ajoutés. À utiliser pour citer le passage.",
  "admin.knowledge.inspection.searchText": "Texte envoyé à l’embedding",
  "admin.knowledge.inspection.searchTextHelp": "Le même passage, précédé des titres disponibles pour calculer son vecteur de recherche. Sans titres, les deux textes sont identiques.",
  "admin.knowledge.inspection.overlapCharacters": "Recouvrement avec le passage précédent : {count} caractères Unicode du document normalisé. Ce n’est pas un nombre de tokens.",
  "admin.knowledge.inspection.originBlocks": "Identifiants des blocs repris",
  "admin.knowledge.inspection.citations": "Origines et liens de citation conservés",
  "admin.knowledge.inspection.embeddedCount": "{count, plural, one {# texte transformé en vecteur} other {# textes transformés en vecteurs}}",
  "admin.knowledge.inspection.model": "Modèle enregistré",
  "admin.knowledge.inspection.dimensions": "Dimensions du vecteur",
  "admin.knowledge.inspection.measuredTokens": "Tokens mesurés par le fournisseur",
  "admin.knowledge.inspection.providerCall": "Appel fournisseur",
  "admin.knowledge.inspection.reusedCall": "Réponse sauvegardée réutilisée",
  "admin.knowledge.inspection.newCall": "Nouvel appel effectué",
  "admin.knowledge.inspection.callUnknown": "Non renseigné dans cette sortie",
  "admin.knowledge.inspection.accounting": "Comptabilisation du coût",
  "admin.knowledge.inspection.accounted": "Coût enregistré dans le journal",
  "admin.knowledge.inspection.accountingNotConfirmed": "Enregistrement du coût non confirmé dans cette vue",
  "admin.knowledge.inspection.indexedCount": "{count, plural, one {# passage de cette source indexé} other {# passages de cette source indexés}}",
  "admin.knowledge.inspection.indexDestination": "Détail technique : index Elasticsearch",
  "admin.knowledge.inspection.versionSelected": "Cette version a été retenue à la fin de cette tentative. Une ingestion plus récente peut l’avoir remplacée depuis.",
  "admin.knowledge.inspection.versionSuperseded": "Cette version n’a pas été retenue : une version plus récente de cette source était déjà indexée.",
  "admin.knowledge.inspection.selectionUnknown": "Ce résultat ne précise pas quelle version a été retenue.",
  "admin.knowledge.inspection.retrievalPending": "La recherche dans ces passages par les Agents n’est pas encore raccordée. Une indexation réussie ne prouve pas qu’un Agent peut les utiliser.",
  "admin.knowledge.predecessor": "Entrée conservée : tentative précédente",
  "admin.knowledge.recordedSteps": "Sous-opérations réellement enregistrées",
  "admin.knowledge.inputFingerprint": "Empreinte de l’entrée",
  "admin.knowledge.outputFingerprint": "Empreinte de la sortie",
  "admin.knowledge.step.acquire": "Obtenir le contenu",
  "admin.knowledge.step.parse": "Extraire la structure",
  "admin.knowledge.step.normalize": "Normaliser le document",
  "admin.knowledge.step.chunk": "Découper en passages",
  "admin.knowledge.step.embed": "Calculer les vecteurs",
  "admin.knowledge.step.index": "Enregistrer la projection de recherche",
  "admin.knowledge.sourceHistory": "Historique des ingestions de cette source (jusqu’à 50)",
  "admin.knowledge.retryPreview": "Examiner la reprise de cette source",
  "admin.knowledge.retryScope": "Reprendre à cette étape, puis continuer jusqu’à la limite de la demande d’ingestion :",
  "admin.knowledge.retryPreserves": "Les étapes précédentes et leurs reçus sont conservés. Une nouvelle tentative sera enregistrée, sans modifier l’historique.",
  "admin.knowledge.retryPaid": "J’autorise les nouveaux appels d’embedding éventuellement nécessaires pour cette reprise.",
  "admin.knowledge.retryNoNewPaidCall": "Cette reprise ne crée pas de nouvel appel payé : elle reste soumise aux reçus existants.",
  "admin.knowledge.retryConfirm": "Confirmer la reprise ciblée",
  "admin.knowledge.retryBlocked.SOURCE_NOT_RETRYABLE": "La source n’est plus en échec ou annulée. Actualisez son parcours.",
  "admin.knowledge.retryBlocked.PROFILE_INCOMPATIBLE": "Cette demande d’ingestion utilise un ancien profil. Aucune conversion automatique n’est autorisée.",
  "admin.knowledge.retryBlocked.ATTEMPT_LIMIT": "Le nombre maximal de tentatives est atteint. Examinez la cause avant d’envisager une nouvelle demande d’ingestion explicite.",
  "admin.knowledge.retryBlocked.INPUT_UNAVAILABLE": "La sortie précédente est absente, expirée ou corrompue. Aucune nouvelle acquisition implicite n’est autorisée.",
  "admin.knowledge.retryBlocked.PAID_OUTCOME_UNCERTAIN": "L’issue de l’appel payé reste inconnue. Retrouvez son reçu avant toute reprise ; une confirmation ne peut pas contourner ce blocage.",
  "admin.knowledge.retryBlocked.RETAINED_RECEIPT_INVALID": "Le reçu d’embedding est invalide ou son contenu a expiré. Cette reprise ne peut pas créer un deuxième appel pour la même entrée.",
  "admin.knowledge.activity": "Activité du pipeline",
  "admin.knowledge.serviceState": "Voir l’état des services",
  "admin.knowledge.diagnostic.CONSUMERS_MISSING": "Capacité demandée, aucune instance prête observée. Vérifiez le gestionnaire et les contrôles de santé.",
  "admin.knowledge.diagnostic.CAPACITY_SATURATED": "Toutes les places observées travaillent ; d’autres tâches attendent. Une hausse reste soumise au budget du VPS.",
  "admin.knowledge.diagnostic.WORK_STALLED": "Du travail attend depuis plus de cinq minutes sans succès récent malgré une instance prête. Consultez les tentatives et les reports.",
  "admin.knowledge.diagnostic.PUBLICATION_OVERDUE": "Une notification est prévue depuis plus d’une minute. Vérifiez le publisher et RabbitMQ ; cela ne prouve pas une perte de travail.",
  "admin.knowledge.diagnostic.EXECUTION_LEASE_EXPIRED": "Une réservation d’exécution a expiré. Le journal permet sa récupération ; ne forcez pas de réussite ni de nouvel appel payant.",
  "admin.knowledge.diagnostic.REPEATED_FAILURES": "Au moins trois tentatives ont échoué ou été interrompues en cinq minutes. Consultez leurs causes avant une reprise.",
  "admin.knowledge.refresh": "Actualiser",
  "admin.knowledge.activityUnavailable": "Le journal d’activité est indisponible. Aucun succès n’est déduit de l’état Docker.",
  "admin.knowledge.managerUnobserved": "Aucune observation récente du gestionnaire. Les instances peuvent toujours fonctionner : vérifiez Knowledge Management et le gestionnaire de conteneurs.",
  "admin.knowledge.observedAt": "Observation du gestionnaire",
  "admin.knowledge.step": "Étape",
  "admin.knowledge.configured": "Souhaitées",
  "admin.knowledge.started": "Démarrées",
  "admin.knowledge.ready": "Prêtes",
  "admin.knowledge.stopping": "En arrêt",
  "admin.knowledge.queued": "Travaux en attente",
  "admin.knowledge.activeWork": "Travaux actifs",
  "admin.knowledge.suspended": "Suspendus / reprenables",
  "admin.knowledge.failed": "Échecs",
  "admin.knowledge.throughput": "Réussis / 5 min",
  "admin.knowledge.noReadyInstances": "Capacité demandée, aucune instance prête observée",
  "admin.knowledge.oldest": "Plus ancien",
  "admin.knowledge.activityHelp": "Les instances viennent d’une observation Docker récente. Les travaux viennent du journal PostgreSQL, pas du nombre de messages RabbitMQ. Une acquisition suspendue ne mobilise plus son worker ; une instance de rendu peut avoir plusieurs places actives.",
  "admin.knowledge.operations": "Contrôle de l’ingestion",
  "admin.knowledge.capacity": "Instances souhaitées",
  "admin.knowledge.capacityHelp": "Une tâche par instance. Zéro met l’étape en pause après les tâches engagées, sans effacer son travail. Le rendu possède ses propres places Chromium.",
  "admin.knowledge.browserPlaces": "Places Chromium par instance de rendu",
  "admin.knowledge.revision": "Révision",
  "admin.knowledge.budget": "Ressources réservées",
  "admin.knowledge.budgetExceeded": "Cette capacité dépasse le budget approuvé. Réduisez les nombres ou faites revoir le budget du VPS.",
  "admin.knowledge.capacityUnavailable": "Configuration indisponible. Les instances existantes sont conservées ; ce n’est pas une demande de mise à zéro.",
  "admin.knowledge.saveCapacity": "Appliquer cette capacité",
  "admin.knowledge.createIngestionRequest": "Lancer une demande d’ingestion",
  "admin.knowledge.explicitUrls": "Une URL par ligne, jusqu’à 100. Aucun crawl automatique. Jusqu’à indexation, cette demande d’ingestion peut appeler le fournisseur d’embeddings configuré.",
  "admin.knowledge.urls": "Sources à ingérer (une URL par ligne)",
  "admin.knowledge.throughStage": "Traiter jusqu’à",
  "admin.knowledge.chunking.title": "Découpage des passages",
  "admin.knowledge.chunking.maxTokens": "Maximum de tokens par chunk",
  "admin.knowledge.chunking.maxTokensHelp": "Titres et chevauchement compris. Choisissez un entier de 1 à {maximum} ; un chunk peut être plus court. Cette taille reste fixée pour toute la demande.",
  "admin.knowledge.chunking.sizeSummary": "Maximum : {amount} tokens par chunk",
  "admin.knowledge.embedding.title": "Modèle des vecteurs",
  "admin.knowledge.embedding.model": "Modèle",
  "admin.knowledge.embedding.provider": "Fournisseur",
  "admin.knowledge.embedding.dimensions": "Dimensions",
  "admin.knowledge.embedding.profile": "Profil enregistré",
  "admin.knowledge.embedding.help":
    "Ce choix est conservé avec la demande. Comparer plusieurs modèles nécessite des demandes séparées ; leurs vecteurs ne sont pas interchangeables.",
  "admin.knowledge.embedding.indexHelp":
    "L’index knowledge-base utilise un seul modèle pour que ses vecteurs soient comparables. Pour tester un autre modèle, arrêtez cette demande à l’étape Embedding.",
  "admin.knowledge.embedding.unknown": "Modèle conservé non renseigné",
  "admin.knowledge.chunking.help": "Ces choix sont conservés pour toute la demande. Le chevauchement répète au plus {maximum} % des tokens du passage précédent, sans compter les titres. Il peut être réduit pour respecter la taille des chunks et les structures du document.",
  "admin.knowledge.chunking.overlap": "Chevauchement",
  "admin.knowledge.chunking.none": "Aucun (0)",
  "admin.knowledge.chunking.tokens": "Nombre de tokens",
  "admin.knowledge.chunking.percent": "Pourcentage du passage précédent",
  "admin.knowledge.chunking.quantity": "Quantité souhaitée",
  "admin.knowledge.chunking.boundary": "Préférer les coupures",
  "admin.knowledge.chunking.word": "Entre les mots",
  "admin.knowledge.chunking.sentence": "En fin de phrase (si elle tient dans un chunk)",
  "admin.knowledge.chunking.tokenAmount": "{amount} tokens",
  "admin.knowledge.chunking.percentAmount": "{amount} %",
  "admin.knowledge.chunking.invalid": "Choisissez une taille de chunk et une quantité entières positives dans les limites indiquées.",
  "admin.knowledge.urlSelectionInvalid": "Indiquez entre 1 et 100 URL explicites.",
  "admin.knowledge.cancelIngestionRequest": "Annuler les travaux restants",
  "admin.knowledge.cancelConfirm": "Annuler les travaux en attente et demander l’arrêt des travaux engagés ? Les résultats sauvegardés et leur historique seront conservés.",
  "admin.knowledge.commandSaved": "Commande sauvegardée. Le gestionnaire applique la capacité ; les workers poursuivent les travaux autorisés.",
  "admin.knowledge.commandFailed": "Commande non confirmée. Réessayez la même demande : son identité est conservée pour éviter un doublon.",
  "admin.knowledge.conflict": "La configuration ou la commande a changé. Rechargez la page et vérifiez les valeurs avant de recommencer.",
  "admin.knowledge.title": "Ingestion Knowledge",
  "admin.knowledge.description": "Suivez le parcours de chaque source, ses tentatives et ses blocages. Cette inspection ne modifie pas les Agents.",
  "admin.knowledge.company": "Entreprise (identifiant)",
  "admin.knowledge.inspect": "Voir les demandes d’ingestion",
  "admin.knowledge.unavailable": "L’inspection est indisponible. Vérifiez Knowledge Management puis rechargez cette page.",
  "admin.knowledge.ingestionRequests": "Demandes d’ingestion récentes (50 maximum)",
  "admin.knowledge.empty": "Aucune demande d’ingestion pour cette entreprise.",
  "admin.knowledge.sources": "Parcours des sources",
  "admin.knowledge.waitingRender": "L’acquisition attend le résultat durable du rendu web. Son worker est libéré ; les autres sources peuvent avancer.",
  "admin.knowledge.notStarted": "Aucune tentative enregistrée pour cette étape.",
  "admin.knowledge.render": "Rendu web délégué",
  "admin.knowledge.eligibleAt": "Prochaine exécution autorisée à partir de",
  "admin.knowledge.artifact": "Voir l’artefact privé",
  "admin.knowledge.expires": "Expiration",
  "admin.knowledge.inert": "Contenu affiché comme texte uniquement. Aucun script ou ressource distante n’est exécuté.",
  "admin.knowledge.sources.title": "Origine des passages — {count} premiers repères maximum",
  "admin.knowledge.sources.captureOnly": "Ces repères décrivent la version récupérée. Le site peut avoir changé ; le lien et la surbrillance dépendent de son contenu actuel et du navigateur.",
  "admin.knowledge.sources.revision": "Révision du document",
  "admin.knowledge.sources.textRange": "Positions précises conservées dans l’extrait d’origine ; le lien peut viser l’élément entier.",
  "admin.knowledge.sources.elementOnly": "Repère de l’élément ou de sa section, sans positions précises dans le texte d’origine.",
  "admin.knowledge.sources.documentOnly": "Document d’origine connu, sans repère fiable du passage.",
  "admin.knowledge.sources.reason.ELEMENT_NOT_IN_CAPTURE": "Document seulement : l’élément n’a pas été retrouvé dans la capture d’origine.",
  "admin.knowledge.sources.reason.NO_RELIABLE_LOCATION": "Document seulement : aucun repère fiable du passage n’a pu être conservé.",
  "admin.knowledge.sources.open": "Ouvrir la source actuelle",
  "admin.knowledge.expired": "Contenu expiré ou indisponible. Les métadonnées restent consultables ; aucune nouvelle acquisition n’est déclenchée.",
  "admin.knowledge.providerReceipt": "Reçu du fournisseur et état de comptabilisation",
  "admin.knowledge.stage.acquisition": "1. Acquisition",
  "admin.knowledge.stage.normalization": "2. Normalisation",
  "admin.knowledge.stage.chunking": "3. Découpage en passages",
  "admin.knowledge.stage.embedding": "4. Embedding",
  "admin.knowledge.stage.indexing": "5. Indexation",
  "admin.knowledge.status.QUEUED": "En attente d’exécution",
  "admin.knowledge.status.RUNNING": "En cours",
  "admin.knowledge.status.WAITING": "Suspendue, en attente de rendu",
  "admin.knowledge.status.RESUMABLE": "Résultat disponible, reprise attendue",
  "admin.knowledge.status.SUCCEEDED": "Réussie",
  "admin.knowledge.status.FAILED": "Échouée",
  "admin.knowledge.status.CANCELLED": "Annulée",
  "admin.knowledge.status.INTERRUPTED": "Interrompue, résultat inconnu",
  "admin.company.usageLoadError":
    "Impossible de charger la consommation. Rechargez la page pour réessayer.",
  "admin.supportDelivery.loadError":
    "Impossible de charger l’état des livraisons des demandes SAV.",
  "admin.supportDelivery.loading": "Vérification des livraisons SAV…",
  "admin.supportDelivery.title": "Livraison des demandes SAV",
  "admin.supportDelivery.historical":
    "Résultats de livraison enregistrés. Une demande sauvegardée ou un tour de l’Agent réussi ne prouve pas son envoi à Slack. Corriger Slack ne renvoie pas automatiquement les demandes bloquées.",
  "admin.supportDelivery.truncated":
    "Seules les 100 livraisons mises à jour le plus récemment sont affichées.",
  "admin.supportDelivery.action.CHECK_CHANNEL":
    "Vérifiez l’identifiant du canal Slack et invitez l’application ChatSystem dans ce canal. Slack ne permettait pas d’y accéder.",
  "admin.supportDelivery.action.INVITE_BOT":
    "Invitez l’application ChatSystem dans le canal Slack. Elle n’en était pas membre lors de la tentative d’envoi.",
  "admin.supportDelivery.action.CHANGE_CHANNEL":
    "Le canal Slack était archivé. Sélectionnez un canal actif dans la configuration du Tool.",
  "admin.supportDelivery.action.REAUTHORIZE":
    "Mettez à jour l’autorisation Slack depuis le Tool, puis vérifiez l’accès au canal.",
  "admin.supportDelivery.action.CHECK_CONFIGURATION":
    "La livraison a été refusée. Vérifiez la connexion et le canal dans la configuration du Tool. L’erreur conservée ne permet pas d’établir une cause plus précise.",
  "admin.supportDelivery.action.VERIFY_DELIVERY":
    "La livraison est incertaine. Vérifiez la destination avant tout renvoi pour éviter un doublon.",
  "discussion.toolsUnavailable.customer":
    "{count, plural, one {Un Tool manque pour cette réponse} other {Plusieurs Tools (#) manquent pour cette réponse}} : {tools}.",
  "discussion.toolsUnavailable.admin":
    "Les Tools suivants n’ont pas pu être proposés pendant ce tour : {tools}.",
  "discussion.toolsUnavailable.checkVersion":
    "La version du client n’est peut-être pas à jour. Pouvez-vous vérifier que vous utilisez bien la dernière version de {packageLink}, disponible sur npm ?",
  "discussion.toolsUnavailable.checkConfiguration":
    "{count, plural, one {Le Tool {tools} n’est probablement pas configuré correctement. Pouvez-vous vérifier sa configuration dans {settingsLink} ?} other {Les Tools {tools} ne sont probablement pas configurés correctement. Pouvez-vous vérifier leur configuration dans {settingsLink} ?}}",
  "discussion.toolsUnavailable.agentSettings": "les paramètres de votre Agent",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.unknown":
    "Impossible de vérifier Slack pour le moment. Relancez la vérification.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.reconnect":
    "La connexion Slack n’est plus valide. Reconnectez votre espace de travail.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.connected":
    "Connecté à Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.button":
    "Tester la connexion",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.again":
    "Tester à nouveau",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.recommended":
    "Un petit test est conseillé pour confirmer que les notifications de cet outil arrivent bien dans ce canal.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.recommendedLabel":
    "Canal pas encore testé pour cet outil",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.verifiedLabel":
    "Canal testé pour cet outil",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.sending":
    "Envoi en cours…",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.hint":
    "Un petit message de test sera envoyé dans le canal enregistré pour ce Tool.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.saveFirst":
    "Enregistrez votre canal pour pouvoir y envoyer le message de test.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.SENT":
    "Le message de test est parti ! Vous pouvez le retrouver dans votre canal Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.NOT_CONFIGURED":
    "Pour essayer, enregistrez d’abord la connexion Slack et le canal de ce Tool.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.CHANNEL_INACCESSIBLE":
    "Nous n’avons pas pu envoyer le message dans ce canal. Pouvez-vous vérifier le canal et y inviter l’application ChatSystem, puis réessayer ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.CHANNEL_ARCHIVED":
    "Ce canal Slack est archivé. Pouvez-vous choisir un canal actif, puis réessayer ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.RECONNECT_REQUIRED":
    "La connexion à Slack a besoin d’être renouvelée. Pouvez-vous reconnecter votre espace de travail, puis réessayer ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.MISSING_PERMISSION":
    "Il manque une autorisation pour envoyer le message. Pouvez-vous mettre à jour l’autorisation Slack, puis réessayer ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.UNAVAILABLE":
    "Le test n’a pas pu aboutir pour le moment. Pouvez-vous réessayer dans une minute ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.UNCERTAIN":
    "Nous n’avons pas reçu de confirmation. Le message est peut-être arrivé : pouvez-vous regarder dans votre canal Slack avant de réessayer ?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.ready":
    "ChatSystem a accès au canal configuré. Cette vérification n’envoie pas de message de test.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.noChannel":
    "Choisissez et enregistrez un canal pour recevoir les demandes.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.unavailable":
    "Le canal configuré est inaccessible. Vérifiez son identifiant et invitez l’application ChatSystem dans ce canal.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.notMember":
    "Invitez l’application ChatSystem dans le canal configuré, puis relancez la vérification.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.archived":
    "Ce canal est archivé. Choisissez un canal actif.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.permissions":
    "Les autorisations Slack sont incomplètes. Mettez à jour l’autorisation Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.channelUnknown":
    "L’accès au canal n’a pas pu être vérifié. Relancez la vérification.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.manageAuthorization":
    "Mettre à jour l’autorisation Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.checkAgain":
    "Vérifier à nouveau",
  "admin.agentTurn.compact.title": "Exécution de l’Agent",
  "admin.agentTurn.compact.calls": "Outils appelés",
  "admin.agentTurn.compact.trace":
    "Voir les traces techniques ({count} événements)",
  "admin.agentTurn.compact.promptReference":
    "Prompt #{number} — consultable ci-dessus, sans répétition ici.",
  "admin.agentTurn.compact.export": "Télécharger les traces brutes (JSON)",
  "admin.discussion.systemInstructions": "Instructions système — message #{id}",
  "myAccount.supportRequests.detail.loading": "Chargement de la demande…",
  "myAccount.supportRequests.detail.retry": "Réessayer",
  "admin.agentTurn.tools.unknown":
    "La liste complète des Tools n’est pas lisible. Consultez les traces techniques conservées.",
  "admin.agentTurn.tools.resume":
    "Reprise de {functionName}. Aucune nouvelle fonction n’est annoncée au modèle.",
  "admin.agentTurn.tools.count": "Tools disponibles : {count}",
  "admin.agentTurn.tools.providerCount":
    "Fonctions annoncées dans cette requête : {count}",
  "admin.agentTurn.tools.instructions":
    "Descriptions et sources des instructions des Tools",
  "admin.agentTurn.tools.schema": "Schéma des paramètres",
  "admin.agentTurn.tools.excluded": "Tools exclus",
  "admin.agentTurn.source.AGENT_OVERRIDE":
    "Instructions personnalisées pour cet Agent",
  "admin.agentTurn.source.TOOL_DEFAULT": "Instructions par défaut du Tool",
  "admin.agentTurn.source.FUNCTION_DESCRIPTION":
    "Description de la fonction utilisée comme instructions",
  "admin.agentTurn.legacy":
    "6.3 : les messages système d’origine sont envoyés sans modification. Les instructions des Tools décrivent la configuration résolue, pas un prompt historique recomposé.",
  "admin.agentTurn.unknown": "Inconnu",
  "admin.agentTurn.yes": "Oui",
  "admin.agentTurn.no": "Non",
  "admin.agentTurn.protocol.absent": "Aucun",
  "admin.agentTurn.header.SUPPORTED": "Reconnu",
  "admin.agentTurn.header.MISSING": "Absent",
  "admin.agentTurn.header.INVALID": "Invalide",
  "admin.agentTurn.admission.requested": "Protocole demandé",
  "admin.agentTurn.admission.header": "En-tête de protocole",
  "admin.agentTurn.admission.effective": "Protocole effectif",
  "admin.agentTurn.admission.enabled": "Continuation activée dans le processus",
  "admin.agentTurn.admission.token": "App Token présent",
  "admin.agentTurn.reason.INTERACTIVE_WIDGET_PROTOCOL_REQUIRED":
    "Protocole interactif requis indisponible : vérifier les prérequis ci-dessous.",
  "admin.agentTurn.reason.LOCAL_PREVIEW_UNAVAILABLE":
    "Prévisualisation locale indisponible",
  "admin.agentTurn.reason.DEMO_EXECUTION_NOT_AUTHORIZED":
    "Exécution non autorisée pour cette démo",
  "admin.agentTurn.reason.DELEGATED_EXECUTION_DISABLED":
    "Exécution déléguée désactivée",
  "admin.agentTurn.reason.IDENTITY_REQUIRED": "Identité du visiteur requise",
  "admin.agentTurn.reason.IDENTITY_EXPIRED": "Identité du visiteur expirée",
  "admin.agentTurn.citations.reference": "Source {number} · résultat {position} de l’appel",
  "admin.agentTurn.citations.saved": "Sources enregistrées avec cette réponse",
  "admin.agentTurn.citations.origin.web_page": "Page Web lue",
  "admin.agentTurn.citations.origin.search_excerpt": "Aperçu de recherche, pas une page téléchargée",
  "admin.agentTurn.citations.origin.indexed_document": "Document indexé de l’entreprise",
  "admin.agentTurn.citations.reused": "Source d’un tour précédent",
  "admin.agentTurn.citations.new": "Source trouvée pendant ce tour",
  "admin.agentTurn.citations.toolResult": "Voir le résultat du Tool dans cette discussion",
  "admin.agentTurn.citations.diagnostic": "Référence retirée ou citation absente (non affiché au visiteur)",
  "admin.agentTurn.event.CITATION_EVIDENCE_REJECTED": "Source conservée exclue de la requête au modèle",
  "admin.agentTurn.event.CITATIONS_PREPARED": "Références de citation contrôlées",
  "admin.agentTurn.event.CITATIONS_PERSISTED": "Réponse et citations enregistrées",
  "admin.agentTurn.event.CITATIONS_STREAM_WRITE_ATTEMPTED": "Métadonnées finales écrites dans le flux (pas un accusé de réception du navigateur)",
  "admin.agentTurn.event.CONTEXT_RESOLVED": "Configuration du tour résolue",
  "admin.agentTurn.event.PROVIDER_REQUEST": "Requête envoyée au modèle",
  "admin.agentTurn.event.PROVIDER_RESPONSE_HEADERS":
    "Réponse reçue du fournisseur",
  "admin.agentTurn.event.PROVIDER_TRANSPORT_FAILED":
    "Échec de communication avec le fournisseur",
  "admin.agentTurn.event.TOOL_STARTED": "Exécution du Tool démarrée",
  "admin.agentTurn.event.TOOL_RETURNED": "Résultat du Tool reçu",
  "admin.agentTurn.event.TOOL_FAILED": "Échec d’exécution du Tool",
  "admin.agentTurn.event.TOOL_SUSPENDED":
    "Tour en attente d’une interaction du visiteur",
  "admin.agentTurn.event.SESSION_COMPLETED": "Réponse du modèle terminée",
  "admin.agentTurn.event.SESSION_FAILED": "Échec de la réponse du modèle",
  "admin.agentTurn.event.TURN_FAILED": "Échec du tour",
  "admin.agentTurn.event.TURN_PERSISTED": "Conversation enregistrée",
  "admin.agentTurn.event.TURN_PERSISTENCE_FAILED":
    "Échec d’enregistrement de la conversation",
  "admin.agentTurn.event.CONTINUATION_COMPLETED": "Reprise terminée",
  "admin.agentTurn.event.CONTINUATION_COMPLETION_FAILED":
    "Échec de finalisation de la reprise",
  "admin.agentTurn.title": "Tour de l’Agent — traces d’exécution",
  "admin.agentTurn.unreadable":
    "Cette trace est incomplète ou utilise une version non prise en charge. Cela ne signifie pas qu’aucun outil n’était disponible.",
  "admin.agentTurn.historical":
    "Configuration résolue pour cette exécution. Les modifications ultérieures ne changent pas cet historique.",
  "admin.agentTurn.prompt": "Prompt système effectif",
  "admin.agentTurn.configuration":
    "Instructions, sources et fonctions disponibles",
  "admin.agentTurn.details": "Détails techniques et payloads conservés",
  "admin.agentTurn.truncated":
    "Snapshot limité : le contenu complet n’a pas été conservé. L’empreinte couvre l’entrée complète.",
  "generic.language.english": "Anglais",
  "generic.language.french": "Français",
  "generic.connect.google": "Se connecter avec Google",
  "generic.button.title.save": "Sauvegarder",
  "generic.crud.create.cta": "Créer",
  "generic.use.none": "Aucun",
  "generic.use.next": "Suivant",
  "generic.dataType.string": "chaine de caractères",
  "generic.dataType.string.developped":
    "Tous textes, mots divers du langage, lien URL...",
  "generic.dataType.boolean": "vrai/faux",
  "generic.dataType.boolean.developped":
    "donnée qui ne peut être que vraie ou fausse, ou oui/non",
  "generic.dataType.number": "chiffres & nombres",
  "generic.dataType.number.developped":
    "données de type chiffre ou nombre. Ne peut contenir de texte.",
  "generic.dataType.date": "dates",
  "generic.dataType.date.developped":
    "tout types de date, contenant au minimum l'année.",
  "generic.dataType.enum": "liste définie",
  "generic.dataType.enum.developped":
    "liste de valeurs possibles qui sont connues à l'avance",
  "generic.form.dropdown.placeholder": "Choisir ...",
  "generic.form.uploadButton.label": "Choisir une image",
  "generic.form.uploadButton.hint": "PNG, JPG, WebP… jusqu'à 10Mo.",
  "generic.form.uploadButton.drop": "Ou glissez votre image ici",
  "generic.form.uploadButton.preview": "Aperçu",
  "generic.form.uploadButton.loading": "Chargement…",
  "generic.save": "Sauvegarder",
  "locale.en-US.label": "Anglais",
  "locale.fr-FR.label": "Français",
  "generic.delete": "Effacer",
  "generic.cancel": "Annuler",
  "generic.close": "Fermer",
  "generic.name": "Nom",
  "generic.description": "Description",
  "generic.deleting.ellipsis": "En train d'effacer ...",
  "generic.notification.error":
    "Il y a eu une erreur. Merci de réessayer ultérieurement.",
  "generic.notification.error.showMessage":
    "Il y a eu une erreur pendant cette opération. Erreur log :",
  "generic.contactUs.calendly": "Contactez-nous",
  "generic.demo.calendly": "Contact",
  "generic.loading": "Chargement...",

  "myAccount.page.myAgents.edit.tools.customerSupport.slack.title":
    "Support client Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.description":
    "Connectez Slack, créez ou choisissez un canal de support, invitez le bot, puis collez l'ID du canal ici.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.title":
    "Recevoir aussi les demandes dans Slack — optionnel",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.description":
    "Chaque nouvelle demande sera automatiquement publiée dans le canal Slack choisi afin que votre équipe puisse la traiter et recontacter le visiteur. Nous vous conseillons de créer un canal dédié, par exemple #demandes-clients, pour garder les demandes visibles et faciles à suivre.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.configured":
    "Les nouvelles demandes seront automatiquement transmises dans le canal Slack configuré ({channelId}).",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.persistence":
    "Les demandes restent enregistrées dans ChatSystem, même si Slack n'est pas connecté.",
  "myAccount.page.leftMenu.supportRequests": "Demandes clients",
  "myAccount.supportRequests.title": "Demandes clients",
  "myAccount.supportRequests.description":
    "Consultez les demandes recueillies par vos Agents et tenez leur suivi à jour.",
  "myAccount.supportRequests.filter.status": "Statut",
  "myAccount.supportRequests.filter.agent": "Agent",
  "myAccount.supportRequests.status.open": "Ouverte",
  "myAccount.supportRequests.status.resolved": "Résolue",
  "myAccount.supportRequests.status.all": "Toutes",
  "myAccount.supportRequests.agent.all": "Tous les Agents",
  "myAccount.supportRequests.loading": "Chargement des demandes...",
  "myAccount.supportRequests.error.load":
    "Les demandes n'ont pas pu être chargées.",
  "myAccount.supportRequests.error.detail":
    "Le détail de la demande n'a pas pu être chargé.",
  "myAccount.supportRequests.error.update":
    "Le statut de la demande n'a pas pu être mis à jour.",
  "myAccount.supportRequests.empty":
    "Aucune demande ne correspond à ces filtres.",
  "myAccount.supportRequests.redacted":
    "Contenu supprimé conformément à la politique de conservation.",
  "myAccount.supportRequests.select":
    "Sélectionnez une demande pour afficher son détail.",
  "myAccount.supportRequests.contact": "Contact",
  "myAccount.supportRequests.message": "Demande",
  "myAccount.supportRequests.resolve": "Marquer comme résolue",
  "myAccount.supportRequests.reopen": "Rouvrir",
  "myAccount.supportRequests.discussion": "Voir la conversation",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connect":
    "Connecter Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.reconnect":
    "Reconnecter Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connecting":
    "Connexion...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.loading":
    "Chargement de la configuration Slack...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connected":
    "Connecté à l'espace {workspace}.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.notConnected":
    "Slack n'est pas encore connecté.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.connect":
    "Connectez cet outil ChatSystem à votre espace Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.channel":
    "Créez un canal de support dédié, ou choisissez un canal existant.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.invite":
    "Invitez le bot ChatSystem dans ce canal Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.channelId":
    "Collez l'ID du canal Slack ci-dessous, puis sauvegardez.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.channelId.label":
    "ID du canal Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.saveChannel":
    "Sauvegarder le canal",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.saving":
    "Sauvegarde...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.channelHint":
    "Utilisez l'ID du canal Slack, pas son nom. Les IDs de canaux publics commencent généralement par C ; les canaux privés par G.",
  "myAccount.page.myAgents.edit.operatorLocale.title":
    "Langue de communication de l’agent",
  "myAccount.page.myAgents.edit.operatorLocale.description":
    "Utilisée lorsque cet agent envoie des messages opérationnels à votre équipe.",
  "myAccount.page.myAgents.edit.operatorLocale.inherit":
    "Langue de la société ({language})",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.load.error":
    "Impossible de charger la configuration Slack du support client.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.activationLoad.error":
    "Impossible de charger l'activation de l'outil de support client.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.connect.error":
    "Impossible de connecter Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.required":
    "Veuillez renseigner l'ID du canal Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.workspace.required":
    "Connectez Slack avant de sauvegarder un canal de support.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.workspace.reused":
    "L’espace Slack de votre société est connecté. Choisissez et sauvegardez le canal de cet outil.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.saved":
    "Le canal Slack du support client a été sauvegardé.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.error":
    "Impossible de sauvegarder le canal Slack du support client.",

  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.title":
    "Horaires du support",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.description":
    "Affichez directement un formulaire de contact quand le support en direct est hors horaires.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.timezone":
    "Fuseau horaire",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedCaptureEnabled":
    "Afficher le formulaire hors horaires",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.schedule":
    "Planning hebdomadaire",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.email":
    "Email requis",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.phone":
    "Téléphone requis",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.reason":
    "Motif requis",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.requiredFieldsDescription":
    "Données demandées au client pour le recontacter.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.addInterval":
    "Ajouter une tranche",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.removeInterval":
    "Supprimer",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDay":
    "Fermé",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.title":
    "Jours fériés",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.calendar":
    "Calendrier",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.description":
    "Les jours fériés sont ajoutés comme jours fermés. Vous pouvez les modifier ou les supprimer.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.reset":
    "Réinitialiser les jours fériés",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.addAll":
    "Ajouter tous les jours fériés",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.toast.load.error":
    "Impossible de charger les jours fériés.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.toast.empty":
    "Aucun jour férié prédéfini n'est disponible pour ce calendrier.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.title":
    "Jours fermés",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.description":
    "Le chat en direct reste fermé à ces dates, dans le fuseau horaire du support.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.add":
    "Ajouter un jour fermé",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.remove":
    "Supprimer",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.empty":
    "Aucun jour fermé configuré.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.from": "de",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.to": "à",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.monday":
    "Lundi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.tuesday":
    "Mardi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.wednesday":
    "Mercredi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.thursday":
    "Jeudi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.friday":
    "Vendredi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.saturday":
    "Samedi",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.sunday":
    "Dimanche",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.title":
    "Prise de coordonnées automatique",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.description":
    "Demandez l'email et le téléphone quand le support n'a pas répondu après le délai configuré.",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.timeout":
    "Délai avant le formulaire (minutes)",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.requireEmail":
    "Email requis",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.requirePhone":
    "Téléphone requis",
  "myAccount.page.myAgents.edit.tools.directChatCustomerSupport.name":
    "Support client en direct",
  "myAccount.page.myAgents.edit.tools.directChatCustomerSupport.description":
    "Connectez le client au support de l’entreprise via un chat en direct.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.name":
    "Demande au service client",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.description":
    "Recueillez une demande complète et transmettez-la à votre équipe pour une réponse différée.",
  "myAccount.page.myAgents.edit.tools.structuredForm.title":
    "Formulaire visiteur",
  "myAccount.page.myAgents.edit.tools.structuredForm.description":
    "Adaptez les textes français et anglais, puis choisissez les informations utiles à votre équipe.",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.title": "Titre",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.submit":
    "Bouton d’envoi",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.cancel":
    "Bouton d’annulation",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.success":
    "Message de confirmation",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.description":
    "Introduction",
  "myAccount.page.myAgents.edit.tools.structuredForm.remove": "Supprimer",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.label": "Libellé",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.placeholder":
    "Texte indicatif",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type":
    "Type de champ",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.text": "Texte",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.email":
    "E-mail",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.tel":
    "Téléphone",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.textarea":
    "Texte long",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.select":
    "Liste de choix",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.checkbox":
    "Case à cocher",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.visible": "Visible",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.required":
    "Obligatoire",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.moveUp":
    "Déplacer le champ vers le haut",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.moveDown":
    "Déplacer le champ vers le bas",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.add":
    "Ajouter un champ",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.value":
    "Valeur de l’option",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.label":
    "Libellé de l’option",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.remove":
    "Supprimer l’option",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.add":
    "Ajouter une option",

  "site.global.tabTitle":
    "Chatsystem.ai | L'agent de vente pour votre site e-commerce",
  "site.global.description":
    "Servez vos utilisateurs avec les meilleurs conseils d'IA",

  "pagination.previous": "Précédent",
  "pagination.next": "Suivant",

  "discussion.internal.label": "Test interne",
  "discussion.internal.yes": "Oui",
  "discussion.internal.no": "Non",
  "admin.discussion.origin.label": "Origine",
  "admin.discussion.origin.all": "Toutes les origines",
  "admin.discussion.origin.customer": "Client",
  "admin.discussion.origin.internalTest": "Test interne",
  "admin.discussion.origin.acquisitionDemo": "Démo d’acquisition",
  "admin.discussion.origin.openAcquisition":
    "Ouvrir le tableau de bord d’acquisition",
  "message.origin.audio.label": "Audio",
  "message.origin.audio.tooltip": "Message issu de l'audio",
  "message.author.customerSupportOperator.label": "Support client",
  "admin.page.companies.monthlyReports.title": "Rapports mensuels",
  "admin.page.companies.monthlyReports.description":
    "Générez et consultez les rapports mensuels d'activité destinés au client, agent par agent.",
  "admin.page.companies.monthlyReports.auto.enabled":
    "Rapport mensuel automatique activé",
  "admin.page.companies.monthlyReports.auto.disabled":
    "Rapport mensuel automatique désactivé",
  "admin.page.companies.monthlyReports.manualHint":
    "La génération automatique s'exécute le quatrième jour du mois pour les sociétés qui ont le reporting d'activité activé. Vous pouvez aussi générer le mois précédent manuellement ici.",
  "admin.page.companies.monthlyReports.empty.salesAgents":
    "Aucun agent sales n'est disponible pour le reporting mensuel.",
  "admin.page.companies.monthlyReports.agent.label": "Agent Sales",
  "admin.page.companies.monthlyReports.monthInput.label": "Mois du rapport",
  "admin.page.companies.monthlyReports.generateMonth": "Générer {month}",
  "admin.page.companies.monthlyReports.button.loading": "Génération...",
  "admin.page.companies.monthlyReports.button.default": "Générer le rapport",
  "admin.page.companies.monthlyReports.available": "Rapports disponibles",
  "admin.page.companies.monthlyReports.loading": "Chargement...",
  "admin.page.companies.monthlyReports.count": "{count} rapports",
  "admin.page.companies.monthlyReports.empty.reports":
    "Aucun rapport mensuel n'est disponible pour le moment.",
  "admin.page.companies.monthlyReports.conversations": "{count} conversations",
  "admin.page.companies.monthlyReports.toast.load.error":
    "Impossible de charger les rapports mensuels.",
  "admin.page.companies.monthlyReports.toast.generate.error":
    "Impossible de générer le rapport mensuel.",
  "admin.page.companies.monthlyReports.toast.generate.success":
    "Le rapport mensuel a été généré.",
  "admin.page.companies.monthlyReports.chart.total": "Total",
  "admin.page.companies.monthlyReports.chart.empty":
    "Aucune donnée disponible.",
  "admin.page.companies.monthlyReports.report.toast.company.error":
    "Impossible de charger la société.",
  "admin.page.companies.monthlyReports.report.toast.load.error":
    "Impossible de charger le rapport mensuel.",
  "admin.page.companies.monthlyReports.report.loading":
    "Chargement du rapport mensuel...",
  "admin.page.companies.monthlyReports.report.error":
    "Impossible de charger ce rapport mensuel.",
  "admin.page.companies.monthlyReports.report.eyebrow": "Rapport ChatSystem",
  "admin.page.companies.monthlyReports.report.generatePdf":
    "Générer le rapport en PDF",
  "admin.page.companies.monthlyReports.report.generatePdf.loading":
    "Génération du PDF...",
  "admin.page.companies.monthlyReports.report.regeneratePdf":
    "Régénérer le rapport en PDF",
  "admin.page.companies.monthlyReports.report.downloadPdf":
    "Télécharger le PDF",
  "admin.page.companies.monthlyReports.report.downloadDiscussionExportPdf":
    "Télécharger les discussions en PDF",
  "admin.page.companies.monthlyReports.report.back": "Retour à la société",
  "admin.page.companies.monthlyReports.report.toast.generatePdf.success":
    "PDF généré avec succès.",
  "admin.page.companies.monthlyReports.report.toast.generatePdf.error":
    "Impossible de générer le PDF.",
  "admin.page.companies.monthlyReports.report.metrics.conversations":
    "Conversations",
  "admin.page.companies.monthlyReports.report.metrics.resolved": "Résolues",
  "admin.page.companies.monthlyReports.report.metrics.unresolved":
    "Non résolues",
  "admin.page.companies.monthlyReports.report.executiveSummary":
    "Synthèse du mois",
  "admin.page.companies.monthlyReports.report.chart.intents.title":
    "Intentions de discussion",
  "admin.page.companies.monthlyReports.report.chart.intents.subtitle":
    "Répartition par intention principale",
  "admin.page.companies.monthlyReports.report.chart.intents.total":
    "Conversations",
  "admin.page.companies.monthlyReports.report.chart.strengths.title":
    "Ce qui fonctionne bien",
  "admin.page.companies.monthlyReports.report.chart.strengths.subtitle":
    "Principaux groupes d'intentions résolues",
  "admin.page.companies.monthlyReports.report.chart.strengths.total":
    "Résolues",
  "admin.page.companies.monthlyReports.report.chart.improvements.title":
    "Recommandations d'évolution",
  "admin.page.companies.monthlyReports.report.chart.improvements.subtitle":
    "Principaux groupes d'intentions non résolues",
  "admin.page.companies.monthlyReports.report.chart.improvements.total":
    "Non résolues",
  "admin.page.companies.monthlyReports.report.highlights.title":
    "Exemples de conversations",
  "admin.page.companies.monthlyReports.report.highlights.subtitle":
    "Une sélection de conversations représentatives du mois.",
  "admin.page.companies.monthlyReports.report.highlights.empty":
    "Aucun exemple de conversation n'a été sélectionné pour ce mois.",
  "admin.page.companies.monthlyReports.report.highlights.rank":
    "Exemple #{rank}",
  "admin.page.companies.monthlyReports.report.strengths.title":
    "Ce qui fonctionne bien",
  "admin.page.companies.monthlyReports.report.strengths.empty":
    "Aucun insight positif n'est disponible pour ce mois.",
  "admin.page.companies.monthlyReports.report.improvements.title":
    "Recommandations d'évolution",
  "admin.page.companies.monthlyReports.report.improvements.empty":
    "Aucune recommandation d'évolution n'est disponible pour ce mois.",
  "admin.page.companies.monthlyReports.report.highlightReason.productClick":
    "Résolue avec clic produit",
  "admin.page.companies.monthlyReports.report.highlightReason.shopInfo":
    "Utilise une information boutique",
  "admin.page.companies.monthlyReports.report.highlightReason.criteria":
    "Conseil par critères",
  "admin.page.companies.monthlyReports.report.highlightReason.similar":
    "Exemple de produit similaire",
  "admin.page.companies.monthlyReports.report.highlightReason.exact":
    "Recherche produit précise",
  "admin.page.companies.monthlyReports.report.highlightReason.representative":
    "Discussion représentative",

  "textarea.placeholder.nonBoolean.semanticDescription":
    "Ex: La taille des chaussures",
  "textarea.placeholder.boolean.semanticDescription":
    "Ex: Ce plat est-il sans gluten ?",
  "textarea.errorMessage.minLength0":
    "Cette phrase est très importante pour aider le robot à analyser ce que lui demande lui client.",
  "textarea.errorMessage.shouldEndWithQuestionMark":
    "En cas de colonne vrai/faux, votre description doit être une question. Exemple : Ce plat est-il végétarien ? La phrase doit finir par un point d'interrogation.",
  "input.placeholder.columnName": "Ex: Type de jeux de société",
  "input.errorMessage.minLength0":
    "Ce champs est obligatoire pour que le robot comprenne de quoi cette donnée traite. Donnez un nom simple qu'un ami comprendrait.",

  "page.login.button.login": "Se connecter / S'inscrire",
  "page.login.personalizedDemo.title":
    "Connectez-vous pour créer votre démo gratuite",
  "page.login.personalizedDemo.description":
    "Vous retrouverez ensuite directement le site renseigné pour préparer votre Agent personnalisé.",
  "page.login.google.login": "Continuer avec Google",
  "page.login.localDevelopment.title": "Développement local",
  "page.login.localAdmin.login": "Se connecter en administrateur",
  "page.login.localOnboarding.login": "Tester un nouvel espace client",

  "navbar.button.home": "Accueil",
  "navbar.button.pricing": "Tarifs",
  "navbar.button.login": "Se Connecter",
  "navbar.button.demo": "Tester",
  "navbar.userMenu.logout": "Déconnection",
  "navbar.userMenu.profile": "Profil",
  "navbar.userMenu.admin": "Admin",
  "navbar.userMenu.backOffice": "Back-office",

  "home.header.catchphase": "Enfin un chatbot intelligent",
  "home.header.subcatchphase":
    "Découvrez le chatbot qui connait vos produits sur le bout des doigts",
  "home.header.CTA": "Voir notre solution",

  "home.sloganHeader.slogan": "L'assistant IA qui conseille le bon produit",
  "home.sloganHeader.slogan.otherTry":
    "Chaque visiteur mérite la bonne recommandation.",
  "home.sloganHeader.slogan.sub":
    "Oubliez les chatbot génériques : il pose les bonnes questions et recommande le bon produit — en stock — 24/7.",
  "home.sloganHeader.slogan.sub.otherTry":
    "Guidez vos visiteurs vers le bon produit grâce à un assistant IA qui connaît parfaitement votre catalogue",
  "home.sloganHeader.slogan.cta": "Voir la démo",
  "home.sloganHeader.slogan.tryTool": "Tester l'outil",
  "home.sloganHeader.slogan.contactUs": "Nous contacter",
  "home.sloganHeader.badge.title": "Agent IA",
  "home.sloganHeader.badge.text": "Spécialisé e-commerce",

  "home.section.bulletsPointSection.title": "Pourquoi nous choisir",

  "home.section.bulletsPointParagraphe1.title": "Pertinent",
  "home.section.bulletsPointParagraphe1.b.title":
    "Applique votre stratégie de vente",
  "home.section.bulletsPointParagraphe1.b.text":
    "Il s'exprime avec le ton de votre marque, respecte vos règles métier et respecte vos méthodes de vente.",
  "home.section.bulletsPointParagraphe1.text":
    "Fait les meilleures recommandations de produits basé sur votre stock et la demande du client",

  "home.section.bulletsPointParagraphe2.title": "A l'écoute",
  "home.section.bulletsPointParagraphe2.text":
    "Comprend réellement vos clients et leur intention d'achat avant de leur répondre",
  "home.section.bulletsPointParagraphe2.b.title":
    "Comprend vraiment vos produits",
  "home.section.bulletsPointParagraphe2.b.text":
    "Comprend les spécifications, les contraintes, la compatibilité et les compromis produits.",

  "home.section.bulletsPointParagraphe3.title": "Flexible",
  "home.section.bulletsPointParagraphe3.text":
    "S'ajuste aux demandes des clients pour apporter une réponse toujours adaptée",
  "home.section.bulletsPointParagraphe3.b.title":
    "Des recommandations basées sur des stocks réels",
  "home.section.bulletsPointParagraphe3.b.text":
    "Des recommandations basées sur des stocks réels et une logique commerciale éprouvée.",

  "home.section.video.showcase.title": "Une démo rapide, concrète, sans blabla",
  "home.section.video.showcase.title.subtitle":
    "Regardez l’agent en action : réponses précises, ton maîtrisé, et un parcours client plus fluide.",
  "home.section.video.showcase.tip.title": "Point fort : ",
  "home.section.video.showcase.tip.text":
    "Le chatbot s'adapte au discours du client et adopte les méthodes de vente de l'entreprise.",

  "home.realm.title": "La nouvelle génération d'intelligence artificielle",
  "home.realm.text":
    "L’IA de nouvelle génération transforme l’assistance en ligne : on passe d’un simple chatbot à un vrai conseiller de vente. Notre agent accompagne le client de l’intention à l’achat, avec des recommandations fiables et actionnables, basées sur vos données réelles.",
  "home.realm.cta": "Testez notre solution",
  "home.realm.secondary.title": "Aidez vos clients en permanence",
  "home.realm.secondary.text":
    "7 jours sur 7, 24 heures sur 24, le chatbot donne des conseils de qualité à tous vos clients. C'est un excellent soutien aux vendeurs.",
  "home.realm.secondary.cta": "Découvrez notre solution",

  "home.realm.b1":
    "Disponible 24/7 : chaque visiteur obtient des réponses instantanées.",
  "home.realm.b2":
    "Du débutant à l’expert : adapte automatiquement la profondeur des conseils.",
  "home.realm.b3":
    "Recommandations fiables : uniquement ce que vous pouvez réellement proposer (stock, variantes, contraintes).",
  "home.realm.b4":
    "Transforme « Je ne sais pas trop ce qu’il me faut » en une recommandation claire et assumée, avec des compromis expliqués.",
  "home.realm.b5":
    "Améliore la conversion en levant les doutes juste avant le paiement.",

  "home.stats.eyebrow": "CONÇU POUR LES ÉQUIPES E-COMMERCE",
  "home.stats.title": "ChatSystem en chiffres",
  "home.stats.subtitle":
    "Des résultats mesurables sur l’accompagnement client et la conversion, là où ça compte : sur vos pages produits.",
  "home.stats.performance.title": "Performance",
  "home.stats.performance.title.md": "Performance",
  "home.stats.keyNumbers.title.md": "Chiffres clés",
  "home.stats.s1": "revenu incrémental",
  "home.stats.s2": "conversion sur discussions assistées par l’IA",
  "home.stats.s3": "conseil produit automatisé sur votre site",
  "home.stats.s4": "disponible 24/7 pour vos clients",
  "home.stats.footnote":
    "Chiffres indicatifs basés sur des déploiements et des tests pilotes. Les résultats varient selon le catalogue et le trafic.",

  "home.testimonials.title": "Nos clients parlent de nous",
  "home.testimonials.1.text":
    "Depuis notre utilisation du logiciel, nous avons un meilleur contrôle du flux de marchandises et un suivi de performance pertinent.",
  "home.testimonials.1.job": "Developpeur @Wordpress",
  "home.testimonials.1.name": "Loic Martins",
  "home.testimonials.2.text":
    "La mise en production de la solution logicielle nous a permis de réorganiser complètement les équipes.",
  "home.testimonials.2.job": "Community Manager @Comet",
  "home.testimonials.2.name": "Anna Wang",
  "home.testimonials.3.text":
    "La maitrise du sujet logistique est une évidence avec la solution logicielle.",
  "home.testimonials.3.job": "Product Owner @April",
  "home.testimonials.3.name": "Louis Bachant",
  "home.test.section.title": "Testez dès maintenant",
  "home.book.section.title": "Testez notre solution",
  "home.test.section.CTA": "Voir notre solution",

  "home.section.faq.title": "Questions fréquentes",

  "home.section.faq.howIsThisDifferentFromOtherChatbots.title":
    "En quoi est-ce différent des autres chatbots ?",
  "home.section.faq.howIsThisDifferentFromOtherChatbots.answer":
    "Ce n’est pas simplement un chatbot générique branché sur une API. ChatSystem sait comment vous vendez et suit votre playbook commercial. Il intègre réellement votre expertise dans le parcours client.",

  "home.section.faq.canItDoSomethingElse.title":
    "Peut-il faire d’autres choses ?",
  "home.section.faq.canItDoSomethingElse.answer":
    "Nous pouvons ajouter des fonctionnalités personnalisées au chatbot selon vos besoins. Les agents et l’IA peuvent faire beaucoup de choses — contactez-nous.",

  "home.section.faq.isItGDPRCompatible.title": "Est-il conforme au RGPD ?",
  "home.section.faq.isItGDPRCompatible.answer":
    "Oui, nous sommes entièrement conformes au RGPD.",

  "home.section.faq.doesItSpeakSeveralLanguages.title":
    "Parle-t-il plusieurs langues ?",
  "home.section.faq.doesItSpeakSeveralLanguages.answer":
    "Le chatbot parle de nombreuses langues, dont l’anglais, l’espagnol, le français et bien d’autres.",

  "home.section.faq.doesItWorkOnAnyProducts.title":
    "Fonctionne-t-il sur n’importe quel produit ?",
  "home.section.faq.doesItWorkOnAnyProducts.answer":
    "Oui, il fonctionne avec n’importe quel produit. C’est une question de configuration entre votre entreprise et la nôtre, notamment autour de votre expertise.",

  "home.section.faq.isItEasyToImplement.title": "Est-ce facile à implémenter ?",
  "home.section.faq.isItEasyToImplement.answer":
    "Oui. Pour une intégration complète, comptez autour de deux semaines.",

  "home.section.faq.canItBeCustomed.title":
    "L’apparence peut-elle être personnalisée ?",
  "home.section.faq.canItBeCustomed.answer":
    "Oui, entièrement. Vous pouvez adapter le design à votre marque, y compris vos visuels et le style.",

  "article.doesntExist":
    "Cet article n'existe pas. Merci de revenir à la page d'accueil.",

  "pricing.CTA.pleaseLogin": "Connectez-vous",
  "pricing.page.eyebrow": "Tarifs ChatSystem",
  "pricing.page.title": "Une formule claire pour chaque étape",
  "pricing.page.plan.highlight": "Recommandée",
  "pricing.page.subtitle":
    "Donnez à vos Agents les capacités d’action de votre choix parmi le catalogue d’actions proposé par ChatSystem pour accompagner vos clients, générer des leads et relayer les demandes vers votre support.",
  "pricing.demo.badge": "Démo personnalisée gratuite",
  "pricing.demo.title":
    "Découvrez ce que ChatSystem peut apporter à votre site",
  "pricing.demo.description":
    "Indiquez votre site. ChatSystem prépare un Agent personnalisé que vous pourrez tester et partager à vos équipes avant de choisir votre formule de mise en production.",
  "pricing.demo.feature.website": "Un Agent préparé à partir de votre site",
  "pricing.demo.feature.test": "Un vrai chatbot à tester",
  "pricing.demo.feature.share": "Un lien prêt à partager à vos équipes",
  "pricing.plans.eyebrow": "Formules de mise en production",
  "pricing.plans.title": "Choisissez la formule adaptée à votre trafic",
  "pricing.plans.introduction":
    "Essayez votre démo personnalisée gratuitement, puis choisissez votre formule quand vous êtes prêt.",
  "pricing.demo.card.title": "Démo personnalisée",
  "pricing.demo.card.free": "Gratuite",
  "pricing.demo.card.noCard": "Aucune carte bancaire requise",
  "pricing.demo.card.description":
    "Testez un Agent préparé à partir de votre site et partagez-le avec votre équipe avant de vous lancer.",
  "pricing.demo.card.boundary":
    "Un aperçu privé à valider et à partager. Pour l’installer sur votre site, choisissez ensuite une formule payante.",
  "pricing.plans.description":
    "Mettez votre Agent en ligne, connectez ses Tools et augmentez sa capacité à mesure que vos besoins évoluent.",
  "pricing.page.toggle.yearly": "Annuel",
  "pricing.page.toggle.monthly": "Mensuel",
  "pricing.page.toggle.saveUpTo": "Jusqu’à {percent}% d’économie",
  "pricing.page.toggle.yearlyHelp":
    "Un paiement annuel, avec votre capacité d’utilisation renouvelée chaque mois.",
  "pricing.page.toggle.monthlyHelp":
    "Une facturation mensuelle flexible, sans engagement annuel.",
  "pricing.page.family.perMonth": "/ mois",
  "pricing.page.family.billedYearly": "Facturé annuellement",
  "pricing.page.family.billedMonthly": "Sans engagement",
  "pricing.page.family.monthlyRenewalInfo":
    "Renouvellement automatique chaque mois. Résiliable à tout moment, avec effet à la fin de la période payée.",
  "pricing.page.family.onlyInterval":
    "Disponible uniquement avec une facturation {interval}",
  "pricing.page.family.aiResponsesMonthly": "réponses IA maximum par mois",
  "pricing.page.family.aiResponsesHelp":
    "Estimation basée sur des réponses IA standard. Le nombre réel varie selon les Tools utilisés par l’Agent.",
  "pricing.page.family.agents":
    "{count, plural, one {# Agent} other {# Agents}}",
  "pricing.page.family.agents.unlimited": "Agents illimités",
  "pricing.page.family.domains":
    "{count, plural, one {# nom de domaine} other {# noms de domaine}}",
  "pricing.page.family.domains.unlimited": "Nombre de domaines illimité",
  "pricing.page.family.members":
    "{count, plural, one {# membre} other {# membres}} dans l’entreprise",
  "pricing.page.family.members.unlimited": "Membres illimités",
  "pricing.page.family.allTools": "Tous les Tools ChatSystem",
  "pricing.page.family.whiteLabel": "Sans la mention « Powered by ChatSystem »",
  "pricing.page.family.directSupport": "Support dédié par email",
  "pricing.page.family.aiResponsesPeriod":
    "réponses IA maximum par période de facturation",
  "pricing.page.family.flexibleCreditMonthly":
    "de crédit d’usage flexible renouvelé chaque mois",
  "pricing.page.family.flexibleCreditPeriod":
    "de crédit d’usage flexible par période de facturation",
  "pricing.page.family.sharedTools":
    "Les réponses IA et les outils de recherche activés partagent ce crédit",
  "pricing.page.family.topUp": "Recharges ponctuelles pour prolonger l’usage",
  "pricing.page.family.topUp.promotional":
    "Recharges ponctuelles avec bonus d’usage",
  "pricing.page.interval.month": "mois",
  "pricing.page.interval.year": "an",
  "pricing.page.usageOnly": "Payez selon votre usage",
  "pricing.page.taxIncluded": "Prix TTC",
  "pricing.page.metered.block": "pour {count} {metric}",
  "pricing.page.funding.postpaid": "Plafond d’usage mensuel : {amount}",
  "pricing.page.funding.uncapped": "Usage facturé après consommation",
  "pricing.page.funding.periodic":
    "{amount} de crédit d’usage renouvelé {cadence}",
  "pricing.page.funding.cadence.monthly": "chaque mois",
  "pricing.page.funding.cadence.period": "à chaque période de facturation",
  "pricing.page.aiResponses.maximum": "Jusqu’à {count} réponses IA par mois",
  "pricing.page.funding.rolling":
    "{amount} de crédit d’usage inclus et reportable",
  "pricing.page.funding.rechargePack": "{price}",
  "pricing.page.funding.rechargePack.promotion":
    "{price} payés → {credit} de crédit d’usage",
  "pricing.page.funding.rechargePacks":
    "Recharges ponctuelles facultatives : {packs}",
  "pricing.page.chooseOffer": "Choisir cette formule",
  "pricing.page.checkout.opening": "Ouverture du paiement sécurisé…",
  "pricing.page.checkout.error":
    "Le paiement sécurisé n’a pas pu être ouvert. Réessayez ou contactez le support.",
  "billing.portal.offer.selectedFromPricing":
    "Sélectionnée depuis la page des tarifs",
  "admin.publicOfferCatalog.load.error":
    "Le catalogue tarifaire public n’a pas pu être chargé. Actualisez la page avant de modifier sa présentation.",
  "admin.subscriptionOffer.retire.confirm":
    "Ne plus proposer cette version aux nouveaux clients ? Les abonnements existants et leurs conditions resteront inchangés.",
  "admin.subscriptionOffer.retire.error":
    "La formule n’a pas pu être retirée. Actualisez la page et réessayez.",
  "admin.subscriptionOffer.retire.success":
    "La formule n’est plus proposée aux nouveaux clients. Les abonnements existants restent inchangés.",
  "admin.subscriptionOffer.retire.pending": "Retrait…",
  "admin.subscriptionOffer.retire.action": "Ne plus proposer",
  "pricing.page.custom.description":
    "Nous pouvons créer pour vos Agents des capacités sur mesure, parfaitement adaptées aux besoins de votre entreprise. Les possibilités sont vastes : contactez-nous pour concevoir ensemble votre solution et recevoir un devis personnalisé.",
  "pricing.page.custom.agents": "Un nombre d’Agents adapté à vos besoins",
  "pricing.page.custom.billing": "Facturation flexible",
  "pricing.page.custom.volume": "Volumes et limites d’usage dédiés",
  "pricing.page.custom.integrations": "Création de Tools sur mesure",
  "pricing.page.custom.support":
    "Contrat et accompagnement adaptés à votre équipe",
  "pricing.page.unavailable.title":
    "Nos formules sont temporairement indisponibles",
  "pricing.page.unavailable.description":
    "Réessayez dans quelques instants ou contactez-nous.",
  "pricing.page.buttonText.buy": "Acheter",
  "pricing.page.buttonText.YouAlreadyHaveIt": "Votre formule actuelle",
  "pricing.page.formula.feature.alreadySubbed": "Vous êtes déjà abonné !",
  "pricing.page.formulaName.fixedIncreasable": "Fixe renouvelable",
  "pricing.page.formulaName.fixedPlusDynamic": "Fixe + Variable",
  "pricing.page.formulaName.fullDynamic": "Complètement variable",
  "pricing.page.formulaName.fullFixed": "Fixe cappé",
  "pricing.page.formulaName.custom": "Sur mesure",
  "pricing.enterprise.audience": "Grands comptes",
  "pricing.enterprise.description":
    "Une offre pensée pour les grands comptes : plusieurs marques, plusieurs équipes, des besoins métier spécifiques. Construisons ensemble des Agents à la hauteur de vos enjeux.",
  "pricing.enterprise.quote": "Devis personnalisé",
  "pricing.enterprise.contact": "Parlons de votre projet",
  "pricing.enterprise.scope": "Une offre à construire autour de vos besoins",
  "pricing.enterprise.agents.title": "Nombre d’Agents illimité",
  "pricing.enterprise.agents.description":
    "Autant d’Agents que nécessaire pour vos marques, vos sites et vos équipes, dans votre offre sur mesure.",
  "pricing.enterprise.behavior.title": "Comportement co-construit",
  "pricing.enterprise.behavior.description":
    "Ton, réponses, actions et relais vers vos équipes : nous concevons avec vous le comportement de vos chatbots autour de vos besoins métier.",
  "pricing.enterprise.responses.title": "Réponses IA illimitées",
  "pricing.enterprise.responses.description":
    "Une offre sans plafond de réponses, sur devis et pour les usages convenus ensemble.",
  "pricing.enterprise.analytics.title": "Analytics avancés sur mesure",
  "pricing.enterprise.analytics.description":
    "Conversions, résolution des demandes, satisfaction : des tableaux de bord à développer autour de vos indicateurs.",
  "pricing.enterprise.integrations.title": "Intégrations métier",
  "pricing.enterprise.integrations.description":
    "CRM, catalogue, support : des connexions et des actions sur mesure à concevoir avec vos équipes.",
  "pricing.enterprise.partnership.title": "Accompagnement dédié",
  "pricing.enterprise.partnership.description":
    "Déploiement, suivi des résultats et support prioritaire, avec des engagements de service définis ensemble.",
  "pricing.page.buttonText.contactUs": "Contactez-nous",
  "pricing.page.formula.feature.botAccess": "Accès Chatbot",
  "pricing.page.formula.feature.limitedAccess": "Accès limité",
  "pricing.page.formula.feature.unlimitedAccess": "Accès illimité",
  "pricing.page.formula.feature.userFollowUp":
    "Suivi des discussions utilisateurs",
  "pricing.page.formula.feature.useAtscale": "Utilisation à grande échelle",
  "pricing.page.formula.feature.customMadeDev":
    "Développement sur mesure pour votre besoin",
  "pricing.page.formula.feature.smallBudget": "Petit budget",

  "subscribe.paymentRecap.title": "Récapitulatif de paiement",
  "subscribe.paymentRecap.customerName": "Nom",
  "subscribe.paymentRecap.customerMail": "Email",
  "subscribe.paymentRecap.additionnalMention": "Mention à ajouter",
  "subscribe.paymentRecap.totalAmount": "Total",
  "subscribe.paymentForm.title": "Carte bancaire",
  "subscribe.paymentForm.cardNumber": "Numéro de carte",
  "subscribe.paymentForm.expiresAt": "Expire le",
  "subscribe.paymentForm.CVCNumber": "Numéro CVV",
  "subscribe.paymentForm.CTA.loading": "Chargement ...",
  "subscribe.paymentForm.CTA.pay": "S'abonner",

  "subscribe.success.title": "Paiement effectué avec succès",
  "subscribe.success.paragraph1":
    "Votre paiement a bien été accepté. Vous êtes désormais abonné !",
  "subscribe.success.paragraph2":
    "Toutes vos options sont maintenant disponibles.",

  "myAccount.page.leftMenu.general": "Général",
  "myAccount.page.leftMenu.profile": "Ma société",
  "myAccount.page.leftMenu.dashboard": "Tableau de bord",
  "myAccount.page.leftMenu.setup": "Installation",
  "myAccount.page.leftMenu.upload": "Uploader Produits",
  "myAccount.page.leftMenu.myCatalogs": "Mes Catalogues",
  "myAccount.page.leftMenu.productCollections": "Collections de produits",
  "myAccount.page.leftMenu.myAgents": "Mes Agents",
  "myAccount.page.myAgents.toast.slackCustomerSupport.connected":
    "L’espace Slack a bien été connecté. Vérifiez que le canal souhaité est sauvegardé pour votre outil.",
  "myAccount.page.leftMenu.myTools": "Outils Agents",
  "myAccount.page.leftMenu.myDNS": "Mes noms de domaine autorisés",
  "myAccount.page.leftMenu.sessions": "Discussions utilisateurs",
  "myAccount.page.leftMenu.testMyChatbot": "Tester mon Chatbot",
  "myAccount.page.leftMenu.settings": "Paramètres",
  "myAccount.auth.error.title": "Impossible d’ouvrir votre espace",
  "myAccount.auth.error.description":
    "Un problème temporaire nous empêche de charger votre compte. Réessayez dans quelques instants.",
  "myAccount.auth.error.retry": "Réessayer",
  "myAccount.auth.error.retrying": "Nouvelle tentative…",
  "myAccount.auth.error.reconnect": "Se connecter à nouveau",
  "myAccount.page.leftMenu.trackingSpace": "Performance",
  "myAccount.page.myAgentDisplays.customCss.warn":
    "Votre CSS personnalisé contient des avertissements. Il sera enregistré, mais certaines règles peuvent être ignorées.",
  "myAccount.page.myAgentDisplays.customCss.warnings.title":
    "Détecté {count, plural, one {# avertissement} other {# avertissements}} dans votre CSS :",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR":
    "Stats Produits Total",
  "myAccount.page.leftMenu.trackingSpace.dailyKPI": "Indicateurs par jour",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity":
    "Détails Discussions",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP":
    "Discussions par IP",
  "myAccount.page.leftMenu.trackingSpace.monthlyPerformance":
    "Activité du mois",
  "myAccount.page.leftMenu.trackingSpace.monthlyReports": "Rapports mensuels",
  "myAccount.page.monthlyReports.back": "Retour aux rapports mensuels",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR":
    "Stats Produits mensuelles",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostClicked":
    "Produits les plus cliqués (de tous temps)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostViewed":
    "Produits les plus vus (de tous temps)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostCTR":
    "Produits les plus cliqués par vue (de tous temps)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.url": "Url Produit",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.impressions":
    "Impressions",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.CTR": "CTR",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.none":
    "Pas encore de statistiques disponibles.",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.url": "Url Produit",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.impressions":
    "Impressions",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.CTR": "CTR",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.none":
    "Pas encore de statistiques disponibles.",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.clicked.table.title":
    "Produits les plus cliqués (score par mois)",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.viewed.table.title":
    "Produits les plus vus (score par mois)",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.ctr.table.title":
    "Produits les cliqués par vues (score par mois)",
  "myAccount.page.leftMenu.trackingSpace.generic.ctr": "CTR",
  "myAccount.page.leftMenu.trackingSpace.generic.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.generic.impressions": "Impressions",
  "myAccount.page.leftMenu.trackingSpace.generic.discussions": "Discussions",
  "myAccount.page.leftMenu.trackingSpace.generic.month": "Mois",
  "myAccount.page.leftMenu.trackingSpace.generic.day": "Jour",
  "myAccount.page.leftMenu.trackingSpace.dailyKPI.title":
    "Indicateurs par jour",
  "myAccount.page.dailyKPI.chart.title": "Performance quotidienne",
  "myAccount.page.dailyKPI.chart.subtitle":
    "Discussions, clics, impressions et CTR",
  "myAccount.page.dailyKPI.chart.empty":
    "Aucune donnée d'indicateurs quotidiens pour le moment.",
  "myAccount.page.monthlyPerformance.chart.title": "Performance mensuelle",
  "myAccount.page.monthlyPerformance.chart.subtitle":
    "Discussions, clics, impressions et CTR",
  "myAccount.page.monthlyPerformance.chart.empty":
    "Aucune donnée de performance mensuelle pour le moment.",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.title":
    "Discussions Groupées par IP",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.ip":
    "IP Client (hashée)",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.firstSeen":
    "Date Première Conversation",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.lastSeen":
    "Date Dernière conversation",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.title":
    "Activités Discussions",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.startingTime":
    "Date de départ",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.endTime":
    "Date de fin",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.type": "Type",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.ipCustomerRaw":
    "IP Client",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.ipCustomerHashed":
    "IP Client (encryptée)",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.discussionId":
    "ID Discussion",
  "myAccount.page.leftMenu.devSpace": "Espace Developpeur",
  "myAccount.page.leftMenu.clientScript": "Client SDK",
  "myAccount.page.leftMenu.apiAccessToken": "Accès API",
  "myAccount.page.leftMenu.documentation": "Documentation",

  "myAccount.page.dashboard.eyebrow": "Votre activité",
  "myAccount.page.dashboard.title": "Tableau de bord - {companyName}",
  "myAccount.page.dashboard.companyFallback": "votre société",
  "myAccount.page.dashboard.subtitle":
    "Suivez vos discussions mensuelles, l'engagement, l'usage consommé et la capacité disponible en un seul endroit.",
  "myAccount.page.dashboard.usageCapacityUsedBadge":
    "{percent}% de la capacité d’usage occupée",
  "myAccount.page.dashboard.usageBilledAfterConsumption":
    "Usage facturé après consommation",
  "myAccount.page.dashboard.error":
    "Nous n'avons pas pu charger vos données. Merci de réessayer plus tard.",
  "myAccount.page.dashboard.currentMonth": "Mois en cours",
  "myAccount.page.dashboard.lastMonth": "Mois dernier",
  "myAccount.page.dashboard.monthOverMonth": "Mois sur mois",
  "myAccount.page.dashboard.discussionsInMonth": "Discussions en {month}",
  "myAccount.page.dashboard.noPriorData": "Aucune donnée précédente",
  "myAccount.page.dashboard.vsLastMonth": "{value}% vs mois dernier",
  "myAccount.page.dashboard.discussionsComparison.title":
    "Discussions : mois en cours vs mois dernier",
  "myAccount.page.dashboard.discussionsComparison.subtitle":
    "Comparaison mensuelle basée sur l'activité de l'abonnement",
  "myAccount.page.dashboard.discussionsEmpty":
    "Aucune donnée de discussion disponible pour le moment.",
  "myAccount.page.dashboard.usageCredit.title": "Crédit d’usage",
  "myAccount.page.dashboard.usageLimit.title": "Limite mensuelle d’usage",
  "myAccount.page.dashboard.usageCapacity.subtitle":
    "Consommé, en cours et disponible sur la période de facturation actuelle",
  "myAccount.page.dashboard.usageCapacity.consumed": "Consommé",
  "myAccount.page.dashboard.usageCapacity.reserved": "En cours",
  "myAccount.page.dashboard.usageCapacity.remaining": "Disponible",
  "myAccount.page.dashboard.usageCapacity.total": "Capacité totale",
  "myAccount.page.dashboard.usageCapacity.empty":
    "Aucun usage n’a encore été enregistré.",
  "myAccount.page.dashboard.unboundedUsage":
    "Votre offre n’a pas de limite monétaire d’usage fixe. Chaque usage tarifé est enregistré puis facturé après consommation.",
  "myAccount.page.dashboard.usageUnavailable":
    "Le détail de votre usage apparaîtra ici lorsqu’un abonnement mesuré actif sera disponible.",
  "myAccount.page.dashboard.legacyMeteredUsage":
    "Cette offre historique mesure directement les usages et n’utilise pas de capacité monétaire partagée.",
  "myAccount.page.dashboard.currentUsage":
    "Usage consommé sur cette période de facturation",
  "myAccount.page.dashboard.currentUsage.subtitle":
    "Valeur des usages tarifés terminés uniquement. Elle n’inclut ni le prix de votre abonnement ni votre crédit d’usage disponible.",
  "myAccount.page.dashboard.currentUsage.reserved": "Usage en cours : {amount}",
  "myAccount.page.dashboard.performance.title": "Performance mois par mois",
  "myAccount.page.dashboard.performance.subtitle":
    "Discussions, impressions, clics et CTR sur les six derniers mois",
  "myAccount.page.dashboard.performanceEmpty":
    "Aucune donnée de performance mensuelle disponible pour le moment.",
  "myAccount.page.myTools.subtitle":
    "Tous les outils actuellement disponibles pour votre société.",
  "myAccount.page.myTools.readonlyHint":
    "Pour activer des outils, ouvrez un agent et configurez-les dans les paramètres de l'agent.",
  "myAccount.page.myTools.create.cta": "Créer un outil propre à ma société",
  "myAccount.page.myTools.create.title": "Créer un outil propre à ma société",
  "myAccount.page.myTools.create.description":
    "Créez une capacité que vos agents pourront utiliser automatiquement lorsqu’une conversation le nécessite. L’outil appelle un endpoint de votre société pour consulter des données ou exécuter une opération métier, avec une vérification d’identité lorsque l’accès doit être limité au client connecté.",
  "myAccount.page.myTools.empty": "Aucun outil disponible pour votre société.",
  "myAccount.page.myTools.status.enabled": "Activé",
  "myAccount.page.myTools.status.disabled": "Désactivé",
  "myAccount.page.myTools.noDescription": "Aucune description disponible.",
  "myAccount.page.myTools.card.activationLabel": "Activation",
  "myAccount.page.myTools.card.toggleAria": "Basculer l'activation de l'outil",
  "myAccount.page.myTools.toast.loadTools.error":
    "Impossible de charger les outils disponibles.",
  "myAccount.page.myTools.toast.loadActivations.error":
    "Impossible de charger les activations.",
  "myAccount.page.myTools.toast.toggle.error":
    "Impossible de mettre à jour l'activation de l'outil.",
  "toolForm.toast.loadResolvers.error": "Impossible de charger les resolveurs.",
  "toolForm.toast.nameDisplay.required":
    "Le nom et le nom d'affichage sont requis.",
  "toolForm.toast.function.required":
    "Le nom de fonction et la description de fonction sont requis.",
  "toolForm.toast.httpConfig.invalid": "httpConfig doit être un JSON valide.",
  "toolForm.toast.parameterSchema.invalid":
    "Le schéma des paramètres est invalide.",
  "toolForm.toast.save.error": "Impossible d'enregistrer l'outil.",
  "toolForm.validation.duplicateParameter":
    "Nom de paramètre en double : {name}",
  "toolForm.validation.emptyEnumValues":
    "Le paramètre {name} a des valeurs d'enum vides.",
  "toolForm.validation.resolverRequired":
    "Le paramètre {name} nécessite un resolveur.",
  "toolForm.validation.unsupportedParameterType":
    "Type de paramètre non pris en charge pour {name}",
  "toolForm.toast.assetUpload.afterCreate":
    "L'upload d'asset est disponible après la création de l'outil.",
  "toolForm.toast.assetUpload.error": "Impossible d'uploader l'asset.",
  "toolForm.toast.assetUpload.success": "Asset uploadé.",
  "toolForm.readOnly.codeTool":
    "Cet outil est un outil code. Il peut être consulté ici mais doit être modifié dans le code.",
  "toolForm.name": "Nom",
  "toolForm.displayName": "Nom d'affichage",
  "toolForm.shortDescription": "Description courte",
  "toolForm.asset": "Asset",
  "toolForm.asset.uploadTitle": "Uploader un fichier",
  "toolForm.asset.or": "ou",
  "toolForm.asset.publicUrlTitle": "Utiliser une URL publique",
  "toolForm.asset.publicUrlHint":
    "Collez l'URL directe d'une image deja hebergee publiquement.",
  "toolForm.logoUrl": "Logo (URL)",
  "toolForm.uploadAsset": "Uploader un asset sur S3",
  "toolForm.uploadAsset.editHint":
    "L'URL du fichier uploadé sera automatiquement renseignée dans le logo.",
  "toolForm.uploadAsset.createHint":
    "Créez d'abord l'outil pour pouvoir uploader des assets.",
  "toolForm.preview": "Aperçu",
  "toolForm.preview.logoAlt": "Aperçu du logo de l'outil",
  "toolForm.preview.empty": "Aucun aperçu",
  "toolForm.functionName": "Nom de fonction",
  "toolForm.functionName.help":
    "Utilisez un nom explicite. Le modèle s'appuie fortement sur ce nom pour décider quand appeler l'outil.",
  "toolForm.functionDescription": "Description de fonction",
  "toolForm.functionDescription.help":
    "Obligatoire. Soyez concis mais précis pour que l'agent puisse choisir cet outil au bon moment.",
  "toolForm.execution": "Exécution",
  "toolForm.execution.server": "server",
  "toolForm.executorType": "Type d'exécuteur",
  "toolForm.executorType.http": "http",
  "toolForm.executorType.code": "code",
  "toolForm.executorType.composite": "composite",
  "toolForm.handlerId": "Handler Id (outils code)",
  "toolForm.active": "Actif",
  "toolForm.public": "Public",
  "toolForm.public.companyOwnedHint":
    "La visibilité publique est désactivée pour les outils propres à la société.",
  "toolForm.tabs.general": "Général",
  "toolForm.tabs.asset": "Asset",
  "toolForm.tabs.execution": "Exécution",
  "toolForm.tabs.parameters": "Paramètres",
  "toolForm.parameters": "Paramètres",
  "toolForm.parameters.add": "Ajouter un paramètre",
  "toolForm.parameters.help":
    "Définissez les paramètres LLM de cet outil. Pour les paramètres string, les enums peuvent être statiques ou pilotés par un resolveur.",
  "toolForm.parameters.name.placeholder": "nom du paramètre",
  "toolForm.parameters.required": "Requis",
  "toolForm.parameters.remove": "Supprimer",
  "toolForm.parameters.description.placeholder":
    "Description (concise et précise)",
  "toolForm.parameters.enum.none": "Aucune restriction d'enum",
  "toolForm.parameters.enum.static": "Valeurs d'enum statiques",
  "toolForm.parameters.enum.resolver": "Enum dynamique depuis un resolveur",
  "toolForm.parameters.enum.static.placeholder": "value1, value2, value3",
  "toolForm.parameters.resolver.select": "Sélectionner un resolveur",
  "toolForm.parameters.arrayItemType": "Type des éléments du tableau",
  "toolForm.parameterType.http": "http",
  "toolForm.parameterType.string": "string",
  "toolForm.parameterType.number": "number",
  "toolForm.parameterType.integer": "integer",
  "toolForm.parameterType.boolean": "boolean",
  "toolForm.parameterType.array": "array",
  "toolForm.httpConfig": "Configuration HTTP (JSON)",
  "toolForm.save.saving": "Enregistrement...",
  "toolForm.save.create": "Créer l'outil",
  "toolForm.save.update": "Enregistrer les modifications",
  "myAccount.tools.category.generic": "Générique",
  "myAccount.tools.category.custom": "Personnalisé",
  "myAccount.page.myChatbot.selectAgent.label":
    "Sélectionner un agent à tester",
  "myAccount.page.myChatbot.selectAgent.empty": "Aucun agent disponible",
  "myAccount.page.myChatbot.info":
    "Vous pouvez tester ici tous les Agents actifs de votre société.",
  "myAccount.page.myChatbot.archivedAgents":
    "{count, plural, one {# Agent archivé} other {# Agents archivés}}",
  "myAccount.page.myChatbot.archivedAgents.link": "Voir mes Agents",
  "myAccount.page.myChatbot.noAgent": "Aucun agent trouvé pour votre société.",
  "myAccount.page.myUserSessions.filters.agent": "Filtrer par agent",
  "myAccount.page.myUserSessions.filters.agent.all": "Tous les agents",
  "myAccount.page.myUserSessions.filters.sort": "Tri",
  "myAccount.page.myUserSessions.filters.sort.latest": "Plus récent d'abord",
  "myAccount.page.myUserSessions.filters.sort.agentAsc": "Agent (A-Z)",
  "myAccount.page.myUserSessions.filters.sort.agentDesc": "Agent (Z-A)",
  "myAccount.page.myUserSessions.filters.isResolved": "Résolution",
  "myAccount.page.myUserSessions.filters.isResolved.all": "Toutes",
  "myAccount.page.myUserSessions.filters.isResolved.true":
    "Résolues uniquement",
  "myAccount.page.myUserSessions.filters.isResolved.false": "Non résolues",
  "myAccount.page.myUserSessions.filters.requestedActionability":
    "Action demandée",
  "myAccount.page.myUserSessions.filters.requestedActionability.all": "Toutes",
  "discussionReport.common.notAvailable": "N/A",
  "discussionReport.requestedActionability.basic_conversation":
    "Conversation simple",
  "discussionReport.requestedActionability.recommendation": "Recommandation",
  "discussionReport.requestedActionability.lookup": "Recherche",
  "discussionReport.requestedActionability.transaction": "Transaction",
  "discussionReport.requestedActionability.human_help": "Aide humaine",
  "discussionReport.requestedActionability.other": "Autre",
  "discussionReport.resolutionStatus.resolved": "Résolue",
  "discussionReport.resolutionStatus.partially_resolved":
    "Partiellement résolue",
  "discussionReport.resolutionStatus.unresolved": "Non résolue",
  "discussionReport.summary.label": "Résumé de la conversation",
  "discussionReport.summary.empty":
    "Aucun résumé n'est encore disponible pour cette discussion.",
  "discussionReport.insights.label": "Insights du rapport",
  "discussionReport.resolution.label": "Résolution",
  "discussionReport.requestedActionability.label": "Action demandée",
  "discussionReport.pendingMetadata.message":
    "Les métadonnées comme le résumé de conversation et la qualification de la discussion sont généralement ajoutées après quelques jours.",

  "myAccount.page.subscriptionFormulas.title": "Offres d’abonnement",
  "myAccount.page.setup.badge": "Installation sur votre site",
  "myAccount.page.setup.title": "Installer votre Agent sur votre site",
  "myAccount.page.setup.description":
    "Choisissez votre Agent, copiez son code d’installation puis ajoutez-le au modèle global de votre site.",
  "myAccount.page.setup.client": "Client",
  "myAccount.page.setup.api": "Api",
  "myAccount.page.setup.apiAccess.methods":
    "Il existe deux manières de s'authentifier par programme : des jetons rotatifs (génération de JWT courts) ou des clés API statiques (longue durée).",
  "myAccount.page.setup.apiAccess.hint":
    "Utilisez les jetons rotatifs si vous voulez des accès à expiration ; utilisez les clés API pour le serveur-à-serveur et effectuez la rotation en revoquant puis en recréant une clé.",
  "myAccount.page.setup.jwt.description": "Votre JWT pour contacter l'api: ",
  "myAccount.page.setup.jwt.copyClipboard": "JWT copié !",
  "myAccount.page.sesstions.title": "Discussions Utilisateurs",
  "myAccount.page.discusion.byHashedIP.title":
    "Discussions Utilisateurs par IP",

  "dev.companyApi.quickstart": "Démarrage rapide",
  "dev.companyApi.title": "Accès à l’API de l’entreprise",
  "dev.companyApi.subtitle":
    "Créez un jeton de rafraîchissement pour l’intégration de votre entreprise. Utilisez-le pour générer des JWT d’accès de courte durée.",
  "dev.companyApi.refreshOnce":
    "Jeton de rafraîchissement (affiché une seule fois)",
  "dev.companyApi.refreshOnce.help":
    "Copiez-le et stockez-le maintenant (gestionnaire de mots de passe / coffre-fort / secrets CI).",
  "dev.companyApi.tokenLabel": "Jeton",
  "dev.companyApi.important": "Important",
  "dev.companyApi.warning.once":
    "Vous ne pourrez plus afficher ce jeton de rafraîchissement.",
  "dev.companyApi.warning.rotation":
    "Les jetons de rafraîchissement tournent : chaque appel de génération renvoie un NOUVEAU jeton de rafraîchissement et révoque le précédent.",
  "dev.companyApi.create.title": "Créer un jeton",
  "dev.companyApi.create.name": "Nom du jeton",
  "dev.companyApi.create.scopes": "Scopes",
  "dev.companyApi.create.scopesHelp": "Laissez « * » pour un accès complet.",
  "dev.companyApi.create.expires": "Expiration en jours",
  "dev.companyApi.create.expiresHelp":
    "Si vide, le jeton n’expire pas (jusqu’à révocation).",
  "dev.companyApi.create.cta": "Créer le jeton",
  "dev.companyApi.working": "En cours...",
  "dev.companyApi.existing": "Jetons existants",
  "dev.companyApi.revokeAll": "Tout révoquer",
  "dev.companyApi.none": "Aucun jeton pour le moment.",
  "dev.companyApi.revoke": "Révoquer",
  "dev.companyApi.tip":
    "Astuce : la rotation des jetons de rafraîchissement est automatique lors de la génération des jetons d’accès.",

  "dev.companyApiKey.quickstart": "Demarrage rapide",
  "dev.companyApiKey.title": "Cles API de l’entreprise",
  "dev.companyApiKey.subtitle":
    "Creez une clé API longue duree pour l'acces serveur-a-serveur. Les clés ne tournent pas automatiquement et sont affichees une seule fois.",
  "dev.companyApiKey.once": "Cle API (affichee une seule fois)",
  "dev.companyApiKey.once.help":
    "Copiez-la et stockez-la maintenant (gestionnaire de mots de passe / coffre-fort / secrets CI).",
  "dev.companyApiKey.keyLabel": "Clé",
  "dev.companyApiKey.important": "Important",
  "dev.companyApiKey.warning.once": "Vous ne pourrez plus afficher cette clé.",
  "dev.companyApiKey.warning.rotation":
    "Les clés API sont statiques. Révoquez et créez une nouvelle clé pour tourner.",
  "dev.companyApiKey.create.title": "Créer une clé API",
  "dev.companyApiKey.create.name": "Nom de la clé",
  "dev.companyApiKey.create.scopes": "Scopes",
  "dev.companyApiKey.create.scopesHelp": "Laissez « * » pour un accès complet.",
  "dev.companyApiKey.create.expires": "Expiration en jours",
  "dev.companyApiKey.create.expiresHelp":
    "Si vide, la clé n'expire pas (jusqu'a revocation).",
  "dev.companyApiKey.create.cta": "Créer la clé",
  "dev.companyApiKey.working": "En cours...",
  "dev.companyApiKey.existing": "Clés existantes",
  "dev.companyApiKey.revokeAll": "Tout revoquer",
  "dev.companyApiKey.none": "Aucune clé pour le moment.",
  "dev.companyApiKey.revoke": "Revoquer",
  "dev.companyApiKey.tip":
    "Astuce : les clés API sont statiques. Revoquez et creez une nouvelle clé pour tourner.",

  "myAccount.page.setup.subscribe":
    "Abonnez-vous pour accéder à votre appToken et pouvoir utiliser l'application.",
  "myAccount.page.setup.appTokenIs": "Votre appToken est",
  "myAccount.page.setup.copySnippetWidget":
    "Copiez ce code dans votre index.html :",
  "myAccount.page.setup.copySnippetReact":
    "Importez l'app React en haut de votre arbre, avec la prop AppToken comme suit :",
  "myAccount.page.setup.agentSelection.label": "Agent pour les snippets",
  "myAccount.page.setup.agentSelection.hint":
    "Choisissez quel identifiant d'agent injecter dans vos snippets d'intégration.",
  "myAccount.page.setup.agentSelection.optional":
    "Si aucun agent n'est fourni, l'agent par défaut de votre société sera utilisé.",
  "myAccount.page.agentContext.select.label": "Agent cible",
  "myAccount.page.agentContext.select.empty": "Aucun agent disponible",
  "myAccount.page.setup.snippet.copy.cta": "Copier le snippet",
  "myAccount.page.setup.snippet.copy.success":
    "Snippet copié dans le presse-papiers.",
  "myAccount.page.setup.snippet.copy.error": "Impossible de copier le snippet.",
  "myAccount.page.setup.guide.title": "Une installation en trois étapes",
  "myAccount.page.setup.guide.choose.title": "Choisissez votre Agent",
  "myAccount.page.setup.guide.choose.description":
    "Sélectionnez l’Agent qui accueillera les visiteurs de votre site.",
  "myAccount.page.setup.guide.copy.title": "Copiez le code",
  "myAccount.page.setup.guide.copy.description":
    "Utilisez le bouton de copie ci-dessous. Le code contient déjà les bons identifiants de société et d’Agent.",
  "myAccount.page.setup.guide.publish.widget.title": "Ajoutez-le à votre site",
  "myAccount.page.setup.guide.publish.react.title":
    "Ajoutez-le à votre application",
  "myAccount.page.setup.guide.publish.widget.description":
    "Collez la balise juste avant {bodyTag} dans le modèle global ou la zone de code personnalisé de votre site, puis publiez.",
  "myAccount.page.setup.guide.publish.react.description":
    "Intégrez le composant à la racine de votre application React, puis déployez la modification.",
  "myAccount.page.setup.guide.publish.react.chatbox.description":
    "Placez le composant à l’endroit de la page où la conversation doit apparaître, puis déployez la modification.",
  "myAccount.page.setup.configure.title": "Votre code d’installation",
  "myAccount.page.setup.configure.description":
    "Choisissez l’Agent, la méthode d’intégration et le format d’affichage. Le code est mis à jour automatiquement.",
  "myAccount.page.setup.displayMode.label": "Format d’affichage",
  "myAccount.page.setup.displayMode.launcher": "Bouton flottant",
  "myAccount.page.setup.displayMode.launcher.description":
    "Un bouton discret ouvre l’Agent au-dessus de votre site.",
  "myAccount.page.setup.displayMode.chatbox": "Chat intégré",
  "myAccount.page.setup.displayMode.chatbox.description":
    "La conversation occupe directement l’emplacement où vous ajoutez le composant.",
  "myAccount.page.setup.reactMultiView.note":
    "Vous affichez les deux formats sur la même page ?",
  "myAccount.page.setup.reactMultiView.link":
    "Voir l’exemple multi-vue avancé.",
  "myAccount.page.setup.handoff.title": "Vous ne gérez pas le site vous-même ?",
  "myAccount.page.setup.handoff.description":
    "Copiez un message prêt à envoyer à votre développeur, votre agence ou la personne qui administre votre site.",
  "myAccount.page.setup.handoff.copy.cta": "Copier les instructions à envoyer",
  "myAccount.page.setup.handoff.copy.success":
    "Instructions copiées. Vous pouvez les envoyer à votre contact technique.",
  "myAccount.page.setup.handoff.widget":
    "Bonjour, pouvez-vous installer ChatSystem sur toutes les pages de notre site ? Ajoutez la balise suivante juste avant la balise de fermeture {bodyTag} dans le modèle global du site, puis publiez la modification.\n\n{snippet}",
  "myAccount.page.setup.handoff.react":
    "Bonjour, pouvez-vous ajouter ChatSystem à notre application React ? Intégrez le composant suivant à la racine de l’application afin qu’il soit disponible sur toutes les pages concernées, puis déployez la modification.\n\n{snippet}",
  "myAccount.page.setup.handoff.react.chatbox":
    "Bonjour, pouvez-vous ajouter ChatSystem à notre application React ? Placez le composant suivant à l’endroit de la page où la conversation doit apparaître, puis déployez la modification.\n\n{snippet}",
  "myAccount.page.setup.verify.title": "Après la publication",
  "myAccount.page.setup.verify.description":
    "Ouvrez votre site, vérifiez que l’Agent apparaît puis envoyez-lui un message. S’il ne se charge pas, vérifiez d’abord que le domaine du site est autorisé.",
  "myAccount.page.setup.verify.domains.cta": "Vérifier les domaines autorisés",
  "myAccount.page.setup.verify.agent.cta": "Tester mon Agent",

  "myAccount.page.setup.documentation.title": "Documentation",
  "myAccount.page.setup.documentation.documentationExplaination":
    "La documentation est disponible sur ce ",
  "myAccount.page.setup.documentation.documentationExplaination.link": "lien",
  "myAccount.page.setup.documentation.swaggerExplaination":
    "Le swagger est disponible sur ce ",
  "myAccount.page.setup.documentation.swaggerExplaination.link": "lien",

  "documentation.hub.metaTitle": "Documentation ChatSystem",
  "documentation.hub.metaDescription":
    "Des guides pratiques pour configurer ChatSystem et l’intégrer à votre parcours client.",
  "documentation.hub.eyebrow": "Guides ChatSystem",
  "documentation.hub.title": "Documentation",
  "documentation.hub.subtitle":
    "Choisissez un guide pour configurer vos agents, connecter vos services et valider l’expérience proposée à vos clients.",
  "documentation.hub.resources.label": "Guides disponibles",
  "documentation.hub.productSearch.title":
    "Mettre en place la recherche de produits sur un agent",
  "documentation.hub.productSearch.description":
    "Créez une Product Collection, configurez le profil de recherche de l’agent et validez ses recommandations.",
  "documentation.hub.productSearch.action":
    "Ouvrir le guide de recherche produit",
  "documentation.hub.identity.title":
    "Mettre en place la délégation d’identité",
  "documentation.hub.identity.description":
    "Connectez votre système de connexion existant pour permettre aux agents d’agir de manière sécurisée pour vos clients connectés.",
  "documentation.hub.identity.action": "Ouvrir le guide d’intégration",
  "documentation.hub.clientSdk.title": "Client SDK",
  "documentation.hub.clientSdk.description":
    "Retrouvez les extraits d’intégration et les réglages nécessaires pour ajouter ChatSystem à votre site.",
  "documentation.hub.clientSdk.action": "Ouvrir le guide Client SDK",
  "documentation.hub.api.title": "Référence API",
  "documentation.hub.api.description":
    "Explorez les routes disponibles ainsi que les formats de requête et de réponse.",
  "documentation.hub.api.action": "Ouvrir la référence API",
  "documentation.guide.back": "Toute la documentation",
  "documentation.productSearch.metaTitle":
    "Mettre en place la recherche de produits sur un agent | ChatSystem",
  "documentation.productSearch.metaDescription":
    "Créez une Product Collection, associez-la à un agent et testez la recherche de produits dans ChatSystem.",
  "documentation.clientSdk.metaTitle": "Installer le Client SDK | ChatSystem",
  "documentation.clientSdk.metaDescription":
    "Installez un widget ChatSystem ou partagez la conversation d’un Agent entre plusieurs vues React.",

  "myAccount.page.upload.title": "Uploadez vos produits",
  "myAccount.page.upload.catalogSelection.manualUpload.title":
    "Ceci est un parcours d'upload manuel. Ne l'utilisez pas si vous utilisez l'API.",
  "myAccount.page.upload.uploadFile.explaination":
    "Merci de choisir un fichier CSV ou XLSX comportant vos produits.",
  "myAccount.page.upload.uploadFile.noFile": "Aucun fichier n'a été uploadé.",
  "myAccount.page.upload.catalogSelection.dropdown.explaination":
    "Choisissez un catalogue dans lequel télécharger vos produits. Vous pouvez créer un catalogue à partir d'un fichier ou télécharger des produits sur un catalogue existant.",
  "myAccount.page.upload.catalogSelection.dropdown.placeholder":
    "Choisissez un catalogue",
  "myAccount.page.upload.catalogSelection.dropdown.addNew":
    "Créer un nouveau catalogue",

  "myAccount.page.upload.MandatoryColumns.title":
    "Colonnes obligatoires pour le robot",
  "myAccount.page.upload.MandatoryColumns.explaination":
    "Afin de bien construire les messages de réponses au client, nous avons besoin de connaître spécifiquement les colonnes suivantes parmi votre fichier. Ces colonnes sont obligatoires pour que le retour du robot soit au niveau de qualité attendu.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description":
    "Description",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description.details":
    "Indiquez la colonne contenant la description du produit. Plus la description est détaillée, meilleure sera la recherche.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.doesNotExist":
    "N'existe pas dans ce fichier",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr":
    "Product Name FR",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr.details":
    "Indiquez la colonne contenant le nom FRANCAIS de votre produit. C’est le nom qui sera affiché dans le tchat quand votre produit sera conseillé par le robot. Seule une langue est obligatoire pour les noms de produits.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en":
    "Product Name EN",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en.details":
    "Indiquez la colonne contenant le nom ANGLAIS de votre produit. C’est le nom qui sera affiché dans le tchat quand votre produit sera conseillé par le robot. Seule une langue est obligatoire pour les noms de produits.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice":
    "Prix de vente",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice.details":
    "Indiquez la colonne contenant le prix du produit. C’est le prix qui sera indiqué dans le tchat lorsque le produit sera conseillé.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct":
    "URL du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct.details":
    "Indiquez la colonne contenant l’URL de la fiche du produit. C’est l’URL qui servira à rediriger l’utilisateur quand il cliquera sur le produit dans le tchat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc":
    "URL de l'image du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc.details":
    "Indiquez la colonne contenant l’URL de l'image du produit. Cette image sera affichée dans le résultat du tchat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId":
    "ID unique du produit",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId.details":
    "Indiquez la colonne contenant l'ID du produit. Cet ID doit être unique pour chaque produit.",
  "myAccount.page.upload.MandatoryColumns.validation.cta": "Ok",

  "myAccount.page.upload.columnSearchSelection.introduction":
    "Quelles colonnes souhaitez-vous utiliser pour filtrer les produits pour vos clients ? Choisissez celles qui font sens, qui définissent votre produit, sur lesquelles une recherche peut être effectuée.",
  "myAccount.page.upload.columnSearchSelection.title":
    "Sélection des colonnes utiles",

  "myAccount.page.upload.mandatoryColumns.title":
    "Selection de colonnes obligatoires",
  "myAccount.page.upload.mandatoryColumns.explanaition":
    "Parmi les critères de recherche, est-ce qu'un critère est obligatoire pour proposer des produits à vos clients ? Par exemple, pour conseiller un jeu de société à un client, l'âge est très important: pour un enfant on ne conseille pas le même jeu qu'à un adulte !",
  "myAccount.page.upload.mandatoryColumns.explanaition.two":
    "Si vous cochez une case ici, le robot demandera cette information au client.",
  "myAccount.page.upload.mandatoryColumns.maximumSelection":
    "Merci de choisir 3 catégories obligatoires maximum.",

  "myAccount.page.upload.columnDefinition.title":
    "Expliquez vos données au robot",
  "myAccount.page.upload.columnDefinition.explaination.danger":
    "Le robot a besoin de comprendre quelle donnée il parcourt. Cette étape est très importante pour la compréhension des produits de votre catalogue.",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.name":
    "Donnez des noms faciles à comprendre",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.dataType":
    "Précisez le type de donnée pour que le robot sache comment la parcourir",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.semanticDescription":
    "Expliquez en une phrase chaque donnée",
  "myAccount.page.upload.columnDefinition.explaination.recap.understanding":
    "Il est très important que le robot comprenne quelle donnée il consulte quand il recherche un produit. Est-ce que ce sont des chiffres, des dates, un ensemble de mots, ou des colonnes de type vrai/faux ?",
  "myAccount.page.upload.columnDefinition.explaination.recap.qualityMatters":
    "Selon la qualité des informations saisies, le robot sera plus ou moins performant dans le conseil de produits.",
  "myAccount.page.upload.columnDefinition.explaination.recap.checkColumns":
    "Vérifions ensemble chaque colonne.",
  "myAccount.page.upload.columnDefinition.explaination.recap.numberOfColumns":
    "Nombres de filtres : ",
  "myAccount.page.upload.columnDefinition.form.invalid":
    "Certaines colonnes n'ont pas été totalement remplies. Cherchez les champs rouges !",

  "myAccount.page.upload.columnDefinitionSetter.mandatory": "Obligatoire",
  "myAccount.page.upload.columnDefinitionSetter.mandatoryExplaination":
    "Cette colonne est obligatoire et ne peut être modifiée",
  "myAccount.page.upload.columnDefinitionSetter.emptyLine": "Ligne vide",

  "myAccount.page.upload.columnDefinition.column": "Définition de la colonne",
  "myAccount.page.upload.columnDefinition.name": "Nom pour le robot",
  "myAccount.page.upload.columnDefinition.type": "Type",
  "myAccount.page.upload.columnDefinition.semanticDescription": "Explication",

  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ProductName":
    "Nom du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ProductName":
    "Le nom du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Price":
    "Prix du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Price":
    "Le prix du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Description":
    "Description du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Description":
    "La description du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.URLProduct":
    "URL Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.URLProduct":
    "Le lien URL qui permet d'accéder au produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ImageURL":
    "URL Image Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ImageURL":
    "Le lien URL qui emmène vers l'image du produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.customerProductId":
    "ID du Produit",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.customerProductId":
    "L'ID unique qui permet d'identifier le produit",

  "myAccount.page.upload.columnDefinition.type.chosenType":
    "Type actuel saisi:",
  "myAccount.page.upload.columnDefinition.type.dataSample":
    "Exemple de données de cette colonne depuis vos données:",
  "myAccount.page.upload.columnDefinition.type.editType":
    "Modifier le type de la colonne:",

  "myAccount.page.upload.columnDefinition.columnNameHelper.header":
    "Plus d'informations sur le nom",
  "myAccount.page.upload.columnDefinition.columnNameHelper.intro":
    "Indiquez un nom simple, facile à comprendre, pour que le robot comprenne la donnée.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationOne":
    "Le nom simple, explicatif est important car il aide le robot à comprendre de quelle donnée on parle.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationTwo":
    "Exemples : 'jeux de société', 'nombre de joueurs' sont des noms simples. 'UK_896' n'est pas un nom simple.",

  "myAccount.page.upload.columnDefinition.columnTypeHelper.header":
    "Plus d'informations sur le type",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.explaination":
    "Préciser le type de la colonne est très important car permet au robot de savoir comment chercher.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.intro":
    "Voici les différents types possibles:",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.title":
    "Liste définie",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.content":
    "Une liste définie est une liste dont on connait toutes les valeurs à l'avance. Par exemple, la taille des habits : S, XS, M, L, XL, XXL. Ou encore, des tags pour des produits - par exemple, 'Science-fiction', 'Western', 'Romance' pour des livres. C'est une liste figée, dont on connait toutes les options.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.title": "Texte",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.content":
    "C'est la rubrique la plus commune. Pour tous textes non structurés, comme une description, une information classique.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.title":
    "Chiffres et nombres",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.content":
    "Si la donnée est un nombre ou un chiffre. Il ne peut pas y avoir de lettre. '91' est un nombre, '91z' est un texte.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.title": "Date",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.content":
    "Si la donnée est une date.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.title":
    "Vrai/Faux",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.content":
    "Si la donnée est de type oui/non, ou vrai/faux. Par exemple, est-ce qu'un plat est sans gluten.",

  "myAccount.page.upload.columnDefinition.name.mandatory.isMappedTo":
    "Correspond au champs obligatoire ",
  "columnDefinition.checkbox.isRequired.name": "Obligatoire",
  "columnDefinition.checkbox.isRequired.explaination":
    "Cette donnée est obligatoire pour le robot",
  "columnDefinition.checkbox.isImportant.name": "Important",
  "columnDefinition.checkbox.isImportant.explaination":
    "Cette donnée est importante : elle ajoute un bonus au score de matching.",
  "myAccount.page.upload.columnDefinition.meta.section": "Metadata",
  "myAccount.page.upload.columnDefinition.meta.helper":
    "Utilisez « Obligatoire » lorsque la présence de la colonne est indispensable au traitement d'un produit. Si ele n'est pas présente, le modèle la déduira. Indiquez « Important » pour prioriser cette colonne dans les recommandations et le classement. La plupart des colonnes n'ont pas besoin d'être Obligatoires ou Importantes.",
  "columnDefinition.cta.addProperty": "Ajouter une propriété",

  "myAccount.page.upload.productDefinition.title":
    "Définition des produits du Catalogue",
  "myAccount.page.upload.productDefinition.intro":
    "Cette donnée permet au robot de comprendre vos données. Merci d’indiquer un nom court qui récapitule le type d’article que vous allez référencer dans le robot. Cette description lui servira encore une fois à être un bon vendeur dans la catégorie que vous allez indiquer. ",
  "myAccount.page.upload.productDefinition.placeholder":
    "Indiquez la catégorie de vos produits. Exemple : Smartphones",
  "myAccount.page.upload.catalog.title": "Nom du catalogue de produits",
  "myAccount.page.upload.catalog.intro":
    "Donnez un nom à votre catalogue. Ce nom ne sert que pour vous.",
  "myAccount.page.upload.catalog.placeholder": "Smartphones",

  "myAccount.page.upload.processing.singleValueError.boolean":
    "Valeur booléenne non reconnue",
  "myAccount.page.upload.processing.singleValueError.number":
    "Valeur Nombre non reconnue",
  "myAccount.page.upload.processing.singleValueError.date":
    "Valeur Date non reconnue",
  "myAccount.page.upload.processing.singleValueError.text":
    "Valeur Text non reconnue",
  "myAccount.page.upload.processing.singleValueError.enum":
    "Valeur Enum non reconnue",
  "myAccount.page.upload.processing.singleValueError.url":
    "Valeur Url non reconnue. Doit commencer par 'http'",
  "myAccount.page.upload.processing.lineError":
    "Ligne: {indexProduct} - Erreur pendant le parsing : Proriété: {property} / Valeur reçue: {value}",
  "myAccount.page.upload.processing.notHandledError":
    "Ligne: {indexProduct} - Donnée non gérée: Propriété - {property} / Valeur reçue : {value}",

  "myAccount.page.upload.error.intro":
    "Il y a des erreurs lors du traitement de votre fichier.",
  "myAccount.page.upload.error.explaination":
    "Chaque ligne avec une erreur est affichée ci-dessous. Merci de vérifier le contenu correspondant et de le corriger. Vous pourrez ensuite réuploader le fichier (vos paramètres saisis ne sont pas perdus)",
  "myAccount.page.upload.button.cta": "Upload",
  "myAccount.page.upload.success.notification":
    "Votre fichier a été correctement uploadé.",
  "myAccount.page.upload.failure.notification":
    "Votre fichier n'a pu être uploadé. Merci de corriger les erreurs affichées dans votre fichier et/ou dans la définition des colonnes, et de réessayer.",
  "myAccount.page.upload.failure.restartUpload": "Restart",

  "myAccount.page.upload.success.component.title": "Succès",
  "myAccount.page.upload.success.component.explaination":
    "Votre fichier a été correctement uploadé.",
  "myAccount.page.upload.success.component.explaination2":
    "Les produits s'afficheront désormais dans les résultats du chatbot à vos clients.",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.header":
    "Plus d'informations sur la description",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionOne":
    "Exliquez en une phrase ce que contient cette colonne, de façon simple, qu'un ami comprendrait.",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionTwo":
    "Exemple : une colonne avec un nom 'durée du jeu' pourrait contenir la phrase suivante : 'La durée de jeu souhaitée par le client'",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionThree":
    "Les colonnes de type vrai/faux doivent être une question. Exemple : 'ce plat est-il sans gluten ?'",

  "myAccount.page.myCatalogs.catalog.title": "Catalogue",
  "myAccount.page.myCatalogs.catalog.name": "Nom",
  "myAccount.page.myCatalogs.catalog.isDefault": "Est par défaut",
  "myAccount.page.myCatalogs.catalog.default": "Défaut",
  "myAccount.page.myCatalogs.catalog.productDefinition":
    "Définition des produits du catalogue",
  "myAccount.page.myCatalogs.catalog.delete": "Supprimer le catalogue",
  "myAccount.page.myCatalogs.catalog.delete.success":
    "Le catalogue a bien été effacé.",
  "myAccount.page.myCatalogs.catalog.products.delete.cta":
    "Effacer les produits du catalogue",
  "myAccount.page.myCatalogs.catalog.products.delete.success":
    "Les produits du catalogue ont été effacés.",
  "myAccount.page.myCatalogs.catalog.numberOfProducts": "Nombre de produits : ",
  "myAccount.page.myCatalogs.catalog.details.title": "Détails du catalogue",
  "myAccount.page.myCatalogs.catalog.header.desc":
    "Gérez les paramètres de votre catalogue, ses filtres et produits.",
  "myAccount.page.myCatalogs.catalog.name.hint":
    "Le nom qui décrit les produits présents dans ce catalogue.",
  "myAccount.page.myCatalogs.catalog.productDefinition.hint":
    "Décrivez en une ou deux phrases ce qui définit un produit dans ce catalogue - son rôle, utilité.",
  "myAccount.page.myCatalogs.catalog.filters.callout":
    "Ajustez les paramètres de vos Search Filter pour en ressortir les produits les plus pertinents pour chaque recherche.",
  "myAccount.page.myCatalogs.catalog.dangerZone.title": "Zone Sensible",
  "myAccount.page.myCatalogs.catalog.dangerZone.desc":
    "Ces actions ne peuvent être annulées. Procédez avec attention.",
  "myAccount.page.myCatalogs.catalog.deleteProducts.hint":
    "Retire tous les produits présents dans le catalogue.",
  "myAccount.page.myCatalogs.catalog.deleteCatalog.hint":
    "Supprime définitivement le catalogue, ses Search Filters et ses produits.",
  "myAccount.page.myCatalogs.all.noCatalogs":
    "Vous n'avez pas de catalogue pour l'instant.",
  "myAccount.page.myCatalogs.cta.create": "Créer un catalogue",
  "myAccount.page.myCatalogs.cta.save": "Sauvegarder le catalogue",
  "myAccount.page.myCatalogs.save.success": "Votre catalogue a bien été créé.",
  "myAccount.page.myCatalogs.save.error":
    "Il y a eu une erreur lors de la création de votre catalogue. Merci de contacter le support.",
  "myAccount.page.myCatalogs.creation.success.title": "Succès",
  "myAccount.page.myCatalogs.creation.success.explaination":
    "Votre catalogue a bien été créé.",
  "myAccount.page.myCatalogs.creation.success.explaination2":
    "Vous pouvez maintenant uploader des produits afin que votre agent chatbot les présente.",
  "myAccount.page.myCatalogs.edition.save.cta": "Sauvegarder les modifications",
  "myAccount.page.myCatalogs.edition.searchFilter.edit.cta":
    "Modifier les filtres de recherche",
  "myAccount.page.myCatalogs.edition.searchFilter.save.cta":
    "Sauvegarder les filtres de recherche",
  "myAccount.page.myCatalogs.searchFiltersedition.title":
    "Modifier les filtres de recherche",
  "myAccount.page.myCatalogs.edition.save.success":
    "Votre catalogue a bien été modifié.",
  "myAccount.page.myCatalogs.searchFiltersedition.save.success":
    "Vos filtres de recherche ont bien été modifiés.",
  "myAccount.page.myCatalogs.searchFiltersedition.edit.notIfProductsExist":
    "Vous ne pouvez pas modifier les filtres de recherche d'un catalogue contenant des produits existants. Videz le catalogue de tous ses produits avant de le modifier.",

  "myAccount.page.myAgents.cta.save": "Enregistrer",
  "myAccount.page.myAgents.cta.title": "Modifier Agent",
  "myAccount.page.myAgents.cta.changeAppearance": "Modifier l'apparence",
  "myAccount.page.myAgents.cta.explaination":
    "Modifiez les détails, le texte de bienvenue et l'apparence de votre chatbot.",
  "myAccount.page.myAgents.cta.field.name": "Nom de l'agent (interne)",
  "myAccount.page.myAgents.cta.field.customNameToDisplay":
    "Nom assistant affiché au client",
  "myAccount.page.myAgents.cta.field.startingText":
    "Texte de départ du chatbot",
  "myAccount.agentConversationStarters.title": "Premières questions suggérées",
  "myAccount.agentConversationStarters.helper":
    "Proposez jusqu’à trois questions utiles à l’ouverture de la conversation. Vos visiteurs pourront en envoyer une en un clic.",
  "myAccount.agentConversationStarters.inputLabel":
    "Question suggérée {number}",
  "myAccount.agentConversationStarters.placeholder":
    "Par exemple : Quel service correspond le mieux à mon besoin ?",
  "myAccount.agentConversationStarters.remove":
    "Supprimer la question suggérée {number}",
  "myAccount.agentConversationStarters.add": "Ajouter une question suggérée",
  "myAccount.page.myAgents.cta.field.initialSystemPrompt":
    "Instructions de l'Agent",
  "myAccount.page.myAgents.cta.field.initialSystemPrompt.helper":
    "Personnalisez ici le rôle, le contexte de l'entreprise, la communication et les limites de votre Agent.",
  "myAccount.agentPrompt.legacy.helper":
    "Cet Agent utilise encore un seul bloc d'instructions. Vous pouvez continuer à le modifier ou le déplacer sans le réinterpréter dans l'éditeur structuré.",
  "myAccount.agentPrompt.convert": "Utiliser l'éditeur structuré",
  "myAccount.agentPrompt.composition.title":
    "Des instructions claires, un objectif par section",
  "myAccount.agentPrompt.composition.helper":
    "ChatSystem ajoute automatiquement les instructions de chaque Tool activé. Gérez les consignes propres aux Tools dans l'onglet Tools de l'Agent.",
  "myAccount.agentPrompt.role": "Rôle de l'Agent",
  "myAccount.agentPrompt.role.helper":
    "Qui est l'Agent et quel rôle il joue auprès des visiteurs.",
  "myAccount.agentPrompt.objectives": "Objectifs et audience",
  "myAccount.agentPrompt.objectives.helper":
    "Ce que l'Agent doit aider les visiteurs à accomplir en priorité.",
  "myAccount.agentPrompt.organization": "Organisation représentée",
  "myAccount.agentPrompt.organization.helper":
    "Les informations validées, services et éléments de contexte que l'Agent peut utiliser sur votre organisation.",
  "myAccount.agentPrompt.communication": "Communication et conversation",
  "myAccount.agentPrompt.communication.helper":
    "Le ton, le style des réponses, les questions utiles et l'approche de recommandation.",
  "myAccount.agentPrompt.safeguards": "Fiabilité et limites",
  "myAccount.agentPrompt.safeguards.helper":
    "Ce que l'Agent doit vérifier, ne jamais inventer ou expliquer avec transparence.",
  "myAccount.agentPrompt.miscellaneous": "Instructions complémentaires",
  "myAccount.agentPrompt.miscellaneous.helper":
    "Tout élément important qui ne correspond pas aux autres sections.",
  "admin.agentPromptWorkspace.title": "Construction du prompt de l'Agent",
  "admin.agentPromptWorkspace.description":
    "Consultez le prompt configuré exact et l'origine de chaque instruction.",
  "admin.agentPromptWorkspace.tab.overview": "Vue d'ensemble",
  "admin.agentPromptWorkspace.tab.edit": "Modifier les instructions",
  "admin.agentPromptInspection.error":
    "La construction du prompt n'a pas pu être chargée.",
  "admin.agentPromptInspection.retry": "Réessayer",
  "admin.agentPromptInspection.unavailable":
    "Ce runtime n'expose pas de prompt configuré unifié. Aucune reconstitution partielle n'est affichée.",
  "admin.agentPromptInspection.runtime": "Runtime",
  "admin.agentPromptInspection.composition": "Composition",
  "admin.agentPromptInspection.activeTools": "Tools actifs dans le prompt",
  "admin.agentPromptInspection.characters": "Caractères après assemblage",
  "admin.agentPromptInspection.group.agent.title": "Configuration de l'Agent",
  "admin.agentPromptInspection.group.agent.description":
    "Instructions propres à cet Agent, modifiables par l'entreprise ou un administrateur.",
  "admin.agentPromptInspection.group.tools.title": "Tools actifs",
  "admin.agentPromptInspection.group.tools.description":
    "Seuls les Tools activés dont les instructions sont ajoutées à ce prompt configuré.",
  "admin.agentPromptInspection.group.platform.title": "Règles du runtime",
  "admin.agentPromptInspection.group.platform.description":
    "Règles d'orchestration et de fiabilité ajoutées par ChatSystem.",
  "admin.agentPromptInspection.section.empty":
    "Aucune instruction n'est configurée dans cette section.",
  "admin.agentPromptInspection.rendered.title": "Prompt configuré exact",
  "admin.agentPromptInspection.copy": "Copier le prompt",
  "admin.agentPromptInspection.copied": "Copié",
  "admin.agentPromptInspection.source.agentComposition":
    "Configuration de l'Agent",
  "admin.agentPromptInspection.source.agentOverride":
    "Surcharge du Tool pour cet Agent",
  "admin.agentPromptInspection.source.toolDefault": "Valeur par défaut du Tool",
  "admin.agentPromptInspection.source.functionDescription":
    "Description de la fonction du Tool",
  "admin.agentPromptInspection.source.platformPolicy":
    "Politique du runtime ChatSystem",
  "myAccount.page.myAgents.cta.field.displayMode": "Affichage",
  "myAccount.page.myAgents.cta.field.displayMode.default": "Defaut",
  "myAccount.page.myAgents.cta.field.displayMode.spritesheet": "SpriteSheet",
  "myAccount.page.myAgents.cta.displayMode.spritesheet.upload.label":
    "Upload spritesheet",
  "myAccount.page.myAgents.edit.displayMode.title": "Thèmes",
  "myAccount.page.myAgents.edit.displayMode.explaination":
    "Choisissez le thème que vous voulez activer, modifier, ou créez-en un nouveau.",
  "myAccount.page.myAgents.edit.displayMode.name.edit":
    "Editer le nom du thème",
  "myAccount.page.myAgents.edit.displayMode.name.edit.explainations":
    "Modifiez le nom de votre thème et accédez à a chacun des apparences ici..",
  "myAccount.page.myAgents.edit.displayMode.name.title": "Modifier Mon Thème",
  "myAccount.page.myAgents.edit.displayMode.name.edit.facets.title":
    "Toutes les apparences du thème",
  "myAccount.page.myAgents.edit.overline": "Paramètres Agent",
  "myAccount.page.myAgents.edit.title": "Modifier Agent",
  "myAccount.page.myAgents.edit.subtitle":
    "Configurez le comportement, les instructions, le style visuel et l'activation des outils pour cet agent.",
  "myAccount.page.myAgents.edit.back": "Retour aux agents",
  "myAccount.page.myAgents.edit.tabs.general": "Général",
  "myAccount.page.myAgents.edit.tabs.prompts": "Instructions",
  "myAccount.page.myAgents.edit.tabs.appearance": "Apparence",
  "myAccount.page.myAgents.edit.tabs.tools": "Outils Agent",
  "myAccount.page.myAgents.edit.preview": "Aperçu",
  "myAccount.page.myAgents.edit.appearance.empty":
    "Aucun affichage sélectionné.",
  "myAccount.page.myAgents.edit.tools.noCompany":
    "Le contexte société est manquant pour charger les outils.",
  "myAccount.page.myAgents.edit.toast.load.error":
    "Impossible de charger l'agent.",
  "myAccount.page.myAgents.edit.toast.save.error":
    "Impossible d'enregistrer les paramètres de l'agent.",
  "myAccount.page.myAgents.edit.toast.save.success":
    "Paramètres de l'agent enregistrés.",
  "myAccount.page.myAgents.edit.save.saving": "Enregistrement...",
  "myAccount.page.myAgents.edit.tools.loading": "Chargement des outils...",
  "myAccount.page.myAgents.edit.tools.empty":
    "Aucun outil n'est actuellement disponible pour votre société.",
  "myAccount.page.myAgents.edit.tools.summary":
    "{enabledCount} outils activés sur {totalCount} pour cet agent.",
  "myAccount.page.myAgents.edit.tools.activationLabel":
    "Activation pour cet agent",
  "myAccount.page.myAgents.edit.tools.toggleAria":
    "Activer ou désactiver cet outil pour cet agent",
  "myAccount.page.myAgents.edit.tools.agentInstructions.title":
    "Instructions pour cet Agent",
  "myAccount.page.myAgents.edit.tools.agentInstructions.help":
    "Adaptez quand et comment cet Agent doit utiliser l'outil. Les règles de sécurité de la plateforme restent appliquées.",
  "myAccount.page.myAgents.edit.tools.agentInstructions.reset":
    "Utiliser les instructions recommandées",
  "myAccount.page.myAgents.edit.tools.agentInstructions.custom":
    "Vos instructions personnalisées sont actives.",
  "myAccount.page.myAgents.edit.tools.agentInstructions.default":
    "Les instructions recommandées de l'outil sont actives.",
  "myAccount.page.myAgents.edit.tools.status.enabled": "Activé",
  "myAccount.page.myAgents.edit.tools.status.disabled": "Désactivé",
  "myAccount.page.myAgents.edit.tools.status.unsaved":
    "Modifications non enregistrées",
  "myAccount.page.myAgents.edit.tools.noDescription":
    "Aucune description disponible.",
  "myAccount.page.myAgents.edit.tools.toast.loadAvailable.error":
    "Impossible de charger les outils disponibles.",
  "myAccount.page.myAgents.edit.tools.toast.loadAgent.error":
    "Impossible de charger les outils de l'agent.",
  "myAccount.page.myAgents.edit.tools.toast.toggle.error":
    "Impossible de mettre à jour l'activation de l'outil.",
  "myAccount.page.myAgents.edit.tools.toast.save.error":
    "Impossible d'enregistrer les paramètres de l'outil.",
  "myAccount.page.myAgents.edit.tools.toast.validation.title":
    "Merci de corriger les erreurs de configuration de l'outil.",
  "myAccount.page.myAgents.edit.tools.validation.title":
    "Problèmes de configuration",
  "myAccount.page.myAgents.edit.tools.validation.searchableUrl.requiredWhenEnabled":
    "Au moins une URL est requise pour activer cet outil.",
  "myAccount.page.myAgents.edit.tools.validation.searchableUrl.invalidList":
    "Merci de renseigner uniquement des URL http(s) valides.",

  "myAccount.page.myDNS.intro":
    "Gérez les domaines autorisés pour votre société",
  "myAccount.page.myDNS.CTA.addFirstDNS": "Saisir un domaine",
  "myAccount.page.myDNS.CTA.addNewDNS": "Saisir un autre domaine",
  "myAccount.page.myDNS.CTA.save": "Enregistrer les modifications",
  "myAccount.page.myDNS.CTA.cancel": "Annuler les modifications",
  "myAccount.page.myDNS.CTA.confirmDelete": "Confirmer la suppression",
  "myAccount.page.myDNS.CTA.delete": "Supprimer ce domaine",
  "myAccount.page.myDNS.empty":
    "Aucun domaine autorisé n’a encore été renseigné.",
  "myAccount.page.myDNS.save.success":
    "Les noms de domaine autorisés ont bien été mis à jour",
  "myAccount.page.myDNS.save.failure":
    "Les noms de domaine n'ont pas pu être mis à jour. Merci de contacter le support.",
  "myAccount.page.myDNS.delete.pending.title": "Suppression en attente",
  "myAccount.page.myDNS.delete.pending.description":
    "{count, plural, one {Le domaine {domains} reste autorisé tant que vous n’avez pas confirmé sa suppression.} other {Les domaines {domains} restent autorisés tant que vous n’avez pas confirmé leur suppression.}}",
  "myAccount.page.myDNS.delete.success":
    "{count, plural, one {Le domaine a bien été supprimé} other {Les domaines ont bien été supprimés}}",

  "myAccount.page.profile.title": "Mes informations",
  "myAccount.page.profile.company.header.title": "Paramètres de votre société",
  "myAccount.page.profile.company.header.desc":
    "Gérez le profil et les dépenses de la société.",
  "myAccount.page.profile.company.defaultLocale.title":
    "Langue de communication de la société",
  "myAccount.page.profile.company.defaultLocale.description":
    "Utilisée pour les messages envoyés par ChatSystem à votre équipe. Un agent peut la remplacer si nécessaire.",
  "myAccount.page.profile.company.name.title": "Nom de votre entreprise",
  "myAccount.page.profile.company.name.queryParamToAppend":
    "Query Param à ajouter",
  "myAccount.page.profile.company.profile.title": "Profil de votre société",
  "myAccount.page.profile.company.subscriptionPlan.unknown": "Inconnue",
  "myAccount.page.profile.company.subscriptionPlan.label": "Abonnement",
  "myAccount.page.profile.company.subscriptionPlan.hint.fixedShort":
    "Seuil limité",
  "myAccount.page.profile.company.subscriptionPlan.hint.dynamicShort":
    "Adaptatif",
  "myAccount.page.profile.company.subscriptionPlan.availableDescription":
    "Comparez les formules publiques et privées actuellement proposées à votre entreprise.",
  "myAccount.page.profile.company.subscriptionPlan.availableAction":
    "Voir les formules disponibles",
  "myAccount.page.profile.company.placeholder":
    "Ajoutez le nom de votre entreprise",
  "myAccount.page.profile.company.queryParam.placeholder":
    "Créez un query param qui sera ajouté sur vos URLS",
  "myAccount.page.profile.company.cannotEditMaxBudget":
    "Votre formule ayant un seuil fixe de dépense, vous ne pouvez modifier ce champs.",
  "myAccount.page.profile.company.subscriptionFormula.name.fullFixed": "Fixe",
  "myAccount.page.profile.company.subscriptionFormula.name.fixedIncreasable":
    "Fixe et augmentable par palier",
  "myAccount.page.profile.company.subscriptionFormula.name.fixedPlusDynamic":
    "Fixe et augmentable dynamiquement",
  "myAccount.page.profile.company.subscriptionFormula.name.fullDynamic":
    "Complètement dynamique",
  "myAccount.page.profile.company.notSubscribed.message":
    "Vous n'avez pas d'abonnement. Merci de vous abonner pour gérer vos paramètres de paiement.",
  "myAccount.page.profile.company.notSubscribed.cta": "S'abonner",
  "myAccount.page.profile.company.currentConsumption.title":
    "Usage consommé sur cette période de facturation",
  "myAccount.page.profile.company.currentConsumption.loading":
    "Chargement de votre abonnement ...",
  "myAccount.page.profile.company.currentConsumption.error":
    "Nous n'avons pu charger votre consommation.",
  "myAccount.page.profile.company.currentConsumption.value": "{amount}",
  "myAccount.page.profile.company.currentConsumption.subtitle":
    "Usages tarifés terminés uniquement ; le prix de l’abonnement et le crédit disponible sont exclus.",
  "myAccount.page.profile.company.currentConsumption.badge": "A jour",

  "myAccount.page.profile.company.save.success":
    "Votre entreprise a bien été mise à jour",
  "myAccount.page.company.save.failure":
    "Votre entreprise n'a pas pu être mis à jour. Merci de contacter le support.",

  "myAccount.page.myUserSessions.all.table.title": "Discussions Utilisateurs",
  "myAccount.page.myUserSessions.all.table.id": "Id",
  "myAccount.page.myUserSessions.all.table.agent": "Agent",
  "myAccount.page.myUserSessions.all.table.numberOfMessages":
    "Nombre de messages",
  "myAccount.page.myUserSessions.all.table.Totalduration": "Durée totale",
  "myAccount.page.myUserSessions.all.table.TFTduration": "Durée TFT",
  "myAccount.page.myUserSessions.all.table.COT": "COT",
  "myAccount.page.myUserSessions.all.table.LastUse": "Créé le",
  "myAccount.page.myUserSessions.all.noUserSession":
    "Vous n'avez pas de discussion utilisateur pour l'instant.",

  "admin.page.companies.all.table.title": "Sociétés",
  "admin.page.companies.all.table.id": "Id",
  "admin.page.companies.all.table.name": "Nom",
  "admin.page.companies.all.table.mail": "Mail",
  "admin.page.companies.all.noCompanies":
    "Il n'y a pas de société pour l'instant.",
  "admin.page.companies.crud.create": "Créer une société",
  "admin.page.companies.crud.edit.title": "Editer une société",
  "admin.page.companies.crud.edit.agentsDisplayed.title":
    "Agents de la société",
  "admin.page.companies.crud.create.success":
    "La société a été créée avec succès.",
  "admin.page.companies.crud.update.success":
    "La société a été éditée avec succès.",
  "admin.page.companies.activityReporting.title": "Analyse des discussions",
  "admin.page.companies.activityReporting.description":
    "Analyse les discussions client de cette société pour ajouter les métadonnées utilisées par les rapports mensuels.",
  "admin.page.companies.activityReporting.auto.enabled":
    "Analyse automatique activée",
  "admin.page.companies.activityReporting.auto.disabled":
    "Analyse automatique désactivée",
  "admin.page.companies.activityReporting.auto.saving": "Enregistrement...",
  "admin.page.companies.activityReporting.manualHint":
    "Le déclenchement manuel analyse les discussions client racines et ne retraite que celles dont les métadonnées sont manquantes ou obsolètes.",
  "admin.page.companies.activityReporting.metrics.totalDiscussions":
    "Discussions totales",
  "admin.page.companies.activityReporting.metrics.eligibleDiscussions":
    "Discussions éligibles",
  "admin.page.companies.activityReporting.metrics.generated": "Analysées",
  "admin.page.companies.activityReporting.metrics.failed": "En échec",
  "admin.page.companies.activityReporting.metrics.skipped": "Ignorés",
  "admin.page.companies.activityReporting.button.default":
    "Analyser les discussions",
  "admin.page.companies.activityReporting.button.loading":
    "Analyse des discussions...",
  "admin.page.companies.activityReporting.toast.generate.success":
    "L’analyse des discussions est terminée.",
  "admin.page.companies.activityReporting.toast.generate.error":
    "Impossible d’analyser les discussions.",
  "admin.page.companies.activityReporting.toast.autoSave.success":
    "Le paramètre d’analyse automatique a été mis à jour.",
  "admin.page.companies.activityReporting.toast.autoSave.error":
    "Impossible de mettre à jour l’analyse automatique.",

  "admin.page.users.all.table.title": "Utilisateurs",
  "admin.page.users.all.table.id": "Id",
  "admin.page.users.all.table.name": "Nom",
  "admin.page.users.all.table.mail": "Mail",
  "admin.page.users.all.noUsers": "Il n'y a pas d'utilisateur pour l'instant.",
  "admin.page.users.crud.edit.title": "Editer Utilisateur",
  "admin.page.users.crud.update.success":
    "L'utilisateur a été mis à jour avec succès",

  "admin.page.agents.all.table.title": "Agents",
  "admin.page.agents.all.table.id": "Id",
  "admin.page.agents.all.table.name": "Nom",
  "admin.page.agents.all.table.isDefault": "Par défaut",
  "admin.page.agents.all.table.company": "Société",
  "admin.page.agents.all.table.companyId": "Id de la société",
  "admin.page.agents.all.table.implementation": "Type d’Agent",
  "admin.page.agents.all.filters.implementation": "Type d’Agent",
  "admin.page.agents.all.filters.allImplementations": "Tous les types d’Agent",
  "admin.page.agents.all.filters.allCompanies": "Afficher toutes les sociétés",
  "admin.page.agents.all.implementation.unassigned": "Legacy / non assigné",
  "admin.page.agents.all.company.unnamed": "Société sans nom",
  "admin.page.agents.all.company.none": "Aucune société",
  "admin.page.agents.all.noAgents": "Il n'y a pas d'agent pour l'instant",
  "admin.page.agents.crud.edit.title": "Editer un agent",
  "admin.page.agents.crud.edit.modernTitle": "Modifier {name}",
  "admin.page.agents.crud.edit.eyebrow":
    "Configuration de l'Agent · #{agentId}",
  "admin.page.agents.crud.edit.subtitle":
    "Consultez sa configuration, comprenez le prompt qu'il reçoit et gérez ses connaissances et capacités connectées.",
  "admin.page.agents.crud.edit.back": "Retour aux Agents",
  "admin.page.agents.crud.edit.save": "Enregistrer les modifications",
  "admin.page.agents.crud.edit.loadError": "Impossible de charger cet Agent.",
  "admin.page.agents.crud.edit.nav.configuration": "Configuration",
  "admin.page.agents.crud.edit.nav.prompt": "Prompt",
  "admin.page.agents.crud.edit.nav.catalogs": "Catalogues",
  "admin.page.agents.crud.edit.nav.tools": "Tools",
  "admin.page.agents.crud.edit.configuration.title": "Configuration générale",
  "admin.page.agents.crud.edit.configuration.description":
    "Identité, présentation, runtime et paramètres persistés de l'Agent.",
  "admin.page.agents.crud.edit.catalogs.description":
    "Sources de connaissance actuellement connectées à cet Agent.",
  "admin.page.agents.crud.update.success":
    "L'agent a été mis à jour avec succès",

  "admin.page.catalogs.all.table.title": "Catalogues",
  "admin.page.catalogs.all.table.id": "Id",
  "admin.page.catalogs.all.table.name": "Nom",
  "admin.page.catalogs.all.table.agentId": "Id agent",
  "admin.page.catalogs.all.nocatalogs":
    "Il n'y a pas de catalogues pour l'instant",
  "admin.page.companies.crud.edit.catalogDisplayed.title":
    "Catalogues de l'agent",
  "admin.page.catalogs.crud.edit.title": "Editer un catalogue",
  "admin.page.catalogs.crud.update.success":
    "Le catalogue a été mis à jour avec succès",

  "myAccount.page.oneSession.title": "Discussion Utilisateur",
  "myAccount.discussion.load.loading": "Chargement de la discussion…",
  "myAccount.discussion.load.error.title":
    "Impossible d’afficher cette discussion",
  "myAccount.discussion.load.error.description":
    "La discussion n’a pas pu être chargée. Réessayez dans un instant.",
  "myAccount.discussion.load.retry": "Réessayer",
  "myAccount.page.oneSession.": "Discussion Utilisateur",

  "myAccount.page.myChatbot.errorBlockingAgentDisplay":
    "Certaines erreurs empêchent le chatbot de s'afficher.",
  "myAccount.page.myChatbot.noSearchFilter.title": "Pas de filtre de recherche",
  "myAccount.page.myChatbot.noSearchFilter":
    "Vous n'avez pas configuré de filtres de recherche pour votre catalogue. Il ne peut donc pas utiliser de critères de recherche. Merci de les mettre en place.",
  "myAccount.page.myChatbot.noProducts.title": "Pas de produits",
  "myAccount.page.myChatbot.noProducts":
    "Vous n'avez ajouté aucun produit pour votre chatbot. Cela signifie qu'il ne peut rien proposer. Merci de les ajouter.",
  "myAccount.page.myChatbot.noCatalogs.title": "Pas de catalogue",

  "myAccount.page.myChatbot.noCatalogs":
    "Vous n'avez aucun catalogue de produits pour votre chatbot. Cela signifie qu'il ne peut rechercher quoi que ce soit. Merci d'en créer au moins un, de lui ajouter des filtres de recherche, et d'ajouter les produits.",

  "admin.page.leftMenu.entity": "Entités",
  "admin.page.leftMenu.kpis": "KPIs",
  "admin.page.leftMenu.workflow": "Workflow",
  "admin.page.leftMenu.entities.companies": "Sociétés",
  "admin.page.leftMenu.entities.agents": "Agents",
  "admin.page.leftMenu.entities.users": "Utilisateurs",
  "admin.page.leftMenu.entities.catalogs": "Catalogues",
  "admin.page.leftMenu.workflow.onboard": "Onboard Manuel",
  "admin.page.leftMenu.adminTokens": "Tokens API Admin",

  "admin.apiTokens.title": "Tokens API Admin",
  "admin.apiTokens.subtitle": "Acces API Admin",
  "admin.apiTokens.description":
    "Creez un refresh token et frappez des JWT d'acces courts pour l'acces admin programmatique.",
  "admin.apiTokens.create.title": "Creer un token",
  "admin.apiTokens.create.name": "Nom du token",
  "admin.apiTokens.create.scopes": "Scopes",
  "admin.apiTokens.create.scopesHelp": "Laissez '*' pour un acces total.",
  "admin.apiTokens.create.expires": "Expiration (jours)",
  "admin.apiTokens.create.expiresHelp":
    "Si vide, le token n'expire pas (jusqu'a revocation).",
  "admin.apiTokens.create.cta": "Creer le token",
  "admin.apiTokens.working": "En cours...",
  "admin.apiTokens.refreshOnce": "Refresh token (affiche une seule fois)",
  "admin.apiTokens.refreshOnce.help":
    "Copiez et stockez-le maintenant (gestionnaire de mots de passe / coffre / secrets CI).",
  "admin.apiTokens.tokenLabel": "Token",
  "admin.apiTokens.important": "Important",
  "admin.apiTokens.warning.once":
    "Vous ne pourrez plus afficher ce refresh token.",
  "admin.apiTokens.warning.rotation":
    "Les refresh tokens tournent : chaque mint renvoie un NOUVEAU refresh token et revoque l'ancien.",
  "admin.apiTokens.mint.title": "Frapper un access token",
  "admin.apiTokens.mint.refreshLabel": "Refresh token",
  "admin.apiTokens.mint.cta": "Frapper un access token",
  "admin.apiTokens.mint.accessLabel": "Access token (JWT)",
  "admin.apiTokens.mint.rotationTitle": "Refresh token tourne",
  "admin.apiTokens.mint.rotationBody":
    "Un nouveau refresh token a ete emis. Mettez a jour votre token stocke.",
  "admin.apiTokens.mint.newRefresh": "Nouveau refresh token",
  "admin.apiTokens.existing": "Tokens existants",
  "admin.apiTokens.revokeAll": "Tout revoquer",
  "admin.apiTokens.none": "Aucun token pour le moment.",
  "admin.apiTokens.revoke": "Revoquer",
  "admin.apiTokens.tip":
    "Astuce : les refresh tokens tournent automatiquement lors du mint d'access tokens.",

  "admin.session.cost": "Coût (centimes)",
  "admin.session.company": "Entreprise",
  "admin.session.oneSession.cost": "Coût (centimes)",
  "admin.session.oneSession.message.functionUsed": "Fonction: ",
  "admin.session.oneSession.message.model": "Modèle: ",
  "admin.session.oneSession.message.provider": "Provider: ",
  "admin.session.oneSession.message.duration": "Durée: ",
  "admin.session.oneSession.message.cost": "Coût (centimes)",
  "admin.subscriptionFormula.add": "Créer une offre",
  "admin.subscriptionFormula.id": "Id",
  "admin.subscriptionFormula.fixedPrice": "Prix de base",
  "admin.subscriptionFormula.BSPriceResell": "tarif User Discussion",
  "admin.subscriptionFormula.isDisplayedOnFrontEnd": "Visible Front",
  "admin.subscriptionFormula.subscriptionType": "Type de Subscription",
  "admin.subscriptionFormula.noOne":
    "Il n'existe pas de formules d'abonnement pour l'instant",
  "admin.subscriptionFormula.page.create.title":
    "Créer une nouvelle Formule d'abonnement",
  "admin.companyPicker.label": "Société",
  "admin.companyPicker.placeholder": "Rechercher par nom ou e-mail…",
  "admin.companyPicker.loading": "Recherche…",
  "admin.companyPicker.empty": "Aucune société trouvée.",
  "admin.companyPicker.error": "Impossible de charger les sociétés.",
  "admin.companyPicker.unnamed": "Société sans nom",
  "admin.companyPicker.selected": "Sélection : {name} (société n° {id})",
  "admin.subscriptionOffer.list.eyebrow": "Opérations de facturation",
  "admin.subscriptionOffer.list.description":
    "Créez, versionnez et publiez des conditions commerciales publiques en libre-service ou réservées à une société. Les brouillons ne créent aucune ressource Stripe.",
  "admin.subscriptionOffer.list.loading": "Chargement des offres…",
  "admin.subscriptionOffer.list.name": "Nom",
  "admin.subscriptionOffer.list.scope": "Périmètre",
  "admin.subscriptionOffer.list.lifecycle": "Cycle de vie",
  "admin.subscriptionOffer.list.usageMode": "Contrôle d’usage",
  "admin.subscriptionOffer.list.version": "Version",
  "admin.subscriptionOffer.list.lines": "Lignes tarifaires",
  "admin.subscriptionOffer.scope.public": "Publique",
  "admin.subscriptionOffer.scope.private": "Privée",
  "admin.subscriptionOffer.scope.company": "Société n° {id}",
  "admin.subscriptionOffer.unnamed": "Offre sans nom",
  "admin.subscriptionOffer.create.eyebrow": "Offre commerciale",
  "admin.subscriptionOffer.create.title":
    "Préparer les conditions sans toucher à Stripe",
  "admin.subscriptionOffer.create.description":
    "L’enregistrement crée un brouillon interne sans effet client. Vérifiez-le sur l’écran suivant, puis publiez-le explicitement avant d’attribuer un contrat.",
  "admin.subscriptionOffer.create.saveDraft": "Enregistrer le brouillon",
  "admin.subscriptionOffer.create.saving": "Enregistrement…",
  "admin.subscriptionOffer.create.success": "Brouillon d’offre créé.",
  "admin.subscriptionOffer.create.error": "Impossible de créer l’offre.",
  "admin.subscriptionOffer.edit.eyebrow": "Brouillon modifiable",
  "admin.subscriptionOffer.edit.title": "Corriger l’offre avant sa publication",
  "admin.subscriptionOffer.edit.description":
    "Ces changements remplacent uniquement ce brouillon local. Ils ne créent ni ne modifient aucune ressource Stripe.",
  "admin.subscriptionOffer.edit.success": "Brouillon d’offre mis à jour.",
  "admin.subscriptionOffer.edit.submit": "Enregistrer les modifications",
  "admin.subscriptionOffer.edit.action": "Modifier le brouillon",
  "admin.subscriptionOffer.edit.unavailable.title":
    "Cette offre ne peut plus être modifiée",
  "admin.subscriptionOffer.edit.unavailable.description":
    "Seul un brouillon local peut être modifié. Les conditions publiées restent immuables.",
  "admin.subscriptionOffer.version.eyebrow": "Nouvelle version commerciale",
  "admin.subscriptionOffer.version.title": "Préparer la version {version}",
  "admin.subscriptionOffer.version.description":
    "Modifiez les conditions copiées en toute sécurité. La version publiée et ses contrats restent inchangés jusqu’à la publication de ce brouillon.",
  "admin.subscriptionOffer.version.success":
    "La prochaine version de l’offre a été créée comme brouillon.",
  "admin.subscriptionOffer.version.action": "Préparer la version {version}",
  "admin.subscriptionOffer.version.unavailable.title":
    "Cette offre ne peut pas démarrer une nouvelle version",
  "admin.subscriptionOffer.version.unavailable.description":
    "Utilisez une offre publiée ou retirée. Une offre privée exige aussi que sa société existe toujours.",
  "admin.subscriptionOffer.create.scope.eyebrow": "Périmètre de l’offre",
  "admin.subscriptionOffer.create.scope.title":
    "Nommez l’offre et choisissez son audience",
  "admin.subscriptionOffer.create.scope.description":
    "Une offre publique est disponible pour toutes les sociétés. Une offre privée est réservée à une société sélectionnée.",
  "admin.subscriptionOffer.create.visibility.label": "Audience de l’offre",
  "admin.subscriptionOffer.visibility.public": "Publique / libre-service",
  "admin.subscriptionOffer.visibility.public.help":
    "Publiée en ligne pour toutes les sociétés et éligible au catalogue tarifaire public.",
  "admin.subscriptionOffer.visibility.private": "Privée / dédiée à une société",
  "admin.subscriptionOffer.visibility.private.help":
    "Disponible uniquement pour la société sélectionnée après publication.",
  "admin.publicOfferCatalog.eyebrow": "Catalogue public libre-service",
  "admin.publicOfferCatalog.title":
    "Organiser la page tarifaire au même endroit",
  "admin.publicOfferCatalog.description":
    "Chaque offre publique publiée et prête sur Stripe apparaît ici. Réordonnez les cartes et choisissez exactement une recommandation, puis enregistrez ces deux décisions ensemble.",
  "admin.publicOfferCatalog.familyTitle":
    "Organiser les familles tarifaires au même endroit",
  "admin.publicOfferCatalog.familyDescription":
    "Regroupez une offre mensuelle et une offre annuelle sous une même carte. Les versions publiées restent immuables ; seule leur présentation publique est organisée ici.",
  "admin.publicOfferCatalog.familyRecommendation.required":
    "Choisissez l’unique famille tarifaire à présenter comme recommandée avant d’enregistrer.",
  "admin.publicOfferCatalog.familyName": "Nom de la famille tarifaire",
  "admin.publicOfferCatalog.familySeparate":
    "Séparer cette variante dans sa propre famille",
  "admin.publicOfferCatalog.familyMissingVariant": "Aucune variante publiée",
  "admin.publicOfferCatalog.familyPairWith":
    "Associer à une famille compatible",
  "admin.publicOfferCatalog.familyPairChoose": "Choisir l’autre variante…",
  "admin.publicOfferCatalog.familyRecommended": "Famille recommandée",
  "admin.publicOfferCatalog.save": "Enregistrer la présentation tarifaire",
  "admin.publicOfferCatalog.saving": "Enregistrement…",
  "admin.publicOfferCatalog.save.success":
    "Présentation tarifaire publique enregistrée.",
  "admin.publicOfferCatalog.save.error":
    "Impossible d’enregistrer la présentation tarifaire publique.",
  "admin.publicOfferCatalog.empty":
    "Aucune offre publique n’est encore en ligne. Publiez un brouillon public pour ajouter automatiquement sa première carte.",
  "admin.publicOfferCatalog.recommendation.required":
    "Choisissez l’unique offre à présenter comme recommandée avant d’enregistrer.",
  "admin.publicOfferCatalog.recommended": "Recommandée",
  "admin.publicOfferCatalog.moveUp": "Remonter {name}",
  "admin.publicOfferCatalog.moveDown": "Descendre {name}",
  "admin.publicOfferCatalog.custom.last":
    "La carte de contact est gérée par ChatSystem et reste toujours en dernière position.",
  "admin.subscriptionOffer.help.open": "Expliquer ce champ",
  "admin.subscriptionOffer.create.name.label": "Nom interne de l’offre",
  "admin.subscriptionOffer.create.name.placeholder":
    "Par exemple : Playin annuel 2026",
  "admin.subscriptionOffer.create.name.help":
    "Référence réservée à l’exploitation pour retrouver et auditer cette version exacte. Le client ne la voit jamais.",
  "admin.subscriptionOffer.create.customerFacingName.label": "Nom commercial",
  "admin.subscriptionOffer.create.customerFacingName.placeholder":
    "Par exemple : ChatSystem Annuel",
  "admin.subscriptionOffer.create.customerFacingName.help":
    "Nom commercial affiché au client dans ChatSystem, le paiement Stripe, la facture et le portail de facturation. Il reste stable quand la version interne change.",
  "admin.subscriptionOffer.create.companyLocked":
    "Société n° {id} · identique pour toutes les versions de cette offre",
  "admin.subscriptionOffer.create.usageMode.label": "Mode de contrôle d’usage",
  "admin.subscriptionOffer.create.usageMode.help":
    "Ce choix décrit la politique de contrôle prévue. Son application en production restera désactivée tant que le déploiement de la facturation ne l’aura pas activée explicitement.",
  "admin.subscriptionOffer.flow.eyebrow": "Fonctionnement de l’offre",
  "admin.subscriptionOffer.flow.title": "Paiement, crédit, puis consommation",
  "admin.subscriptionOffer.flow.description":
    "Il s’agit de trois conditions distinctes. Le crédit inclus n’est pas un paiement. Un crédit positif exige un prélèvement récurrent, mais peut le dépasser lorsqu’il s’agit d’un avantage promotionnel volontaire.",
  "admin.subscriptionOffer.flow.promotion.title":
    "Avantage promotionnel d’usage",
  "admin.subscriptionOffer.flow.promotion.description":
    "{fixedPrice} prélevés pour {credit} de valeur d’usage : un avantage promotionnel de {advantage} ({multiplier}×). Cette configuration est autorisée et devra être confirmée explicitement lors de la publication.",
  "admin.subscriptionOffer.flow.notConfigured": "Non configuré",
  "admin.subscriptionOffer.flow.charge.step": "1 · Paiement du client",
  "admin.subscriptionOffer.flow.charge.title": "Stripe prélève",
  "admin.subscriptionOffer.flow.charge.detail": "une fois par {period}",
  "admin.subscriptionOffer.flow.budget.step": "2 · Capacité d’usage",
  "admin.subscriptionOffer.flow.budget.title": "ChatSystem accorde",
  "admin.subscriptionOffer.flow.budget.postpaid":
    "de dépense mensuelle maximale",
  "admin.subscriptionOffer.flow.budget.uncapped.value":
    "Aucun plafond contractuel",
  "admin.subscriptionOffer.flow.budget.uncapped":
    "tous les usages tarifés sont facturés ensuite",
  "admin.subscriptionOffer.flow.budget.credit": "de crédit d’usage partagé",
  "admin.subscriptionOffer.flow.usage.step": "3 · Consommation",
  "admin.subscriptionOffer.flow.usage.title": "Les usages débitent",
  "admin.subscriptionOffer.flow.usage.value":
    "{count, plural, =0 {Aucun tarif} one {# tarif} other {# tarifs}}",
  "admin.subscriptionOffer.flow.usage.detail": "réponses IA et outils tarifés",
  "admin.subscriptionOffer.funding.eyebrow": "2 · Capacité d’usage",
  "admin.subscriptionOffer.funding.title":
    "Choisir comment l’usage du client est financé et contrôlé",
  "admin.subscriptionOffer.funding.description":
    "Les réponses finales de l’IA et les outils tarifés partagent cette politique. Les crédits et plafonds sont des capacités monétaires ; l’usage privé sans plafond est intégralement facturé après consommation.",
  "admin.subscriptionOffer.funding.mode.label": "Financement de l’usage",
  "admin.subscriptionOffer.funding.mode.help":
    "Cette politique immuable détermine si l’usage est plafonné mensuellement, facturé sans plafond contractuel pour un client privé, déduit d’un crédit expirant ou déduit d’un crédit reportable.",
  "admin.subscriptionOffer.funding.mode.none":
    "Ancien mode non plafonné — indisponible pour les nouvelles offres",
  "admin.subscriptionOffer.funding.mode.postpaid":
    "Plafond mensuel facturé après consommation",
  "admin.subscriptionOffer.funding.mode.uncapped":
    "Usage postpayé sans plafond — offres privées uniquement",
  "admin.subscriptionOffer.funding.mode.periodic":
    "Crédit inclus expirant à chaque période de facturation",
  "admin.subscriptionOffer.funding.mode.periodic.monthly":
    "Crédit inclus renouvelé chaque mois — le reliquat expire mensuellement",
  "admin.subscriptionOffer.funding.mode.rolling":
    "Crédit prépayé reporté sur les périodes suivantes",
  "admin.subscriptionOffer.funding.none.description":
    "Ce mode historique n’arrête pas l’usage. Sélectionnez un budget plafonné avant d’enregistrer une nouvelle version de l’offre.",
  "admin.subscriptionOffer.funding.uncapped.title":
    "Usage facturé sans plafond contractuel",
  "admin.subscriptionOffer.funding.uncapped.description":
    "Chaque réponse et appel d’outil tarifé reste réservé, journalisé et facturé. Ce mode ne comporte ni recharge ni crédit inclus et ne peut être enregistré que pour une société sélectionnée.",
  "admin.subscriptionOffer.funding.postpaid.amount.label":
    "Plafond mensuel de dépense TTC (EUR)",
  "admin.subscriptionOffer.funding.postpaid.amount.help":
    "Dépense d’usage maximale autorisée pendant un mois. Seul l’usage réel est facturé ensuite.",
  "admin.subscriptionOffer.funding.postpaid.monthlyOnly":
    "Un plafond postpayé mensuel nécessite une offre mensuelle. Pour une offre annuelle, choisissez le crédit inclus mensuel ou un crédit prépayé reportable.",
  "admin.subscriptionOffer.funding.credit.monthly.amount.label":
    "Crédit d’usage renouvelé chaque mois (EUR)",
  "admin.subscriptionOffer.funding.credit.monthly.amount.help":
    "Crédit d’usage partagé intégral renouvelé chaque mois. Pour une offre annuelle, saisissez le montant mensuel et non douze mois de crédit. Ce champ ne crée aucun paiement.",
  "admin.subscriptionOffer.funding.credit.rolling.amount.label":
    "Crédit d’usage prépayé initial (EUR)",
  "admin.subscriptionOffer.funding.credit.rolling.amount.help":
    "Crédit d’usage partagé initial accordé au client et conservé sur les périodes suivantes. Ce champ ne crée aucun paiement.",
  "admin.subscriptionOffer.funding.credit.monthly.yearlyNotice":
    "Paiement annuel, crédit mensuel : saisissez ici un seul mois de crédit. Exemple : pour 9 € renouvelés chaque mois, saisissez 9 et non 108.",
  "admin.subscriptionOffer.funding.credit.monthly.monthlyNotice":
    "Ce montant intégral est renouvelé chaque mois. Le crédit inclus non consommé expire à la prochaine échéance mensuelle.",
  "admin.subscriptionOffer.funding.rechargeOptions.title":
    "Packs de recharge proposés au client (facultatif)",
  "admin.subscriptionOffer.funding.options.periodic.monthly.help":
    "Laissez vide pour désactiver les recharges. Le crédit acheté reste valable un mois à compter de la confirmation du paiement et est consommé après le crédit mensuel inclus.",
  "admin.subscriptionOffer.funding.options.periodic.yearly.help":
    "Laissez vide pour désactiver les recharges. Le crédit acheté reste valable douze mois à compter de la confirmation du paiement et est consommé après le crédit mensuel inclus.",
  "admin.subscriptionOffer.funding.options.rolling.help":
    "Laissez vide pour désactiver les recharges. Le paiement et le crédit d’usage accordé peuvent être identiques ou inclure un bonus promotionnel. Le crédit acheté reste disponible pendant les périodes de facturation suivantes.",
  "admin.subscriptionOffer.funding.options.add": "+ Ajouter un choix",
  "admin.subscriptionOffer.safety.fundingRequired":
    "Sélectionnez un budget d’usage plafonné. Une nouvelle offre ne peut pas donner un usage illimité.",
  "admin.subscriptionOffer.safety.includedCreditRecurringPaymentRequired":
    "Un crédit d’usage inclus positif exige un prix d’abonnement récurrent positif. Le crédit peut dépasser ce prix lorsqu’il s’agit d’un avantage promotionnel volontaire.",
  "admin.subscriptionOffer.safety.baselineRequired":
    "Ajoutez la composante Réponses de l’IA. Chaque réponse visible par le client doit consommer le budget partagé.",
  "admin.subscriptionOffer.safety.baselinePriceRequired":
    "Définissez un prix strictement positif pour les réponses de l’IA afin que le budget partagé puisse arrêter l’usage.",
  "admin.subscriptionOffer.safety.metricCatalogUnavailable":
    "Les métriques d’usage obligatoires n’ont pas pu être chargées. Actualisez la page avant de créer cette offre.",
  "admin.subscriptionOffer.funding.options.payment.label":
    "Pack {number} : paiement client TTC (EUR)",
  "admin.subscriptionOffer.funding.options.payment.help":
    "Montant prélevé immédiatement par Stripe lorsque le client achète ce pack.",
  "admin.subscriptionOffer.funding.options.credit.label":
    "Crédit d’usage accordé (EUR)",
  "admin.subscriptionOffer.funding.options.credit.help":
    "Valeur d’usage ajoutée au solde partagé du client après confirmation du paiement. Indiquez un montant supérieur pour créer un bonus promotionnel.",
  "admin.subscriptionOffer.funding.options.promotion":
    "Bonus promotionnel : {bonus} de valeur d’usage supplémentaire.",
  "admin.subscriptionOffer.funding.options.creditBelowPayment":
    "Le crédit d’usage accordé doit être au moins égal au montant payé.",
  "admin.subscriptionOffer.list.usageFunding": "Financement de l’usage",
  "admin.subscriptionOffer.details.usageFunding": "Financement de l’usage",
  "admin.subscriptionOffer.create.interval.label": "Période de facturation",
  "admin.subscriptionOffer.create.interval.help":
    "Toutes les composantes fixes et à l’usage suivent cette période. Publiez une nouvelle version de l’offre pour la modifier.",
  "admin.subscriptionOffer.interval.monthly": "Mensuelle",
  "admin.subscriptionOffer.interval.yearly": "Annuelle",
  "admin.subscriptionOffer.interval.monthly.short": "mois",
  "admin.subscriptionOffer.interval.yearly.short": "an",
  "admin.subscriptionOffer.details.interval": "Période de facturation",
  "admin.subscriptionOffer.create.paymentGracePeriod.label":
    "Délai de grâce de paiement (heures)",
  "admin.subscriptionOffer.create.paymentGracePeriod.help":
    "Après un échec de paiement récupérable, l’accès reste disponible pendant cette durée. Utilisez 0 pour suspendre immédiatement l’accès.",
  "admin.subscriptionOffer.details.paymentGracePeriod":
    "Délai de grâce de paiement",
  "admin.subscriptionOffer.details.paymentGracePeriod.value":
    "{hours, plural, =0 {Suspension immédiate} one {# heure} other {# heures}}",
  "admin.subscriptionOffer.usageMode.observeOnly":
    "Observation — mesurer l’usage sans bloquer",
  "admin.subscriptionOffer.usageMode.hardCap":
    "Plafond inclus — arrêter lorsque la limite est atteinte",
  "admin.subscriptionOffer.usageMode.overage":
    "Dépassement facturé — facturer au-delà du volume inclus",
  "admin.subscriptionOffer.create.pricing.title": "Composantes tarifaires",
  "admin.subscriptionOffer.create.pricing.description":
    "Combinez si nécessaire un montant fixe récurrent et des composantes à l’usage. Les montants sont saisis TTC.",
  "admin.subscriptionOffer.create.pricing.empty":
    "Ajoutez au moins une composante tarifaire.",
  "admin.subscriptionOffer.create.addFixed": "+ Montant fixe",
  "admin.subscriptionOffer.create.addMetered": "+ Usage mesuré",
  "admin.subscriptionOffer.create.fixed.eyebrow": "1 · Paiement du client",
  "admin.subscriptionOffer.create.fixed.title":
    "Définir le prix récurrent de l’abonnement",
  "admin.subscriptionOffer.create.fixed.description":
    "C’est le montant prélevé par Stripe à chaque période de facturation. Un crédit inclus positif exige un prix d’abonnement positif, mais peut volontairement offrir davantage de valeur d’usage que le montant prélevé.",
  "admin.subscriptionOffer.create.fixed.empty.title":
    "Aucun paiement client récurrent",
  "admin.subscriptionOffer.create.fixed.empty.description":
    "Ajoutez un montant fixe si cette offre accorde du crédit d’usage. Le champ de crédit ne prélève jamais le client à lui seul.",
  "admin.subscriptionOffer.create.metered.eyebrow": "3 · Consommation",
  "admin.subscriptionOffer.create.metered.title":
    "Tarifer ce qui consomme le budget d’usage",
  "admin.subscriptionOffer.create.metered.description":
    "Chaque réponse finale de l’IA et chaque outil sélectionné déduit son montant du budget partagé.",
  "admin.subscriptionOffer.create.metered.empty":
    "Ajoutez au minimum le tarif de la réponse finale de l’IA afin que l’usage soit toujours plafonné.",
  "admin.subscriptionOffer.line.fixed": "Fixe",
  "admin.subscriptionOffer.line.metered": "À l’usage",
  "admin.subscriptionOffer.line.nickname.placeholder":
    "Nom de la ligne (facultatif)",
  "admin.subscriptionOffer.line.remove": "Retirer",
  "admin.subscriptionOffer.fixed.price":
    "Montant fixe par période de facturation TTC (EUR)",
  "admin.subscriptionOffer.fixed.price.placeholder": "Par exemple : 29,00",
  "admin.subscriptionOffer.fixed.price.help":
    "Montant récurrent prélevé une fois par période choisie. Pour une offre annuelle, saisissez le montant annuel complet.",
  "admin.subscriptionOffer.price.invalid":
    "Saisissez un montant valide avec au plus deux décimales.",
  "admin.subscriptionOffer.meter.trigger": "Événement d’usage",
  "admin.subscriptionOffer.meter.trigger.help":
    "Événement versionné mesuré par ChatSystem. Le choisir fixe aussi son unité, son agrégation et la taille de ses blocs.",
  "admin.subscriptionOffer.meter.metric.select": "Choisir l’usage mesuré",
  "admin.subscriptionOffer.metric.conversation.started.v1.name":
    "Conversations démarrées",
  "admin.subscriptionOffer.metric.conversation.started.v1.description":
    "Compte les conversations créées pour la société pendant la période de facturation.",
  "admin.subscriptionOffer.metric.ai.tokens.v1.name": "Jetons d’IA",
  "admin.subscriptionOffer.metric.ai.tokens.v1.description":
    "Additionne les jetons d’entrée et de sortie enregistrés pour les conversations de la société.",
  "admin.subscriptionOffer.metric.provider.brave.request.v1.name":
    "Requêtes Brave Search",
  "admin.subscriptionOffer.metric.provider.brave.request.v1.description":
    "Compte les requêtes Brave Search enregistrées pour la société.",
  "admin.subscriptionOffer.meter.trigger.placeholder":
    "Par exemple : DISCUSSION_ENDED",
  "admin.subscriptionOffer.meter.unit": "Unité mesurée",
  "admin.subscriptionOffer.meter.unit.help":
    "Unité brute canonique émise par l’événement d’usage choisi. Elle est fixée par la définition de la métrique et ne peut pas varier entre les offres.",
  "admin.subscriptionOffer.meter.unit.select": "Choisir une unité",
  "admin.subscriptionOffer.meter.aggregation": "Agrégation",
  "admin.subscriptionOffer.meter.aggregation.help":
    "Façon dont les événements mesurés sont combinés. Les métriques canoniques de lancement utilisent une somme ; cette valeur vient du registre des métriques.",
  "admin.subscriptionOffer.meter.aggregation.select": "Choisir une agrégation",
  "admin.subscriptionOffer.meter.scale": "Unités par bloc facturé",
  "admin.subscriptionOffer.meter.scale.help":
    "Nombre d’unités brutes représentées par un bloc tarifé. Par exemple, 1 000 000 de jetons par bloc.",
  "admin.subscriptionOffer.meter.scale.placeholder": "Par exemple : 1 ou 1000",
  "admin.subscriptionOffer.meter.pricingMode": "Méthode tarifaire",
  "admin.subscriptionOffer.meter.pricingMode.select": "Choisir une méthode",
  "admin.subscriptionOffer.meter.pricingMode.help":
    "Le prix de vente explicite utilise le prix client saisi. Coût majoré reste réservé à l’analyse et ne peut pas encore être publié.",
  "admin.subscriptionOffer.meter.cost": "Coût par bloc TTC (EUR)",
  "admin.subscriptionOffer.meter.cost.help":
    "Coût interne estimé pour un bloc facturé. Cette donnée sert uniquement à l’analyse et n’est jamais affichée au client.",
  "admin.subscriptionOffer.meter.cost.placeholder": "Par exemple : 0,08",
  "admin.subscriptionOffer.meter.margin": "Marge cible (%)",
  "admin.subscriptionOffer.meter.margin.help":
    "Objectif d’analyse comparé au coût interne. Les offres à coût majoré restent en brouillon tant que leur politique tarifaire n’est pas reproductible.",
  "admin.subscriptionOffer.meter.margin.placeholder": "Par exemple : 40",
  "admin.subscriptionOffer.meter.sell": "Prix de vente par bloc TTC (EUR)",
  "admin.subscriptionOffer.meter.sell.placeholder": "Par exemple : 0,12",
  "admin.subscriptionOffer.meter.sell.help":
    "Prix TTC facturé au client pour un bloc. Toutes les lignes d’usage tarifées consomment la capacité monétaire partagée de l’offre.",
  "admin.subscriptionOffer.lines.included": "Usage inclus :",
  "admin.subscriptionOffer.lines.hardCap": "Plafond d’usage :",
  "admin.subscriptionOffer.lines.legacyAllowance":
    "Ancienne allocation par métrique (lecture seule)",
  "admin.subscriptionOffer.lines.rechargePack":
    "Lot d’usage propre à la métrique :",
  "admin.subscriptionOffer.publish.confirm":
    "Publier cette offre en ligne ? Ses conditions seront figées et ChatSystem créera ou vérifiera son produit, ses prix, ses compteurs Stripe et le portail de facturation sécurisé.",
  "admin.subscriptionOffer.publish.uncappedPostpaid":
    "l’usage postpayé privé ne comporte aucun plafond contractuel ; chaque événement tarifé sera facturé après consommation",
  "admin.subscriptionOffer.publish.confirmReviewedTerms":
    "Publier cette offre avec ces conditions ?\n• {terms}\n\nConfirmez que chaque condition est volontaire. Les conditions seront ensuite figées et ChatSystem préparera Stripe.",
  "admin.subscriptionOffer.publish.promotion.includedCredit":
    "abonnement : {fixedPrice} prélevés pour {credit} de valeur d’usage",
  "admin.subscriptionOffer.publish.promotion.rechargePack":
    "recharge : {price} prélevés pour {credit} de crédit d’usage (+{bonus} offerts)",
  "admin.subscriptionOffer.publish.error":
    "La publication en ligne n’a pas pu être terminée. Vous pouvez la relancer sans risque.",
  "admin.subscriptionOffer.publish.success":
    "Offre publiée en ligne. Stripe Checkout et la gestion de facturation sont prêts.",
  "admin.subscriptionOffer.publish.publishing": "Publication…",
  "admin.subscriptionOffer.publish.action": "Publier avec paiement Stripe",
  "admin.subscriptionOffer.publishOffline.confirm":
    "Publier cette offre privée pour facturation manuelle ? Ses conditions seront figées sans créer de ressource Stripe.",
  "admin.subscriptionOffer.publishOffline.confirmReviewedTerms":
    "Publier cette offre avec ces conditions ?\n• {terms}\n\nConfirmez que chaque condition est volontaire. Les conditions seront ensuite figées pour une facturation manuelle hors Stripe.",
  "admin.subscriptionOffer.publishOffline.exceptionWarning":
    "⚠️ EXCEPTION — FACTURATION MANUELLE\n\nCe mode est réservé aux contrats exceptionnels des grands comptes et doit rester très rare. Il ne crée aucun paiement Stripe ni aucun encaissement automatique.\n\nAvant de continuer, vérifiez que :\n• cette société doit volontairement être facturée hors Stripe ;\n• la société sélectionnée et tous les tarifs sont corrects ;\n• un opérateur émettra, suivra et enregistrera chaque facture et chaque règlement.\n\nAu moindre doute, annulez maintenant et revérifiez l’offre ainsi que l’accord client.",
  "admin.subscriptionOffer.publishOffline.error":
    "La publication pour facturation manuelle n’a pas pu être terminée. Vous pouvez la relancer sans risque.",
  "admin.subscriptionOffer.publishOffline.success":
    "Offre privée publiée pour facturation manuelle. Aucune ressource Stripe n’a été créée.",
  "admin.subscriptionOffer.publishOffline.action":
    "Publier en facturation manuelle",
  "admin.subscriptionOffer.publicationChoice.eyebrow":
    "Publication et encaissement",
  "admin.subscriptionOffer.publicationChoice.title":
    "Comment cette offre doit-elle être facturée ?",
  "admin.subscriptionOffer.publicationChoice.description":
    "Les deux choix figent la même version commerciale. Seuls le mode d’encaissement et la preuve du règlement diffèrent.",
  "admin.subscriptionOffer.publicationChoice.stripe.title":
    "Paiement automatique avec Stripe",
  "admin.subscriptionOffer.publicationChoice.stripe.description":
    "Crée ou vérifie les produits, prix et compteurs Stripe. Le client paie avec Checkout et gère sa facturation dans le portail sécurisé.",
  "admin.subscriptionOffer.publicationChoice.offline.title":
    "Facturation manuelle hors Stripe",
  "admin.subscriptionOffer.publicationChoice.offline.description":
    "Ne crée aucune ressource Stripe. ChatSystem journalise les usages tarifés ; un opérateur enregistre ensuite la facture et son règlement.",
  "admin.subscriptionOffer.details.back": "Retour aux offres",
  "admin.subscriptionOffer.details.notFound": "Offre d’abonnement introuvable.",
  "admin.subscriptionOffer.details.draft.title": "Vérifier avant de publier",
  "admin.subscriptionOffer.details.draft.description":
    "Ce brouillon n’a aucun effet sur l’accès client et n’a créé aucune ressource Stripe. Vérifiez son audience et chaque montant, puis publiez-le explicitement.",
  "admin.subscriptionOffer.details.company": "Société concernée",
  "admin.subscriptionOffer.details.internalName": "Référence interne",
  "admin.subscriptionOffer.details.commercialModel": "Modèle commercial",
  "admin.subscriptionOffer.details.offerKey.help":
    "Identité technique stable partagée par toutes les versions d’une même offre commerciale. Elle permet à ChatSystem de retirer la v1 et publier la v2 sans mélanger leurs contrats ni leurs ressources Stripe.",
  "admin.subscriptionOffer.details.usageMode": "Mode de contrôle d’usage",
  "admin.subscriptionOffer.details.commercialPolicy": "Politique commerciale",
  "admin.subscriptionOffer.details.created": "Créée",
  "admin.subscriptionOffer.details.published": "Publiée",
  "admin.subscriptionOffer.details.companies": "Clients attribués",
  "admin.subscriptionOffer.details.lines": "Composantes tarifaires",
  "admin.subscriptionOffer.details.entitlements": "Droits inclus",
  "admin.subscriptionOffer.details.pricing": "Conditions commerciales",
  "admin.subscriptionOffer.details.audience.public":
    "Publique en libre-service",
  "admin.subscriptionOffer.details.audience.private":
    "Offre privée pour une société",
  "admin.subscriptionOffer.details.audience.allCompanies":
    "Disponible pour toutes les sociétés",
  "admin.subscriptionOffer.details.visibility.public": "Offre publique",
  "admin.subscriptionOffer.details.visibility.private": "Offre privée",
  "admin.subscriptionOffer.details.visibility.help.open":
    "Expliquer l’audience de cette offre",
  "admin.subscriptionOffer.details.visibility.public.help":
    "Après sa publication avec Stripe, cette offre peut être souscrite par toutes les sociétés et apparaître dans le catalogue public /pricing.",
  "admin.subscriptionOffer.details.visibility.private.help":
    "Cette offre est réservée à {company}. Elle n’apparaît jamais dans le catalogue public /pricing et ne peut pas être attribuée à une autre société.",
  "admin.subscriptionOffer.details.hero.draft":
    "Vérifiez ci-dessous le prix client, l’usage inclus et chaque tarif à l’usage. La publication figera ces conditions ; choisissez ensuite le prélèvement en ligne avec Stripe ou la facturation manuelle pour une offre privée éligible.",
  "admin.subscriptionOffer.details.hero.published":
    "Ces conditions commerciales sont immuables. Préparez une nouvelle version pour les modifier sans altérer les contrats existants.",
  "admin.subscriptionOffer.details.missingRecurringPayment.title":
    "Publication bloquée : prélèvement récurrent manquant",
  "admin.subscriptionOffer.details.missingRecurringPayment.description":
    "Cette offre accorde {credit} d’usage sans prélèvement récurrent positif. Ajoutez un prix d’abonnement récurrent. Son montant peut rester inférieur au crédit lorsque cet avantage promotionnel est volontaire.",
  "admin.subscriptionOffer.details.promotion.title":
    "Valeur d’usage promotionnelle",
  "admin.subscriptionOffer.details.promotion.description":
    "Le client paie {fixedPrice} et reçoit {credit} de valeur d’usage par période de facturation. La différence de {advantage} est un avantage commercial volontaire, pas un paiement Stripe supplémentaire.",
  "admin.subscriptionOffer.details.promotion.rechargePack":
    "Prix payé par le client : {price} · Crédit d’usage ajouté : {credit} · Bonus promotionnel : +{bonus}.",
  "admin.subscriptionOffer.details.review.audience": "Audience",
  "admin.subscriptionOffer.summary.eyebrow": "Conditions client",
  "admin.subscriptionOffer.summary.title": "Ce que le client paie et reçoit",
  "admin.subscriptionOffer.summary.description":
    "Voici le contrat commercial qui sera figé lors de la publication de l’offre.",
  "admin.subscriptionOffer.summary.recurring.eyebrow": "Prélèvement récurrent",
  "admin.subscriptionOffer.summary.recurring.title": "Prix de l’abonnement",
  "admin.subscriptionOffer.summary.recurring.empty":
    "Aucun montant fixe récurrent n’est configuré pour cette offre.",
  "admin.subscriptionOffer.summary.fixedFallback": "Abonnement récurrent",
  "admin.subscriptionOffer.summary.perMonth": "par mois",
  "admin.subscriptionOffer.summary.perYear": "par an",
  "admin.subscriptionOffer.summary.usageBudget.eyebrow": "Budget d’usage",
  "admin.subscriptionOffer.summary.usageBudget.title":
    "Contrôle de la consommation",
  "admin.subscriptionOffer.summary.usageBudget.postpaid":
    "Montant maximal d’usage facturé pendant chaque période mensuelle.",
  "admin.subscriptionOffer.summary.usageBudget.uncapped.title":
    "Aucun plafond contractuel",
  "admin.subscriptionOffer.summary.usageBudget.uncapped":
    "Chaque événement d’usage tarifé est journalisé et facturé après consommation. Cette offre privée ne bloque pas à un plafond monétaire.",
  "admin.subscriptionOffer.summary.usageBudget.periodic":
    "Crédit d’usage inclus à chaque période ; le reliquat expire à l’échéance.",
  "admin.subscriptionOffer.summary.usageBudget.periodic.monthly":
    "Ce crédit d’usage intégral est renouvelé chaque mois ; le crédit inclus non consommé expire à la prochaine échéance mensuelle.",
  "admin.subscriptionOffer.summary.usageBudget.rolling":
    "Crédit d’usage inclus à l’activation ; le reliquat est conservé.",
  "admin.subscriptionOffer.summary.usageBudget.none":
    "Aucun budget d’usage plafonné n’est configuré.",
  "admin.subscriptionOffer.summary.creditCadence.label":
    "Cadence du crédit inclus",
  "admin.subscriptionOffer.summary.creditCadence.monthly":
    "Renouvelé chaque mois",
  "admin.subscriptionOffer.summary.creditCadence.billingPeriod":
    "Renouvelé à chaque période de facturation",
  "admin.subscriptionOffer.summary.recharges": "Packs de recharge facultatifs",
  "admin.subscriptionOffer.summary.recharges.pack": "Pack {number}",
  "admin.subscriptionOffer.summary.recharges.promotionalBadge":
    "Pack promotionnel",
  "admin.subscriptionOffer.summary.recharges.paidLabel":
    "Prix payé par le client",
  "admin.subscriptionOffer.summary.recharges.creditLabel":
    "Crédit d’usage ajouté",
  "admin.subscriptionOffer.summary.recharges.bonusLabel":
    "Bonus promotionnel inclus",
  "admin.subscriptionOffer.summary.recharges.noBonus": "Aucun bonus",
  "admin.subscriptionOffer.summary.recharges.validityLabel":
    "Validité du crédit",
  "admin.subscriptionOffer.summary.recharges.validityMonths":
    "{count, plural, one {# mois après le paiement} other {# mois après le paiement}}",
  "admin.subscriptionOffer.summary.recharges.validityLegacy":
    "Conditions historiques de la période",
  "admin.subscriptionOffer.summary.usagePrices.eyebrow": "Usage mesuré",
  "admin.subscriptionOffer.summary.usagePrices.title":
    "Ce qui consomme le budget",
  "admin.subscriptionOffer.summary.usagePrices.perBlock":
    "pour {count} unité(s) mesurée(s)",
  "admin.subscriptionOffer.economicsLink.eyebrow": "Analyse interne",
  "admin.subscriptionOffer.economicsLink.title":
    "Analyser la rentabilité séparément",
  "admin.subscriptionOffer.economicsLink.description":
    "Projetez les usages, les coûts fournisseur et la marge sans modifier cette offre ni la facturation client.",
  "admin.subscriptionOffer.economicsLink.action":
    "Ouvrir l’analyse de rentabilité",
  "admin.subscriptionOffer.technical.title":
    "Détails techniques et liaisons Stripe",
  "admin.subscriptionOffer.technical.description":
    "Identifiants stables, versions de politique, compteurs bruts et ressources prestataire.",
  "admin.subscriptionOffer.technical.offerKey": "Clé de l’offre",
  "admin.subscriptionOffer.technical.creditCadence": "Cadence du crédit inclus",
  "admin.subscriptionOffer.technical.rechargeValidity":
    "Validité du crédit de recharge",
  "admin.subscriptionOffer.technical.rechargeValidityPack":
    "Pack {number} : {months, plural, one {# mois} other {# mois}}",
  "admin.subscriptionOffer.technical.rechargeValidityNone":
    "Aucun pack de recharge",
  "admin.subscriptionOffer.technical.legacyDefault":
    "valeur historique par défaut",
  "admin.subscriptionOffer.lines.empty":
    "Cette offre ne contient aucune composante tarifaire.",
  "admin.subscriptionOffer.lines.type": "Type",
  "admin.subscriptionOffer.lines.name": "Nom",
  "admin.subscriptionOffer.lines.price": "Prix TTC",
  "admin.subscriptionOffer.lines.meter": "Mesure d’usage",
  "admin.subscriptionOffer.lines.provider":
    "Liaison au prestataire de paiement",
  "admin.subscriptionOffer.lines.kind": "Type :",
  "admin.subscriptionOffer.lines.amount": "Montant :",
  "admin.subscriptionOffer.lines.meteredAmount": "Défini par la mesure d’usage",
  "admin.subscriptionOffer.lines.unit": "Unité :",
  "admin.subscriptionOffer.lines.aggregation": "Agrégation :",
  "admin.subscriptionOffer.lines.trigger": "Événement :",
  "admin.subscriptionOffer.lines.scale": "Taille du bloc :",
  "admin.subscriptionOffer.lines.mode": "Méthode tarifaire :",
  "admin.subscriptionOffer.lines.cost": "Coût :",
  "admin.subscriptionOffer.lines.margin": "marge",
  "admin.subscriptionOffer.lines.sell": "Prix de vente :",
  "admin.subscriptionOffer.lines.priceId": "ID du prix :",
  "admin.subscriptionOffer.lines.meterId": "ID du compteur :",
  "admin.subscriptionOffer.lines.providerEvent": "Événement prestataire :",
  "admin.subscriptionOffer.simulation.eyebrow": "Économie de l’offre",
  "admin.subscriptionOffer.simulation.back": "Retour à l’offre",
  "admin.subscriptionOffer.simulation.page.eyebrow":
    "Aide à la décision interne",
  "admin.subscriptionOffer.simulation.page.title":
    "Analyse de rentabilité — {offer}",
  "admin.subscriptionOffer.simulation.page.description":
    "Comparez un scénario d’usage explicite aux coûts fournisseur, de paiement et d’exploitation avant de prendre une décision commerciale.",
  "admin.subscriptionOffer.simulation.page.safety":
    "Lecture seule : cette page ne modifie jamais l’offre, Stripe, l’usage mesuré ni l’accès client.",
  "admin.subscriptionOffer.simulation.title":
    "Simulateur de scénario commercial",
  "admin.subscriptionOffer.simulation.description":
    "Testez cette version exacte de l’offre avec un mix d’usage et des hypothèses de coût explicites. La simulation est en lecture seule et ne modifie jamais les prix, l’usage, les coûts fournisseur ni l’accès client.",
  "admin.subscriptionOffer.simulation.usageVersion":
    "Version du scénario d’usage",
  "admin.subscriptionOffer.simulation.assumptionVersion":
    "Version des hypothèses commerciales",
  "admin.subscriptionOffer.simulation.tax": "Taux de taxe (%)",
  "admin.subscriptionOffer.simulation.marginFloor":
    "Marge minimale requise (%)",
  "admin.subscriptionOffer.simulation.paymentRate":
    "Taux de frais de paiement (%)",
  "admin.subscriptionOffer.simulation.paymentFixed":
    "Frais de paiement fixes (EUR)",
  "admin.subscriptionOffer.simulation.operatingCost":
    "Coût d’infrastructure et de support alloué (EUR)",
  "admin.subscriptionOffer.simulation.metricMix": "Usage mesuré attendu",
  "admin.subscriptionOffer.simulation.blockSize":
    "Bloc de l’offre : {count} unités brutes",
  "admin.subscriptionOffer.simulation.expectedQuantity":
    "Quantité brute attendue",
  "admin.subscriptionOffer.simulation.costPerBlock":
    "Coût estimé par bloc (EUR)",
  "admin.subscriptionOffer.simulation.costVersion":
    "Version de l’hypothèse de coût",
  "admin.subscriptionOffer.simulation.running": "Calcul en cours…",
  "admin.subscriptionOffer.simulation.run": "Lancer la simulation",
  "admin.subscriptionOffer.simulation.precision":
    "Les montants acceptent six décimales et les pourcentages deux.",
  "admin.subscriptionOffer.simulation.invalid":
    "Complétez chaque hypothèse avec une valeur exacte positive ou nulle et une version.",
  "admin.subscriptionOffer.simulation.error":
    "Impossible d’exécuter la simulation commerciale.",
  "admin.subscriptionOffer.simulation.ready":
    "Le scénario respecte la marge minimale",
  "admin.subscriptionOffer.simulation.belowFloor":
    "Le scénario est sous la marge minimale",
  "admin.subscriptionOffer.simulation.noRevenue":
    "Le scénario ne produit aucun revenu client",
  "admin.subscriptionOffer.simulation.fingerprint": "Référence du scénario",
  "admin.subscriptionOffer.simulation.fixedRevenue": "Revenu fixe TTC",
  "admin.subscriptionOffer.simulation.meteredRevenue": "Revenu variable TTC",
  "admin.subscriptionOffer.simulation.revenueInclTax": "Revenu TTC",
  "admin.subscriptionOffer.simulation.revenueExTax": "Revenu HT",
  "admin.subscriptionOffer.simulation.variableCost": "Coût variable estimé",
  "admin.subscriptionOffer.simulation.operatingCostResult":
    "Coût d’exploitation alloué",
  "admin.subscriptionOffer.simulation.paymentCost": "Frais de paiement estimés",
  "admin.subscriptionOffer.simulation.totalCost": "Coût total estimé",
  "admin.subscriptionOffer.simulation.marginAmount": "Marge projetée",
  "admin.subscriptionOffer.simulation.metric": "Métrique",
  "admin.subscriptionOffer.simulation.expected": "Attendu / inclus",
  "admin.subscriptionOffer.simulation.billable": "Facturable",
  "admin.subscriptionOffer.simulation.metricRevenue": "Revenu client",
  "admin.subscriptionOffer.simulation.metricCost": "Coût estimé",
  "admin.subscriptionOffer.simulation.costVersionShort": "Version du coût",
  "admin.subscriptionOffer.simulation.hardCapWarning":
    "Le mix attendu dépasse au moins un plafond d’usage de l’offre ; il n’est pas atteignable sans capacité supplémentaire achetée.",
  "admin.page.leftMenu.entities.tools": "Outils",
  "admin.kpis.eyebrow": "Activité SaaS",
  "admin.kpis.title": "KPIs",
  "admin.kpis.subtitle":
    "Un tableau de bord transverse pour les discussions et l'usage des outils. Les données proviennent de read models de reporting pour garder le back office rapide.",
  "admin.kpis.lastUpdated": "Dernière mise à jour",
  "admin.kpis.refreshCadence":
    "Les vues matérialisées se rafraîchissent toutes les heures.",
  "admin.kpis.error":
    "Impossible de charger le tableau de bord KPI. Réessayez plus tard.",
  "admin.kpis.empty": "Aucune donnée KPI disponible pour le moment.",
  "admin.kpis.monthlyDiscussions.title": "Discussions mensuelles",
  "admin.kpis.monthlyDiscussions.subtitle":
    "Discussions racines non internes sur les {months} derniers mois, ventilées par société.",
  "admin.kpis.dailyDiscussions.title":
    "Discussions quotidiennes du mois en cours",
  "admin.kpis.dailyDiscussions.subtitle":
    "Discussions non internes du mois en cours, ventilées par société.",
  "admin.kpis.monthlyToolUsage.title": "Usage mensuel des outils",
  "admin.kpis.monthlyToolUsage.subtitle":
    "Appels d'outils sur les {months} derniers mois, ventilés par société.",
  "admin.page.tools.title": "Outils",
  "admin.page.tools.table.name": "Nom",
  "admin.page.tools.table.type": "Type",
  "admin.page.tools.table.execution": "Exécution",
  "admin.page.tools.table.active": "Actif",
  "admin.page.tools.table.public": "Public",
  "admin.page.tools.table.company": "Entreprise",
  "admin.page.tools.table.actions": "Actions",
  "admin.page.tools.scope.title": "Gestion de la disponibilité par entreprise",
  "admin.page.tools.scope.loadingTools": "Chargement des outils...",
  "admin.page.tools.scope.toolCount": "{count} outils",
  "admin.page.tools.scope.createTool": "Créer un outil",
  "admin.page.tools.scope.noToolsFound": "Aucun outil trouvé.",
  "admin.page.tools.scope.toolLabel": "Outil",
  "admin.page.tools.scope.selectTool": "Sélectionner un outil",
  "admin.page.tools.scope.companySearchLabel": "Recherche d'entreprise",
  "admin.page.tools.scope.companySearchPlaceholder":
    "Saisissez un nom d'entreprise...",
  "admin.page.tools.scope.searching": "Recherche...",
  "admin.page.tools.scope.noCompaniesFound": "Aucune entreprise trouvée.",
  "admin.page.tools.scope.selectedCompany": "Entreprise sélectionnée :",
  "admin.page.tools.scope.companyIdLabel": "ID",
  "admin.page.tools.scope.noCompanySelected": "Aucune entreprise sélectionnée.",
  "admin.page.tools.scope.company.noName": "(sans nom)",
  "admin.page.tools.scope.offerability.title": "Proposabilité de l'outil",
  "admin.page.tools.scope.offerability.subtitle":
    "Définissez quelle entreprise peut voir et recevoir cet outil.",
  "admin.page.tools.scope.offerability.originLabel":
    "Origine de proposabilité de l'outil",
  "admin.page.tools.scope.offerability.originPlaceholder": "admin",
  "admin.page.tools.scope.offerability.submit":
    "Créer / Mettre à jour la proposabilité",
  "admin.page.tools.scope.offerability.existing": "Proposabilités existantes",
  "admin.page.tools.scope.offerability.empty":
    "Aucune proposabilité pour cet outil.",
  "admin.page.tools.scope.activation.title": "Activation de l'outil",
  "admin.page.tools.scope.activation.subtitle":
    "Définissez si l'entreprise sélectionnée peut utiliser cet outil.",
  "admin.page.tools.scope.activation.submit":
    "Créer / Mettre à jour l'activation",
  "admin.page.tools.scope.activation.existing": "Activations existantes",
  "admin.page.tools.scope.activation.empty":
    "Aucune activation pour cet outil.",
  "admin.page.tools.scope.enabled": "Activé",
  "admin.page.tools.scope.disabled": "Désactivé",
  "admin.page.tools.scope.saving": "Enregistrement...",
  "admin.page.tools.scope.loading": "Chargement...",
  "admin.page.tools.scope.companyRow": "Entreprise {companyId}",
  "admin.page.tools.scope.remove": "Retirer",
  "admin.page.tools.scope.toast.loadTools.error":
    "Impossible de charger les outils",
  "admin.page.tools.scope.toast.loadOffers.error":
    "Impossible de charger les proposabilités d'outils",
  "admin.page.tools.scope.toast.loadActivations.error":
    "Impossible de charger les activations d'outils",
  "admin.page.tools.scope.toast.loadCompanies.error":
    "Impossible de charger les entreprises",
  "admin.page.tools.scope.toast.searchCompanies.error":
    "Impossible de rechercher les entreprises",
  "admin.page.tools.scope.toast.selectToolFirst":
    "Sélectionnez d'abord un outil.",
  "admin.page.tools.scope.toast.selectCompanyFirst":
    "Sélectionnez d'abord une entreprise.",
  "admin.page.tools.scope.toast.saveOffer.error":
    "Impossible d'enregistrer la proposabilité",
  "admin.page.tools.scope.toast.saveOffer.updated":
    "Proposabilité mise à jour.",
  "admin.page.tools.scope.toast.saveOffer.created": "Proposabilité créée.",
  "admin.page.tools.scope.toast.saveActivation.error":
    "Impossible d'enregistrer l'activation",
  "admin.page.tools.scope.toast.saveActivation.updated":
    "Activation mise à jour.",
  "admin.page.tools.scope.toast.saveActivation.created": "Activation créée.",
  "admin.page.tools.scope.toast.deleteOffer.error":
    "Impossible de supprimer la proposabilité",
  "admin.page.tools.scope.toast.deleteOffer.success":
    "Proposabilité supprimée.",
  "admin.page.tools.scope.toast.deleteActivation.error":
    "Impossible de supprimer l'activation",
  "admin.page.tools.scope.toast.deleteActivation.success":
    "Activation supprimée.",
  "admin.page.tools.scope.toast.toggleActivation.error":
    "Impossible de changer l'activation",
  "admin.page.agents.tools.title": "Outils de l'agent",
  "admin.page.agents.tools.description":
    "Gérez les capacités connectées à cet Agent et leur état d'activation.",
  "admin.page.agents.tools.attach.label": "Attacher un outil",
  "admin.page.agents.tools.attach.cta": "Attacher",
  "admin.page.agents.tools.table.tool": "Outil",
  "admin.page.agents.tools.table.type": "Type",
  "admin.page.agents.tools.table.enabled": "Actif",
  "admin.page.agents.tools.table.actions": "Actions",
  "admin.page.agents.tools.empty": "Aucun outil attaché pour le moment.",
  "admin.page.agents.tools.detach": "Détacher",

  "myAccount.page.myAgents.edit.tabs.search": "Recherche de produits",
  "myAccount.searchProfiles.legacy": "Hérité",
  "myAccount.searchProfiles.collection": "Collection de produits :",
  "myAccount.searchProfiles.collectionFallback": "Collection n°",
  "myAccount.searchProfiles.filters": "Filtres",
  "myAccount.searchProfiles.agents": "Agents",
  "myAccount.searchProfiles.edit": "Modifier le profil",
  "myAccount.searchProfiles.detach": "Détacher le profil",
  "myAccount.searchProfiles.assign": "Affecter le profil",
  "myAccount.searchProfiles.delete": "Supprimer le profil",
  "myAccount.searchProfiles.title": "Profils de recherche",
  "myAccount.tools.browse.all": "Tous",
  "myAccount.page.myAgents.edit.tools.urlEditor.label": "URL à consulter",
  "myAccount.page.myAgents.edit.tools.urlEditor.hint": "Saisissez une URL par ligne.",
  "myAccount.page.myAgents.edit.tools.urlEditor.placeholder": "https://www.mon-site.fr\nhttps://mon-autre-site.fr",
  "myAccount.tools.browse.loadError": "Vos outils n’ont pas pu être chargés. Pouvez-vous réessayer ?",
  "myAccount.tools.browse.retry": "Réessayer",
  "myAccount.tools.browse.support": "Support client",
  "myAccount.tools.browse.information": "Information",
  "myAccount.tools.browse.products": "Produits",
  "myAccount.tools.browse.other": "Autres",
  "myAccount.tools.browse.search": "Rechercher un outil",
  "myAccount.tools.browse.enabledOnly": "Activés",
  "myAccount.tools.browse.customOnly": "Personnalisés",
  "myAccount.tools.browse.categories": "Catégories d’outils",
  "myAccount.tools.browse.reset": "Effacer les filtres",
  "myAccount.tools.browse.configure": "Configurer",
  "myAccount.tools.browse.collapse": "Fermer les réglages",
  "myAccount.tools.browse.configureAria": "Configurer {name}",
  "myAccount.tools.browse.collapseAria": "Fermer les réglages de {name}",
  "myAccount.tools.browse.activationAria": "Activer {name} pour cet Agent",
  "myAccount.tools.browse.needsAttention": "À vérifier",
  "myAccount.tools.browse.issues": "{count, plural, one {Un outil est à vérifier avant l’enregistrement.} other {# outils sont à vérifier avant l’enregistrement.}}",
  "myAccount.tools.browse.showAll": "Afficher tous les outils",
  "myAccount.tools.browse.results": "{count, plural, =0 {Aucun outil ne correspond} one {Un outil affiché} other {# outils affichés}}",
  "myAccount.tools.browse.noResults": "Essayez un autre nom ou effacez les filtres pour retrouver vos outils.",
  "myAccount.searchProfiles.setup.title": "Aidez votre Agent à trouver les bons produits",
  "myAccount.searchProfiles.setup.scope": "Cet onglet concerne les suggestions de produits de votre Agent. Si vous n’utilisez pas cette fonctionnalité, vous pouvez le laisser de côté.",
  "myAccount.searchProfiles.setup.collection": "Préparez une collection avec ses champs de recherche, puis importez vos produits.",
  "myAccount.searchProfiles.setup.collectionsLink": "Mes collections",
  "myAccount.searchProfiles.setup.profile": "Créez un profil ci-dessous pour choisir les critères de recherche, ou affectez un profil existant à cet Agent.",
  "myAccount.searchProfiles.setup.tool": "Vérifiez qu’un outil de recherche de produits compatible est configuré et activé dans",
  "myAccount.searchProfiles.setup.availability": "Aucun outil de recherche proposé ? Contactez-nous pour préparer votre intégration. Un profil seul n’active pas la recherche.",
  "myAccount.searchProfiles.assignedCount":
    "{count, plural, =0 {Aucun profil affecté} one {# profil affecté} other {# profils affectés}} à cet agent",
  "myAccount.searchProfiles.deleteAction": "Supprimer",
  "myAccount.searchProfiles.new": "Nouveau profil",
  "myAccount.searchProfiles.loading": "Chargement...",
  "myAccount.searchProfiles.assigned": "Affectés",
  "myAccount.searchProfiles.assignedEmpty":
    "Aucun profil de recherche affecté.",
  "myAccount.searchProfiles.available": "Disponibles dans cette entreprise",
  "myAccount.searchProfiles.availableEmpty":
    "Aucun profil de recherche disponible.",
  "myAccount.searchProfiles.deleteConfirm": "Supprimer {name} ?",
  "myAccount.searchProfiles.editor.defaultFunctionDescription":
    "Rechercher les produits correspondants.",
  "myAccount.searchProfiles.editor.defaultBooleanDescription":
    "Le produit correspond-il à {field} ?",
  "myAccount.searchProfiles.editor.defaultFilterDescription":
    "Valeur recherchée pour {field}.",
  "myAccount.searchProfiles.editor.editTitle":
    "Modifier le profil de recherche",
  "myAccount.searchProfiles.editor.newTitle": "Nouveau profil de recherche",
  "myAccount.searchProfiles.editor.collection": "Collection de produits",
  "myAccount.searchProfiles.editor.function": "Fonction de recherche",
  "myAccount.searchProfiles.editor.functionName": "Nom de la fonction",
  "myAccount.searchProfiles.editor.functionDescription":
    "Description de la fonction",
  "myAccount.searchProfiles.editor.filters": "Filtres de recherche",
  "myAccount.searchProfiles.editor.productField": "Propriété du produit",
  "myAccount.searchProfiles.editor.selectField":
    "Sélectionner une propriété du produit",
  "myAccount.searchProfiles.editor.addFilter": "Ajouter un filtre",
  "myAccount.searchProfiles.editor.filtersEmpty":
    "Aucun filtre de recherche configuré.",
  "myAccount.searchProfiles.editor.filterName": "Nom du filtre",
  "myAccount.searchProfiles.editor.semanticDescription":
    "Description sémantique",
  "myAccount.searchProfiles.editor.required": "Obligatoire",
  "myAccount.searchProfiles.editor.removeFilter": "Supprimer le filtre",
  "myAccount.searchProfiles.toast.loadError":
    "Impossible de charger la configuration de recherche.",
  "myAccount.searchProfiles.toast.saveError":
    "Impossible d’enregistrer le profil de recherche.",
  "myAccount.searchProfiles.toast.saved": "Profil de recherche enregistré.",
  "myAccount.searchProfiles.toast.assignError":
    "Impossible d’affecter le profil de recherche.",
  "myAccount.searchProfiles.toast.detachError":
    "Impossible de détacher le profil de recherche.",
  "myAccount.searchProfiles.toast.deleteError":
    "Impossible de supprimer le profil de recherche.",

  "chatbot.placeholder.content": "Envoyez un message à l'assistant ...",
  "chatbot.chatline.label.user": "Vous",
  "chatbot.chatline.label.assistant": "Assistant",
  "chatbot.chatline.loading.function.search": "Recherche",
  "chatbot.chatline.loading.function.genericSearchMessage":
    "Je cherche des produits",
  "chatbot.chatline.loading.function.extractProductName":
    "Recherche dans la caverne",
  "chatbot.chatline.loading.function.suggestProductName":
    "Consultation des shadocks",
  "chatbot.chatline.loading.function.criteriaDefinition":
    "Recherche des ziboublis",
  "chatbot.chatline.loading.function.searchStock": "Recherche en stock",
  "chatbot.chatline.loading.function.step": "Etape",

  "footer.tab.title.general": "Général",
  "footer.tab.title.about": "A propos",
  "footer.tab.title.resources": "Ressources",
  "footer.tab.title.legal": "Mentions Légales",
  "footer.tab.title.social": "Social",
  "footer.tab.title.articles": "Articles",
  "footer.tab.title.chatbot": "Chatbot",
  "footer.tab.title.data_augmentation": "Augmentation de données",
  "footer.tab.search": "Rechercher",
  "footer.tab.pricing": "Tarifs",
  "footer.tab.termsAndConditions": "Termes et conditions",
  "footer.tab.documentation": "Documentation",
  "footer.link.email": "Email",
  "footer.gdpr.compliant": "Conforme au RGPD",
  "footer.tab.finalCopyright":
    "Copyright © 2026 Chatsystem, Inc. Tous droits réservés.",
  "common.copy": "Copier",
  "common.copied": "Copié",
  "common.loading": "Chargement…",
  "myAccount.page.leftMenu.identityDelegation": "Délégation d’identité",
  "identityDelegation.eyebrow": "Parcours développeur",
  "identityDelegation.title": "Délégation d’identité",
  "identityDelegation.documentation.metaTitle":
    "Guide d’intégration de la délégation d’identité | ChatSystem",
  "identityDelegation.documentation.metaDescription":
    "Connectez votre système de connexion à ChatSystem et sécurisez les actions réalisées pour vos utilisateurs.",
  "identityDelegation.subtitle":
    "Permettez à un agent d’effectuer des actions autorisées en lecture seule pour un utilisateur déjà connecté à votre site, sans exposer son cookie de session ni vos identifiants d’API au widget.",
  "identityDelegation.status.ready": "Prêt",
  "identityDelegation.status.actionRequired": "Action requise",
  "identityDelegation.refresh": "Actualiser l’état",
  "identityDelegation.readiness.title": "État de la configuration ChatSystem",
  "identityDelegation.readiness.progress":
    "{ready} étapes plateforme prêtes sur {total}",
  "identityDelegation.readiness.application": "Périmètre applicatif",
  "identityDelegation.readiness.mintKey": "Identifiant d’émission",
  "identityDelegation.readiness.delegatedTool": "Outil délégué",
  "identityDelegation.readiness.agentAssignment": "Affectation à l’agent",
  "identityDelegation.readiness.error":
    "Certaines informations n’ont pas pu être chargées. Actualisez pour réessayer.",
  "identityDelegation.readiness.boundary":
    "Cet état confirme uniquement les ressources enregistrées dans ChatSystem. Validez votre endpoint client et vos autorisations métier dans votre propre intégration avant d’utiliser l’outil avec vos clients.",
  "identityDelegation.application.title":
    "Choisir l’installation du widget et les sites autorisés",
  "identityDelegation.application.description":
    "L’app token identifie l’installation du widget utilisée par cette intégration. Les domaines autorisés sont les origines web qui peuvent initialiser ChatSystem ; ils protègent le widget dans son ensemble et n’activent pas la délégation d’identité domaine par domaine.",
  "identityDelegation.application.action": "Gérer les domaines autorisés",
  "identityDelegation.application.appToken": "App token du widget",
  "identityDelegation.application.noToken":
    "Aucun app token associé à cette entreprise",
  "identityDelegation.application.noTokenHelp":
    "Les app tokens sont normalement créés avec l’entreprise. Contactez le support ChatSystem avant de continuer si aucun jeton n’est affiché.",
  "identityDelegation.application.noCompanyHelp":
    "Votre utilisateur n’est associé à aucune entreprise. Associez ce compte à l’entreprise souhaitée avant de configurer cette intégration.",
  "identityDelegation.application.domains": "Domaines autorisés",
  "identityDelegation.mint.title":
    "Créer l’identifiant d’émission réservé au serveur",
  "identityDelegation.mint.description":
    "Votre backend utilise ce secret au périmètre réduit pour échanger son utilisateur authentifié contre une identité widget de courte durée. Copiez-le une fois dans votre gestionnaire de secrets ; ne l’envoyez jamais au navigateur.",
  "identityDelegation.mintKey.title": "Clé d’émission d’identité widget",
  "identityDelegation.mintKey.subtitle":
    "Créez l’identifiant réservé au serveur utilisé par votre backend pour émettre des identités widget de courte durée. Il n’est affiché qu’une fois.",
  "identityDelegation.mintKey.scopeHelp":
    "Cette clé est limitée à widget-identity:mint et doit rester sur votre backend.",
  "identityDelegation.endpoint.title":
    "Ajouter un endpoint d’identité sur la même origine",
  "identityDelegation.endpoint.description":
    "Votre serveur authentifie le visiteur avec votre système de connexion existant, détermine ce que ce compte peut faire, puis demande à ChatSystem une identité de courte durée avec la clé serveur créée à l’étape précédente.",
  "identityDelegation.endpoint.serverBoundary.title":
    "Ce code doit être ajouté à votre application serveur",
  "identityDelegation.endpoint.serverBoundary.description":
    "Ajoutez un endpoint au backend qui authentifie déjà vos clients. N’implémentez pas cet échange dans React, le bundle du widget, un gestionnaire de balises ou tout autre code navigateur : la clé d’émission créée ci-dessus est un secret serveur.",
  "identityDelegation.endpoint.flow.title":
    "Ce que l’endpoint doit faire à chaque requête",
  "identityDelegation.endpoint.flow.authenticate":
    "Authentifier la requête entrante avec votre mécanisme serveur habituel : par exemple un cookie de session sécurisé, un middleware SSO ou un jeton d’accès déjà utilisé par votre application.",
  "identityDelegation.endpoint.flow.signedOut":
    "Si l’utilisateur n’est pas authentifié, renvoyez HTTP 204 sans identité. La discussion anonyme continue, mais les outils protégés demanderont une connexion si nécessaire.",
  "identityDelegation.endpoint.flow.subject":
    "Choisissez l’identifiant qui représente déjà ce client dans votre base de données, par exemple l’UUID de son compte client. N’utilisez pas son adresse e-mail ou son numéro de téléphone, et ne réattribuez jamais cet identifiant à une autre personne.",
  "identityDelegation.endpoint.flow.capabilities":
    "Construisez la liste des actions autorisées pour ce compte. Par exemple, ajoutez orders:read uniquement si le client connecté peut consulter ses commandes. Construisez cette liste dans votre backend, jamais à partir de valeurs envoyées par le navigateur.",
  "identityDelegation.endpoint.flow.mint":
    "Votre backend envoie ensuite à ChatSystem l’app token sélectionné, l’identifiant du client et les actions autorisées. Authentifiez cet appel serveur à serveur avec la clé secrète créée à l’étape 2.",
  "identityDelegation.endpoint.flow.return":
    "L’appel POST envoyé à ChatSystem renvoie un JSON contenant un jeton de courte durée et sa date d’expiration. Votre backend transmet cette réponse JSON au widget. Ce n’est pas l’app token : il s’agit d’une identité temporaire créée pour le client connecté. N’envoyez jamais au navigateur la clé secrète, votre cookie de session ou le mot de passe du client.",
  "identityDelegation.endpoint.context.authentication.title":
    "Réutiliser votre authentification",
  "identityDelegation.endpoint.context.authentication.description":
    "L’endpoint peut utiliser votre cookie de session sécurisé existant, votre middleware SSO, un jeton d’accès ou un autre mécanisme d’authentification backend. ChatSystem ne le choisit pas et ne le remplace pas.",
  "identityDelegation.endpoint.context.capabilities.title":
    "Accorder des capacités précises",
  "identityDelegation.endpoint.context.capabilities.description":
    "Déduisez les permissions de l’état actuel du compte côté serveur, par exemple orders:read ou subscriptions:read. N’acceptez jamais une liste de capacités fournie par le navigateur.",
  "identityDelegation.endpoint.context.security.title":
    "Conserver votre autorité",
  "identityDelegation.endpoint.context.security.description":
    "Votre cookie et votre mot de passe ne quittent jamais votre infrastructure. L’identité de courte durée indique seulement à ChatSystem quel utilisateur opaque et quelles capacités votre backend vient de confirmer.",
  "identityDelegation.endpoint.context.expiration.title":
    "Laisser ChatSystem gérer l’expiration",
  "identityDelegation.endpoint.context.expiration.description":
    "Ne choisissez pas et n’envoyez pas de durée. ChatSystem limite actuellement l’identité à cinq minutes maximum et renvoie sa date d’expiration. Le widget la conserve uniquement en mémoire et en demande une nouvelle peu avant son expiration. À chaque demande, authentifiez de nouveau la session et recalculez les capacités ; ne mettez pas vous-même l’identité émise en cache.",
  "identityDelegation.endpoint.stakeholder.title": "En bref :",
  "identityDelegation.endpoint.stakeholder.description":
    "vous conservez l’authentification et l’autorisation métier dans votre propre backend. ChatSystem limite la durée de la preuve et le widget la renouvelle lorsque nécessaire ; vous n’avez pas à gérer cette durée. Votre API vérifie toujours les droits actuels sur la ressource lorsque l’agent utilise un outil protégé.",
  "identityDelegation.widget.title": "Connecter l’identité au widget frontend",
  "identityDelegation.widget.description":
    "Choisissez le composant npm ou l’API du bundle navigateur. Les deux fournissent l’identité à la demande au même widget et l’informent après une connexion, une déconnexion ou un changement de compte. L’identité reste en mémoire et n’est jamais placée dans le HTML ni le stockage du navigateur.",
  "identityDelegation.widget.explanation.location.title":
    "Choisir une intégration frontend",
  "identityDelegation.widget.explanation.location.description":
    "Utilisez soit le composant npm, soit le bundle index.js programmatique présenté ci-dessous. Les deux montent le même client ChatSystem et appellent l’endpoint serveur de l’étape 3 ; la clé secrète d’émission n’apparaît jamais ici.",
  "identityDelegation.widget.explanation.getToken.title":
    "Fournir l’identité à la demande",
  "identityDelegation.widget.explanation.getToken.description":
    "Le widget appelle getToken silencieusement à son ouverture, avant un message si nécessaire et à l’approche de l’expiration. Si un outil protégé exige une connexion, interactive passe à true : ouvrez votre interface de connexion existante, puis rappelez le même endpoint.",
  "identityDelegation.widget.explanation.subscribe.title":
    "Signaler les changements de compte",
  "identityDelegation.widget.explanation.subscribe.description":
    "Reliez subscribe aux événements de votre système d’authentification. Une fois la connexion, la déconnexion ou le changement de compte terminé, appelez le callback fourni par ChatSystem : il supprime l’ancienne identité en mémoire et récupère l’identité actuelle.",
  "identityDelegation.widget.npm.title": "Si vous utilisez React",
  "identityDelegation.widget.npm.codeLabel":
    "Code frontend / @chatsystem/client",
  "identityDelegation.widget.bundle.title": "Si vous utilisez le script bundlé",
  "identityDelegation.widget.bundle.codeLabel": "Code frontend / script bundlé",
  "identityDelegation.widget.tabs.label": "Méthode d’intégration frontend",
  "identityDelegation.widget.scriptBoundary":
    'L’intégration déclarative existante <script data-appToken="…"> reste disponible pour les widgets anonymes. Pour la délégation d’identité, chargez le même bundle index.js sans data-appToken, puis appelez ChatSystem.mount(...) afin que votre frontend fournisse les fonctions d’identité.',
  "identityDelegation.verifier.title": "Protéger l’endpoint de votre outil",
  "identityDelegation.verifier.description":
    "Ajoutez ce contrôle dans la route de votre backend qui reçoit les appels d’outil ChatSystem. Il confirme qui a envoyé la requête et quel client elle représente ; votre backend décide ensuite si ce client peut accéder à la donnée demandée.",
  "identityDelegation.verifier.explanation.location.title":
    "Placer ce code dans l’endpoint de l’outil",
  "identityDelegation.verifier.explanation.location.description":
    "Ce code appartient au backend du client, au début de la route HTTPS que ChatSystem appellera. Il ne doit pas être placé dans React, index.js ni aucun autre code navigateur.",
  "identityDelegation.verifier.explanation.proof.title":
    "Confirmer que l’appel vient de ChatSystem",
  "identityDelegation.verifier.explanation.proof.description":
    "Le vérificateur maintenu contrôle la signature, l’expiration, l’entreprise, le widget et l’outil visés, les capacités requises et l’usage unique de la requête. Si tout est valide, il renvoie l’identifiant opaque du client.",
  "identityDelegation.verifier.explanation.authorization.title":
    "Vérifier l’accès dans votre propre base",
  "identityDelegation.verifier.explanation.authorization.description":
    "Utilisez cet identifiant pour retrouver le compte client actuel, puis vérifiez qu’il peut toujours consulter la commande, l’abonnement ou l’autre ressource demandée. Une preuve ChatSystem valide n’accorde jamais l’accès à elle seule.",
  "identityDelegation.verifier.tabs.label": "Code du backend client",
  "identityDelegation.verifier.tabs.endpoint": "Dans votre endpoint",
  "identityDelegation.verifier.tabs.utilities": "Utilitaires Node",
  "identityDelegation.verifier.endpoint.codeLabel":
    "Endpoint client / TypeScript",
  "identityDelegation.verifier.utilities.codeLabel":
    "Utilitaires Node / TypeScript",
  "identityDelegation.guide.action":
    "Ouvrir le guide d’intégration complet et les exemples maintenus",
  "identityDelegation.tool.title":
    "Enregistrer l’API protégée comme outil délégué",
  "identityDelegation.tool.description":
    "Décrivez l’endpoint HTTPS fixe, l’audience exacte, les capacités requises et les schémas de requête et de réponse. ChatSystem, et non le navigateur, ajoute le JWT d’invocation de courte durée.",
  "identityDelegation.tool.action": "Créer l’outil délégué",
  "identityDelegation.tool.existing.title": "Outils délégués existants",
  "identityDelegation.tool.existing.active": "Actif",
  "identityDelegation.tool.existing.inactive": "Inactif",
  "identityDelegation.tool.existing.edit": "Ouvrir la configuration",
  "identityDelegation.tool.existing.loading": "Chargement des outils délégués…",
  "identityDelegation.tool.existing.empty":
    "Aucun outil délégué n’a encore été créé pour cette société.",
  "identityDelegation.tool.create.title": "Créer un outil à identité déléguée",
  "identityDelegation.tool.defaultParameterDescription":
    "Identifiant stable de la ressource à consulter",
  "identityDelegation.agent.title": "Activer l’outil pour un agent",
  "identityDelegation.agent.description":
    "Ouvrez l’onglet Outils de l’agent cible, activez l’outil délégué et faites décrire à son prompt la capacité client sans exposer les détails d’authentification.",
  "identityDelegation.agent.action": "Configurer les outils de l’agent",
  "toolForm.httpConfig.authentication": "Authentification",
  "toolForm.httpConfig.authentication.none":
    "Aucune identité déléguée ChatSystem",
  "toolForm.httpConfig.authentication.delegated":
    "Identité déléguée ChatSystem (JWT signé)",
  "toolForm.httpConfig.delegated.title": "API client déléguée en lecture seule",
  "toolForm.httpConfig.delegated.help":
    "ChatSystem injecte un JWT signé de courte durée. Ne configurez jamais d’en-tête Authorization statique ici.",
  "toolForm.httpConfig.method": "Méthode HTTP",
  "toolForm.httpConfig.audience": "Audience exacte du jeton",
  "toolForm.httpConfig.urlTemplate": "Modèle d’URL HTTPS fixe",
  "toolForm.httpConfig.capabilities": "Capacités requises",
  "toolForm.httpConfig.capabilities.help":
    "Permissions précises séparées par des virgules, par exemple orders:read.",
  "toolForm.outputSchema.title": "Schéma de réponse de l’API client",
  "toolForm.outputSchema.help":
    "Décrivez le JSON renvoyé par l’endpoint afin que l’agent reçoive un résultat limité et validé.",
  "toolForm.toast.delegatedConfig.invalid":
    "Renseignez l’endpoint HTTPS fixe, l’audience, une méthode prise en charge et les capacités requises.",
  "toolForm.toast.outputSchema.invalid":
    "Les outils délégués nécessitent un schéma valide pour la réponse de l’API client.",
  "myAccount.page.myTools.create.toast.success": "Outil créé avec succès.",
  "myAccount.page.myTools.create.toast.error":
    "La création de l’outil a échoué.",
  "myAccount.page.myTools.edit.cta": "Modifier la configuration",
  "myAccount.page.myTools.edit.title": "Modifier l’outil de l’entreprise",
  "myAccount.page.myTools.edit.back": "Retour aux outils",
  "myAccount.page.myTools.edit.unavailable":
    "Cet outil d’entreprise ne peut pas être modifié ici.",
  "myAccount.page.myTools.edit.toast.loadError":
    "Le chargement de l’outil a échoué.",
  "myAccount.page.myTools.edit.toast.error":
    "La mise à jour de l’outil a échoué.",
  "myAccount.page.myTools.edit.toast.success":
    "Configuration de l’outil mise à jour.",
  "dev.companyApiKey.column.name": "Nom",
  "dev.companyApiKey.column.scopes": "Périmètres",
  "dev.companyApiKey.column.created": "Créée le",
  "dev.companyApiKey.column.expires": "Expire le",
  "dev.companyApiKey.column.lastUsed": "Dernière utilisation",
  "dev.companyApiKey.column.status": "État",
  "dev.companyApiKey.status.active": "active",
  "dev.companyApiKey.status.revoked": "révoquée",
  "toolForm.httpConfig.advanced": "Configuration HTTP avancée",
  "myAccount.page.leftMenu.billing": "Facturation",
  "billing.portal.eyebrow": "Facturation",
  "billing.portal.title": "Votre abonnement",
  "billing.portal.description":
    "Consultez votre formule, votre consommation et votre facturation.",
  "billing.portal.interval.month": "mois",
  "billing.portal.interval.year": "an",
  "billing.portal.frequency.monthly": "Mensuelle",
  "billing.portal.frequency.yearly": "Annuelle",
  "billing.portal.current.eyebrow": "Votre formule actuelle",
  "billing.portal.current.status.scheduled": "Votre formule est programmée.",
  "billing.portal.current.status.active": "Votre accès est actif.",
  "billing.portal.current.status.grace":
    "Votre accès reste actif pendant la résolution d’un problème de paiement.",
  "billing.portal.current.graceEndsAt":
    "Mettez à jour votre moyen de paiement avant le {date} pour conserver l’accès.",
  "billing.portal.current.status.suspended": "Votre accès est suspendu.",
  "billing.portal.current.status.cancelled": "Votre formule a été résiliée.",
  "billing.portal.current.status.ended": "Votre formule est terminée.",
  "billing.portal.current.statusLabel.scheduled": "Programmée",
  "billing.portal.current.statusLabel.active": "Active",
  "billing.portal.current.statusLabel.grace": "Incident de paiement",
  "billing.portal.current.statusLabel.suspended": "Suspendue",
  "billing.portal.current.statusLabel.cancelled": "Résiliée",
  "billing.portal.current.statusLabel.ended": "Terminée",
  "billing.portal.current.frequency": "Fréquence de facturation : {interval}.",
  "billing.portal.current.nextBillingDate":
    "Prochaine date de facturation : {date}.",
  "billing.portal.current.cancellationScheduled":
    "La résiliation est programmée pour le {date}. Votre accès reste actif jusque-là et l’abonnement ne sera pas renouvelé.",
  "billing.portal.current.pricing.title": "Détail de votre facturation",
  "billing.portal.current.pricing.empty":
    "Le détail de cette ancienne formule n’est pas encore disponible en ligne.",
  "billing.portal.funding.postpaid":
    "Tous les usages tarifés partagent ce plafond mensuel. Seul l’usage réellement consommé est facturé ensuite.",
  "billing.portal.funding.uncapped.title":
    "Usage postpayé sans plafond contractuel",
  "billing.portal.funding.uncapped":
    "Tous les usages tarifés sont facturés après consommation. Votre accord privé ne comporte aucun plafond contractuel d’usage.",
  "billing.portal.funding.periodic":
    "Tous les usages tarifés partagent ce crédit inclus. Le montant non utilisé expire à la fin de la période de facturation.",
  "billing.portal.funding.rolling":
    "Tous les usages tarifés partagent ce crédit prépayé. Le montant non utilisé reste disponible pendant les périodes suivantes.",
  "billing.portal.funding.base": "Budget d’usage partagé : {amount}",
  "billing.portal.funding.used": "Utilisé : {amount}",
  "billing.portal.funding.inProgress": "En cours : {amount}",
  "billing.portal.funding.remaining.postpaid":
    "Plafond d’usage restant ce mois-ci",
  "billing.portal.funding.remaining.periodic.monthly":
    "Crédit d’usage restant ce mois-ci",
  "billing.portal.funding.remaining.periodic.period":
    "Crédit d’usage restant pour cette période de facturation",
  "billing.portal.funding.remaining.rolling": "Crédit d’usage disponible",
  "billing.portal.usageCredit.title": "Crédit d’usage",
  "billing.portal.usageCredit.periodLabel": "Période de facturation",
  "billing.portal.usageCredit.periodValue": "Du {start} au {end}",
  "billing.portal.usageCredit.policyLabel": "Conditions d’usage",
  "billing.portal.usageActivity.eyebrow": "Période de facturation en cours",
  "billing.portal.usageActivity.title": "Votre consommation",
  "billing.portal.usageActivity.description":
    "Suivez chaque ressource mesurée incluse dans votre formule actuelle.",
  "billing.portal.usageActivity.used": "utilisé sur cette période",
  "billing.portal.usage.period": "Période d’usage : du {start} au {end}",
  "billing.portal.usage.included":
    "{quantity} inclus à chaque période de facturation.",
  "billing.portal.usage.limit":
    "Plafond d’usage actuel : {quantity} pour cette période de facturation.",
  "billing.portal.usage.consumed": "Consommation sur la période : {quantity}",
  "billing.portal.usage.reserved": "Utilisation en cours : {quantity}",
  "billing.portal.usage.additionalAllowance":
    "Crédit d’usage supplémentaire sur cette période : {quantity}",
  "billing.portal.usage.remaining":
    "Disponible avant d’atteindre le plafond : {quantity}",
  "billing.portal.usage.billable":
    "Usage facturable au-delà de l’inclus : {quantity}",
  "billing.portal.usage.noOverage":
    "Aucun usage n’est actuellement facturable au-delà de l’inclus.",
  "billing.portal.metric.conversations": "conversations démarrées",
  "billing.portal.metric.aiResponses": "réponses de l’IA",
  "billing.portal.metric.productSearches": "recherches de produits",
  "billing.portal.metric.completedConversations": "conversations terminées",
  "billing.portal.metric.aiTokens": "jetons d’IA",
  "billing.portal.metric.braveRequests": "requêtes Brave Search",
  "billing.portal.recharge.title":
    "Ajouter de l’usage pour cette période de facturation",
  "billing.portal.recharge.shared.title": "Recharges ponctuelles",
  "billing.portal.recharge.shared.action":
    "Acheter une recharge ponctuelle — {price}",
  "billing.portal.recharge.shared.promotion":
    "Payez {price}, recevez {credit} de crédit d’usage",
  "billing.portal.recharge.card.title": "Ajouter du crédit d’usage",
  "billing.portal.recharge.card.creditAmount": "{credit} de crédit d’usage",
  "billing.portal.recharge.card.payment": "Paiement unique : {price}",
  "billing.portal.recharge.card.action": "Acheter {credit} de crédit d’usage",
  "billing.portal.recharge.card.bonus": "Dont {bonus} de crédit offert",
  "billing.portal.recharge.shared.periodic":
    "Le crédit est ajouté après confirmation du paiement et expire à la fin de la période de facturation en cours.",
  "billing.portal.recharge.shared.rolling":
    "Le crédit est ajouté après confirmation du paiement et reste disponible avec cet abonnement.",
  "billing.portal.recharge.pack":
    "{quantity} {metric} par lot supplémentaire pour {price}.",
  "billing.portal.recharge.quantity": "Nombre de lots",
  "billing.portal.recharge.action":
    "Acheter {quantity} {metric} supplémentaires — {total}",
  "billing.portal.recharge.opening": "Ouverture du paiement sécurisé…",
  "billing.portal.recharge.confirmation":
    "Le crédit supplémentaire est ajouté après confirmation du paiement sécurisé et reste disponible jusqu’à la fin de la période de facturation en cours.",
  "billing.portal.recharge.error":
    "Le paiement de l’usage supplémentaire n’a pas pu être ouvert. Actualisez la page puis réessayez, ou contactez le support.",
  "billing.portal.recharge.return.success":
    "Le paiement sécurisé est terminé. Votre usage supplémentaire apparaîtra ici dès que le paiement sera confirmé.",
  "billing.portal.recharge.return.cancelled":
    "Le paiement a été annulé. Aucun usage supplémentaire n’a été ajouté.",
  "billing.portal.pricing.taxIncluded":
    "Les prix sont affichés en {currency}, taxes comprises. Stripe confirme la taxe applicable à partir de vos informations de facturation lors du paiement et sur la facture.",
  "billing.portal.planDetails.title": "Détail de la formule",
  "billing.portal.management.heroAction": "Gérer ma facturation",
  "billing.portal.history.title": "Activité de facturation récente",
  "billing.portal.history.description":
    "Consultez vos dernières factures, leurs ajustements et vos achats d’usage supplémentaire.",
  "billing.portal.history.recharge.title": "Usage supplémentaire acheté",
  "billing.portal.history.recharge.sharedCredit":
    "Crédit d’usage partagé ajouté",
  "billing.portal.history.recharge.availability": "Disponibilité",
  "billing.portal.history.recharge.rollsForward":
    "Reporté tant que cet abonnement reste actif",
  "billing.portal.history.recharge.appliedRefundTitle":
    "Remboursement enregistré — vérification nécessaire",
  "billing.portal.history.recharge.reviewTitle":
    "Paiement reçu — vérification nécessaire",
  "billing.portal.history.recharge.partialRefundTitle":
    "Paiement partiellement remboursé — vérification nécessaire",
  "billing.portal.history.recharge.refundedTitle": "Paiement remboursé",
  "billing.portal.history.recharge.appliedRefundDescription":
    "{amount} a été remboursé après l’ajout de l’usage supplémentaire. Cet usage reste disponible pendant la vérification de l’ajustement par le support.",
  "billing.portal.history.recharge.reviewDescription":
    "La période de facturation prévue s’est terminée avant la confirmation du paiement ; aucun usage n’a donc été ajouté automatiquement. Contactez le support afin que nous vérifiions ce paiement.",
  "billing.portal.history.recharge.reviewContractChangedDescription":
    "Votre abonnement a changé avant la confirmation du paiement ; cet achat n’a donc pas pu être ajouté automatiquement. Contactez le support afin que nous vérifiions ce paiement.",
  "billing.portal.history.recharge.partialRefundDescription":
    "La période de facturation prévue s’est terminée avant la confirmation ; aucun usage n’a donc été ajouté. {amount} a été remboursé à ce jour ; contactez le support.",
  "billing.portal.history.recharge.partialRefundContractChangedDescription":
    "Votre abonnement a changé avant la confirmation du paiement ; aucun usage n’a donc été ajouté. {amount} a été remboursé à ce jour ; contactez le support.",
  "billing.portal.history.recharge.refundedDescription":
    "La période de facturation prévue était déjà terminée ; aucun usage n’a donc été ajouté. Le paiement intégral de {amount} a été remboursé.",
  "billing.portal.history.recharge.refundedContractChangedDescription":
    "Votre abonnement a changé avant la confirmation du paiement ; aucun usage n’a donc été ajouté. Le paiement intégral de {amount} a été remboursé.",
  "billing.portal.history.recharge.paidAt": "Payé le {date}",
  "billing.portal.history.recharge.availableUntil": "Disponible jusqu’au",
  "billing.portal.history.recharge.intendedAvailableUntil":
    "Disponibilité initialement prévue jusqu’au",
  "billing.portal.history.recharge.periodEnded": "Fin de la période prévue",
  "billing.portal.invoice.title": "Facture",
  "billing.portal.invoice.updatedAt": "Dernière mise à jour le {date}",
  "billing.portal.invoice.total": "Total de la facture",
  "billing.portal.invoice.totalPaid": "Total payé",
  "billing.portal.invoice.alreadyPaid": "Déjà payé",
  "billing.portal.invoice.remaining": "Reste à payer",
  "billing.portal.invoice.viewDetail": "Voir le détail",
  "billing.portal.invoice.downloadPdf": "Télécharger le PDF",
  "billing.portal.invoice.opening": "Ouverture…",
  "billing.portal.invoice.documentError":
    "Cette facture n’a pas pu être ouverte. Réessayez ou utilisez Gérer la facturation.",
  "billing.portal.invoice.attempts":
    "{count, plural, one {# tentative de paiement enregistrée} other {# tentatives de paiement enregistrées}}.",
  "billing.portal.paymentActionRequired.title":
    "Votre banque vous demande de confirmer ce paiement",
  "billing.portal.paymentActionRequired.description":
    "Confirmez-le de manière sécurisée avant le {date} pour conserver votre abonnement actif.",
  "billing.portal.paymentActionRequired.invoiceHelp":
    "Ouvrez la facture sécurisée pour terminer l’authentification. ChatSystem ne reçoit jamais vos identifiants bancaires.",
  "billing.portal.paymentActionRequired.action":
    "Confirmer le paiement en toute sécurité",
  "billing.portal.invoice.status.draft": "En préparation",
  "billing.portal.invoice.status.open": "Paiement en attente",
  "billing.portal.invoice.status.paid": "Payée",
  "billing.portal.invoice.status.uncollectible": "Paiement requis",
  "billing.portal.invoice.status.void": "Annulée",
  "billing.portal.invoice.status.unknown": "Mise à jour en cours",
  "billing.portal.creditNote.title": "Ajustements",
  "billing.portal.creditNote.issued": "Avoir",
  "billing.portal.creditNote.void": "Avoir annulé",
  "billing.portal.creditNote.detail": "Effectif le {date}",
  "billing.portal.creditNote.detailWithReason": "Effectif le {date} · {reason}",
  "billing.portal.creditNote.truncated":
    "Seuls les ajustements les plus récents sont affichés ici. Contactez le support pour obtenir l’historique complet.",
  "billing.portal.creditNote.reason.duplicate": "Facturation en double",
  "billing.portal.creditNote.reason.fraudulent": "Transaction signalée",
  "billing.portal.creditNote.reason.orderChange": "Modification de commande",
  "billing.portal.creditNote.reason.productUnsatisfactory":
    "Problème avec le produit ou le service",
  "billing.portal.current.help.change":
    "Choisissez une autre formule ci-dessous pour programmer le changement.",
  "billing.portal.current.help.scheduled":
    "Votre formule actuelle reste disponible jusqu’à la date programmée.",
  "billing.portal.current.help.paymentIssue":
    "Contactez le support si le problème de paiement persiste.",
  "billing.portal.current.help.restoreAccess":
    "Contactez le support pour rétablir votre accès.",
  "billing.portal.current.help.inactive":
    "Contactez-nous si vous souhaitez choisir une autre formule.",
  "billing.portal.offer.private": "Offre préparée pour votre entreprise",
  "billing.portal.offer.current": "Formule actuelle",
  "billing.portal.offer.scheduled": "Programmée",
  "billing.portal.planChange.action": "Changer à la prochaine échéance",
  "billing.portal.planChange.alreadyScheduled":
    "Un autre changement est déjà programmé",
  "billing.portal.planChange.unavailable": "Changement de formule indisponible",
  "billing.portal.planChange.confirm.title":
    "Passer de {source} à {target} le {date} ?",
  "billing.portal.planChange.confirm.help":
    "Aucun paiement n’est effectué aujourd’hui. Votre formule actuelle reste active jusqu’à la fin de la période payée et vous pouvez annuler ce changement d’ici là.",
  "billing.portal.planChange.confirm.action": "Confirmer le changement",
  "billing.portal.planChange.confirm.back": "Retour",
  "billing.portal.planChange.scheduling": "Programmation du changement…",
  "billing.portal.planChange.scheduled":
    "La formule {offer} prendra effet le {date}.",
  "billing.portal.planChange.scheduled.help":
    "Votre formule et vos tarifs actuels restent inchangés jusque-là. Aucun paiement n’est effectué aujourd’hui.",
  "billing.portal.planChange.cancel": "Annuler le changement programmé",
  "billing.portal.planChange.cancelling": "Annulation du changement…",
  "billing.portal.planChange.error":
    "Le changement de formule n’a pas pu être programmé. Actualisez la page et réessayez, ou contactez le support.",
  "billing.portal.planChange.rollingCredit":
    "Cette formule possède encore du crédit d’usage à préserver. Utilisez le crédit restant avant de changer de formule, ou contactez le support.",
  "billing.portal.planChange.cancel.error":
    "Le changement programmé n’a pas pu être annulé. Actualisez la page et réessayez, ou contactez le support.",
  "billing.portal.paymentGracePeriod":
    "Délai de grâce de paiement : {hours, plural, one {# heure} other {# heures}}",
  "billing.portal.offer.public": "Offre standard",
  "billing.portal.available.title":
    "Formules disponibles pour votre entreprise",
  "billing.portal.available.description":
    "Comparez les formules publiques et privées actuellement proposées à votre entreprise.",
  "billing.portal.available.back": "Retour à mon abonnement",
  "billing.portal.selected.header.title": "Finalisez votre abonnement",
  "billing.portal.selected.header.description":
    "Vérifiez les conditions sélectionnées, puis continuez vers le paiement sécurisé de Stripe.",
  "billing.portal.selected.title": "Votre formule sélectionnée",
  "billing.portal.selected.compare": "Comparer toutes les formules",
  "billing.portal.checkout.action": "Continuer vers le paiement sécurisé",
  "billing.portal.checkout.opening": "Ouverture du paiement sécurisé…",
  "billing.portal.checkout.error":
    "Le paiement n’a pas pu être ouvert. Réessayez ou contactez le support.",
  "billing.portal.checkout.return.success":
    "Le paiement sécurisé est terminé. Votre abonnement apparaîtra ici dès que le paiement sera confirmé.",
  "billing.portal.checkout.return.continueProduction":
    "Continuer la mise en production de mon Agent",
  "billing.portal.checkout.return.cancelled":
    "Le paiement a été annulé. Votre abonnement n’a pas changé.",
  "billing.portal.management.title":
    "Gérer votre abonnement et votre facturation",
  "billing.portal.management.description":
    "Ouvrez l’espace sécurisé de Stripe pour mettre à jour votre moyen de paiement, télécharger vos factures ou programmer la résiliation à la fin de la période payée. Votre formule ChatSystem et ses quantités ne peuvent pas y être modifiées.",
  "billing.portal.management.action": "Gérer ma facturation en toute sécurité",
  "billing.portal.management.opening": "Ouverture de la facturation sécurisée…",
  "billing.portal.management.error":
    "La gestion sécurisée de la facturation n’a pas pu être ouverte. Réessayez ou contactez le support.",
  "billing.portal.load.error":
    "Vos informations de facturation n’ont pas pu être chargées. Actualisez la page ou contactez le support.",
  "billing.portal.empty.current.title":
    "Aucune autre formule n’est disponible actuellement",
  "billing.portal.empty.current.description":
    "Votre accès actuel reste inchangé. Contactez-nous si vous souhaitez étudier une autre formule.",
  "billing.portal.empty.noCurrent.title":
    "Aucun abonnement n’est disponible en ligne actuellement",
  "billing.portal.empty.noCurrent.description":
    "Contactez-nous pour étudier la formule la plus adaptée à votre entreprise.",
  "admin.subscriptionOffer.stripe.title": "Préparation du paiement en ligne",
  "admin.subscriptionOffer.stripe.description":
    "Les conditions locales sont figées. Terminez ou relancez leur projection Stripe idempotente : aucune ressource ne sera créée en double.",
  "admin.subscriptionOffer.stripe.ready":
    "Prête : {count} composantes tarifaires sont reliées à l’offre Checkout {interval}, et le portail client est configuré.",
  "admin.subscriptionOffer.stripe.prepare": "Terminer la publication en ligne",
  "admin.subscriptionOffer.stripe.preparing": "Préparation…",
  "admin.subscriptionOffer.stripe.verify": "Vérifier la configuration en ligne",
  "admin.subscriptionOffer.stripe.confirm":
    "Créer ou vérifier le produit, les composantes tarifaires Stripe et le portail client sécurisé pour cette version publiée exacte ?",
  "admin.subscriptionOffer.stripe.error":
    "La configuration en ligne n’a pas pu être terminée. Vous pouvez la relancer sans risque.",
  "admin.subscriptionOffer.stripe.success":
    "Stripe Checkout et la gestion sécurisée de la facturation client sont prêts.",
  "admin.subscriptionOffer.publicationMode.stripe": "Paiement Stripe",
  "admin.subscriptionOffer.publicationMode.offline": "Facturation manuelle",
  "admin.subscriptionOffer.publicationMode.internal": "Interne / offert",
  "admin.subscriptionOffer.publicationMode.legacy":
    "Mode historique à vérifier",
  "admin.subscriptionOffer.offline.eyebrow": "Mode d’encaissement",
  "admin.subscriptionOffer.offline.title": "Facturation manuelle hors Stripe",
  "admin.subscriptionOffer.offline.description":
    "Ce circuit de paiement a été choisi volontairement pour cette version immuable. ChatSystem journalise les usages tarifés ; l’opérateur facture directement le client et garde la main sur les règlements.",
  "admin.subscriptionOffer.offline.paymentRoute.title":
    "Circuit de paiement confirmé",
  "admin.subscriptionOffer.offline.paymentRoute.description":
    "Hors Stripe, par choix : le client est facturé et règle directement auprès de l’opérateur. Aucun produit, tarif ou Checkout Stripe n’est donc attendu.",
  "admin.subscriptionOffer.offline.evidence.title":
    "Suivi financier ChatSystem",
  "admin.subscriptionOffer.offline.evidence.description":
    "Les usages tarifés, références de facture et statuts de règlement sont conservés dans le journal financier indépendant du prestataire.",
  "company.members.title": "Membres de l’entreprise",
  "company.members.description":
    "Invitez une personne avec l’adresse email qu’elle utilise pour se connecter à ChatSystem.",
  "company.members.email.placeholder": "nom@entreprise.fr",
  "company.members.invite": "Créer le lien d’invitation",
  "company.members.invitation.share":
    "Envoyez ce lien sécurisé à la personne invitée.",
  "company.members.invitation.copy": "Copier le lien d’invitation",
  "company.members.invitation.copied": "Lien d’invitation copié",
  "company.members.invitation.pending": "Invitation en attente",
  "company.members.invitation.revoke": "Révoquer l’invitation",
  "company.members.owner": "Propriétaire",
  "company.members.transfer": "Transférer la propriété",
  "company.members.transfer.confirm":
    "Transférer la propriété de l’entreprise à ce membre ?",
  "company.members.remove": "Retirer le membre",
  "company.members.remove.confirm": "Retirer ce membre de l’entreprise ?",
  "company.invitation.accept.title": "Rejoindre l’entreprise sur ChatSystem",
  "company.invitation.accepted.title": "Vous avez rejoint l’entreprise",
  "company.invitation.invalid": "Ce lien d’invitation est invalide.",
  "company.invitation.usedWorkspace":
    "Votre entreprise actuelle contient des données ou de l’activité. Contactez un administrateur ChatSystem pour effectuer le transfert en toute sécurité.",
  "company.invitation.failed":
    "L’invitation est invalide, expirée ou ne correspond pas à l’adresse email utilisée pour vous connecter à ChatSystem.",
  "company.invitation.signIn": "Se connecter pour accepter",
  "admin.subscriptionOffer.capabilities.eyebrow": "Capacités client",
  "admin.subscriptionOffer.capabilities.title":
    "Définir ce que permet cette offre",
  "admin.subscriptionOffer.capabilities.description":
    "Ces limites sont appliquées par l’API et affichées de façon cohérente sur la page des tarifs. Utilisez Illimité uniquement lorsque les conditions commerciales le prévoient réellement.",
  "admin.subscriptionOffer.capabilities.summary":
    "Ressources et service inclus",
  "admin.subscriptionOffer.capabilities.agents": "Nombre maximum d’Agents",
  "admin.subscriptionOffer.capabilities.domains":
    "Nombre maximum de domaines racine",
  "admin.subscriptionOffer.capabilities.members": "Nombre maximum de membres",
  "admin.subscriptionOffer.capabilities.unlimited": "Illimité",
  "admin.subscriptionOffer.capabilities.poweredBy.title":
    "Afficher « Powered by ChatSystem »",
  "admin.subscriptionOffer.capabilities.poweredBy.description":
    "Le widget reçoit cette décision de marque contrôlée par le serveur.",
  "admin.subscriptionOffer.capabilities.branding": "Marque du widget",
  "admin.subscriptionOffer.capabilities.branding.hidden": "Marque blanche",
  "admin.subscriptionOffer.capabilities.branding.visible":
    "Powered by ChatSystem",
  "admin.subscriptionOffer.capabilities.support": "Niveau de support",
  "admin.subscriptionOffer.capabilities.support.standard": "Standard",
  "admin.subscriptionOffer.capabilities.support.direct": "Email direct dédié",
  "workspace.capacity.comparePlans": "Comparer les offres",
  "workspace.capacity.viewPlans": "Voir les offres",
  "workspace.capacity.askOwner.choosePlan":
    "Demandez au propriétaire de l’entreprise de choisir une offre.",
  "workspace.capacity.askOwner.higherPlan":
    "Demandez au propriétaire de l’entreprise de choisir une offre supérieure.",
  "workspace.capacity.scheduledChange":
    "Les limites de votre prochaine offre s’appliquent déjà aux nouvelles créations.",
  "workspace.capacity.agents": "Agents",
  "workspace.capacity.domains": "Domaines autorisés",
  "workspace.capacity.members": "Places dans l’équipe",
  "workspace.capacity.agents.reached":
    "Vous avez créé tous les Agents inclus dans votre offre.",
  "workspace.capacity.agents.reached.preparation":
    "Vous avez atteint le nombre maximum d’Agents que vous pouvez créer sans offre.",
  "workspace.capacity.agents.reached.scheduled":
    "Vous avez atteint le nombre d’Agents inclus dans votre prochaine offre.",
  "workspace.capacity.agents.upgrade":
    "Pour en créer davantage, choisissez une offre supérieure.",
  "workspace.capacity.agents.choosePlan":
    "Pour en créer davantage, choisissez une offre.",
  "workspace.capacity.domains.reached":
    "Vous avez autorisé tous les domaines inclus dans votre offre.",
  "workspace.capacity.domains.reached.preparation":
    "Vous avez atteint le nombre maximum de domaines que vous pouvez autoriser sans offre.",
  "workspace.capacity.domains.reached.scheduled":
    "Vous avez atteint le nombre de domaines inclus dans votre prochaine offre.",
  "workspace.capacity.domains.upgrade":
    "Pour en ajouter davantage, choisissez une offre supérieure.",
  "workspace.capacity.domains.choosePlan":
    "Pour en ajouter davantage, choisissez une offre.",
  "workspace.capacity.members.reached":
    "Toutes les places incluses dans votre offre sont utilisées.",
  "workspace.capacity.members.reached.preparation":
    "Vous avez atteint le nombre maximum de membres autorisés sans offre.",
  "workspace.capacity.members.reached.scheduled":
    "Toutes les places incluses dans votre prochaine offre sont déjà utilisées.",
  "workspace.capacity.members.upgrade":
    "Pour ajouter d’autres membres, choisissez une offre supérieure.",
  "workspace.capacity.members.choosePlan":
    "Pour ajouter d’autres membres, choisissez une offre.",
  "workspace.capacity.agents.error":
    "Votre offre actuelle ne permet pas de créer un Agent supplémentaire.",
  "workspace.capacity.domains.error":
    "Votre offre actuelle ne permet pas d’ajouter ce domaine.",
  "workspace.capacity.members.error":
    "Votre offre actuelle ne comprend pas de place supplémentaire dans l’équipe.",
  "workspace.capacity.agents.duplicateBlocked":
    "Votre limite d’Agents est atteinte. Les réglages existants restent modifiables.",
  "workspace.capabilities.title": "Offre et capacités",
  "workspace.capabilities.loadError":
    "Les capacités de l’offre n’ont pas pu être chargées. Actualisez la page avant d’ajouter des ressources.",
  "workspace.capabilities.preparation":
    "Préparez dès maintenant votre premier Agent et votre domaine. Choisissez une offre avant de tester l’IA et de publier le widget.",
  "workspace.capabilities.active":
    "Les capacités de votre offre {plan} sont actives.",
  "workspace.capabilities.inactive":
    "Votre espace reste configurable, mais l’accès à l’IA nécessite une offre active.",
  "workspace.capabilities.aiActive": "IA active",
  "workspace.capabilities.preparationBadge": "Préparation",
  "workspace.capabilities.suspendedBadge": "Accès suspendu",
  "workspace.capabilities.endedBadge": "Offre terminée",
  "workspace.capabilities.scheduled":
    "L’offre {plan} est prévue pour le {date} ; ses limites inférieures empêchent déjà les nouvelles créations sans supprimer les ressources existantes.",
  "myAccount.page.myAgents.create": "Créer un Agent",
  "myAccount.page.myAgents.create.title": "Créer un Agent",
  "myAccount.page.myAgents.create.description":
    "Commencez par un nom, puis configurez ses instructions, son apparence et ses Tools.",
  "myAccount.page.myAgents.create.error": "L’Agent n’a pas pu être créé.",
  "myAccount.page.myDNS.rootDomainHint":
    "Autorisez une seule fois le domaine racine : ses sous-domaines sont inclus automatiquement.",
  "myAccount.page.myDNS.includedSubdomains":
    "Tous vos sous-domaines sont inclus par défaut. Exemples : www.{domain}, shop.{domain}.",
  "myAccount.page.myChatbot.planRequired.badge": "Une dernière étape",
  "myAccount.page.myChatbot.planRequired.title":
    "Votre Agent est presque prêt à échanger avec vos visiteurs",
  "myAccount.page.myChatbot.planRequired.description":
    "Finalisez sa personnalisation dès maintenant. Une fois votre offre choisie, vous pourrez lui parler ici, puis l’installer sur votre site.",
  "myAccount.page.myChatbot.planRequired.available.title":
    "Préparez votre Agent dès maintenant",
  "myAccount.page.myChatbot.planRequired.available.agent":
    "Personnalisez ses réponses, son apparence et ses Tools",
  "myAccount.page.myChatbot.planRequired.available.domain":
    "Autorisez le site sur lequel il sera disponible",
  "myAccount.page.myChatbot.planRequired.locked.title":
    "Puis, avec votre offre",
  "myAccount.page.myChatbot.planRequired.locked.test":
    "Testez une vraie conversation depuis cette page",
  "myAccount.page.myChatbot.planRequired.locked.publish":
    "Installez votre Agent et accueillez vos visiteurs",
  "myAccount.page.myChatbot.planRequired.configureAgent":
    "Personnaliser mon Agent",
  "myAccount.page.myChatbot.planRequired.configureDomain": "Choisir mon site",
  "myAccount.page.myChatbot.planRequired.activate":
    "Choisir une offre et tester mon Agent",
  "myAccount.page.leftMenu.onboarding": "Créer ma démo",
  "myAccount.page.leftMenu.projects": "Projets",
  "myAccount.page.leftMenu.demos": "Mes démos",
  "myAccount.page.leftMenu.production": "Mettre en production",
  "home.personalizedDemo.promise":
    "Créez gratuitement un chatbot à l’image de votre site en 10 minutes",
  "home.personalizedDemo.websiteLabel": "L’adresse de votre site",
  "home.personalizedDemo.cta": "Créer ma démo gratuite",
  "home.personalizedDemo.reassurance":
    "Aucune carte requise. Vous validez votre aperçu privé avant de pouvoir le partager.",
  "home.personalizedDemo.error":
    "Nous n’avons pas pu préparer ce site. Vérifiez son adresse et réessayez.",
  "onboarding.badge": "Démo personnalisée",
  "onboarding.title": "Découvrez votre futur Agent en action",
  "onboarding.description":
    "Nous utilisons les informations publiques de votre site pour préparer un aperçu privé. Une fois que vous aurez validé et renseigné quelques informations, vous pourrez tester gratuitement le chatbot et le partager à vos équipes.",
  "onboarding.step.website": "Votre site",
  "onboarding.step.discovery": "Découverte",
  "onboarding.step.agent": "Votre Agent",
  "onboarding.step.capabilities": "Capacités",
  "onboarding.step.review": "Agent et capacités",
  "onboarding.step.demo": "Démo partageable",
  "onboarding.progress.label": "Progression de la préparation de votre démo",
  "onboarding.error.start": "La démo n’a pas pu être lancée.",
  "onboarding.error.retry": "L’analyse du site n’a pas pu être relancée.",
  "onboarding.error.saveProposal":
    "La proposition n’a pas pu être enregistrée.",
  "onboarding.error.approveProposal": "La proposition n’a pas pu être validée.",
  "onboarding.error.activate": "La démo n’a pas pu être activée.",
  "onboarding.error.share": "Le lien de démo n’a pas pu être copié.",
  "onboarding.error.revoke": "Le lien de démo n’a pas pu être désactivé.",
  "onboarding.error.agentAlreadyConfigured":
    "Votre Agent est déjà configuré. Pour protéger votre travail, cette démo ne le remplacera pas. Contactez-nous si vous souhaitez créer une démo personnalisée séparée.",
  "onboarding.website.title":
    "Sur quel site voulez-vous construire votre démo ?",
  "onboarding.website.inputLabel": "Adresse publique du site",
  "onboarding.website.inputPlaceholder": "https://votre-site.fr",
  "onboarding.website.description":
    "Indiquez son adresse. ChatSystem prépare un Agent personnalisé à partir de votre activité, de vos contenus et de votre identité visuelle.",
  "onboarding.website.cta": "Préparer ma démo",
  "onboarding.website.duplicate": "Une démo existe déjà pour ce site internet.",
  "onboarding.website.resume": "Reprendre cette démo",
  "onboarding.website.newVersion": "Créer une autre version",
  "onboarding.website.reassurance":
    "Vous pourrez tester gratuitement un chatbot de démonstration construit à partir de ce site.",
  "onboarding.discovery.title": "Nous découvrons votre entreprise",
  "onboarding.discovery.description":
    "Nous consultons les informations de votre site pour préparer votre démo personnalisée.",
  "onboarding.discovery.failure.title": "Une nouvelle tentative est nécessaire",
  "onboarding.discovery.failure.description":
    "Le site n’a pas fourni assez d’informations publiques utilisables. Vous pouvez réessayer sans perdre votre progression.",
  "onboarding.discovery.retry": "Réessayer",
  "onboarding.review.eyebrow": "Étape 3 sur 5",
  "onboarding.review.title": "Regardons votre Agent",
  "onboarding.review.description":
    "Un Agent bien renseigné apporte des réponses plus pertinentes à vos visiteurs. Vérifiez que les informations ci-dessous sont justes et reflètent votre entreprise, sa culture et ses méthodes.",
  "onboarding.review.partial": "À vérifier",
  "onboarding.personalizationRecovery.eyebrow": "Votre Agent personnalisé",
  "onboarding.personalizationRecovery.retryable.title":
    "Votre Agent a besoin d’un peu plus de temps",
  "onboarding.personalizationRecovery.retryable.description":
    "Nous avons bien conservé les informations découvertes sur votre site, mais la proposition personnalisée n’a pas pu être finalisée. Relancez la préparation pour obtenir un Agent réellement utile et fidèle à votre entreprise.",
  "onboarding.personalizationRecovery.unavailable.title":
    "Votre projet est bien enregistré",
  "onboarding.personalizationRecovery.unavailable.description":
    "Votre site et votre projet sont conservés, mais la préparation personnalisée est momentanément indisponible. L’équipe ChatSystem a été prévenue et vous recontactera très rapidement. Vos modifications sont sauvegardées.",
  "onboarding.personalizationRecovery.retry.cta": "Relancer la préparation",
  "onboarding.personalizationRecovery.retry.loading":
    "Préparation de votre Agent…",
  "onboarding.personalizationRecovery.manual.cta":
    "Renseigner mon Agent manuellement",
  "onboarding.personalizationRecovery.saved":
    "Vous pouvez compléter les informations manuellement en attendant. Aucune réponse de votre démo n’est utilisée tant que votre Agent n’est pas prêt à être testé.",
  "onboarding.review.continueToCapabilities":
    "Continuer vers les capacités de mon Agent",
  "onboarding.review.approve": "Valider et préparer la démo",
  "onboarding.field.businessName": "Nom de l’entreprise",
  "onboarding.field.businessDescription": "Votre activité en quelques mots",
  "onboarding.field.websiteContext": "Le briefing de votre Agent",
  "onboarding.field.websiteContext.help":
    "Nous avons transformé les informations utiles de votre site en un briefing directement exploitable. Relisez-le, corrigez-le ou enrichissez-le avant de tester votre Agent.",
  "onboarding.field.agentName": "Nom de l’Agent",
  "onboarding.field.welcome": "Message d’accueil",
  "onboarding.field.welcome.help":
    "C’est le premier message que liront vos visiteurs. Vous pouvez utiliser des paragraphes courts, des listes et une touche de la personnalité de votre marque.",
  "onboarding.field.color": "Couleur principale",
  "onboarding.field.logo": "URL du logo ou favicon",
  "onboarding.field.starters": "Premières questions suggérées (facultatif)",
  "onboarding.field.starter.placeholder": "Question suggérée {number}",
  "onboarding.field.starters.help":
    "Laissez une suggestion vide si elle n’aide pas réellement vos visiteurs.",
  "onboarding.preview.label": "Aperçu en direct",
  "onboarding.preview.agentFallback": "Votre Agent",
  "onboarding.preview.welcomeFallback":
    "Votre message d’accueil apparaîtra ici.",
  "onboarding.capability.eyebrow": "Étape 4 sur 5",
  "onboarding.capability.title": "Les capacités de votre Agent",
  "onboarding.capability.description":
    "Nous avons sélectionné les capacités adaptées aux besoins des visiteurs de votre site. Choisissez celles que vous souhaitez rendre disponibles dans la démo gratuite.",
  "onboarding.capability.testable.title": "Prêtes pour votre démo gratuite",
  "onboarding.capability.testable.description":
    "Ces capacités fonctionnent avec les informations déjà préparées à partir de votre site.",
  "onboarding.capability.future.title": "D’autres capacités pour votre Agent",
  "onboarding.capability.future.description":
    "Ajoutez immédiatement les capacités déjà prêtes. Les autres se configurent depuis votre espace ou sont préparées avec ChatSystem.",
  "onboarding.capability.future.more":
    "Et découvrez bien d’autres capacités à ajouter à votre Agent.",
  "onboarding.capability.none":
    "Aucune capacité supplémentaire n’a été présélectionnée pour ce premier aperçu. Vous pouvez en ajouter une déjà prête ci-dessous.",
  "onboarding.capability.more":
    "Besoin d’un parcours personnalisé ou d’un outil adapté aux spécificités de votre entreprise ? ChatSystem peut créer des Tools sur mesure pour votre Agent. Contactez-nous pour imaginer la solution.",
  "onboarding.capability.availability.demoReady": "Prête à tester",
  "onboarding.capability.availability.readyToAdd": "Prête à ajouter",
  "onboarding.capability.availability.setupRequired": "À configurer",
  "onboarding.capability.availability.productionOnly": "Nous contacter",
  "onboarding.capability.configuration.autoFilled":
    "Préparée à partir de votre site",
  "onboarding.capability.back": "Revenir à mon Agent",
  "onboarding.activation.title": "Votre proposition est validée",
  "onboarding.activation.description":
    "Activez votre démo privée pour obtenir un lien partageable et tester jusqu’à {responseLimit, plural, one {# réponse IA} other {# réponses IA}}. Sa date d’expiration exacte sera affichée après activation. Cette démo ne peut pas être installée sur un site en production.",
  "onboarding.activation.cta": "Activer ma démo gratuite",
  "onboarding.demo.active": "Démo active",
  "onboarding.demo.title": "Votre démo partageable est prête",
  "onboarding.demo.description":
    "Ouvrez-la ou envoyez ce lien à votre équipe. Les visiteurs n’ont pas besoin de compte ChatSystem.",
  "onboarding.demo.responses": "réponses restantes",
  "onboarding.demo.expiry": "disponible jusqu’au",
  "onboarding.demo.copy": "Copier le lien",
  "onboarding.demo.linkLabel": "Lien de la démo partageable",
  "onboarding.demo.copied": "Lien copié",
  "onboarding.demo.view": "Voir ma démo",
  "onboarding.demo.production": "Prêt pour la production ? Voir les offres",
  "onboarding.demo.revoke": "Désactiver ce lien",
  "onboarding.demo.revoke.confirm": "Rendre cette démo partagée indisponible ?",
  "onboarding.closed.title": "Votre travail personnalisé est conservé",
  "onboarding.closed.description":
    "Cette démo ne peut plus recevoir de réponses, mais votre Agent validé reste disponible. Choisissez une offre de production pour continuer sans recommencer.",
  "onboarding.closed.cta": "Passer en production",
  "publicDemo.free": "Démo personnalisée gratuite",
  "publicDemo.availableUntil": "Disponible jusqu’au {date}",
  "publicDemo.title": "Un premier aperçu de votre futur Agent",
  "publicDemo.globalResponses": "réponses restantes dans cette démo",
  "publicDemo.viewerResponses": "réponses pour cette visite",
  "publicDemo.tools.title": "Capacités adaptées à cet Agent",
  "publicDemo.tools.active.title": "À tester dans cette démo",
  "publicDemo.tools.future.title":
    "D’autres capacités peuvent être ajoutées à votre Agent",
  "publicDemo.tools.more":
    "Besoin d’un parcours personnalisé ou d’un outil adapté aux spécificités de votre entreprise ? ChatSystem peut créer des Tools sur mesure pour votre Agent. Contactez-nous pour imaginer la solution.",
  "publicDemo.tools.informationOnly":
    "Cet aperçu répond à partir des informations sur l’entreprise validées par son propriétaire.",
  "publicDemo.tools.demoReady": "Actif dans cette démo",
  "publicDemo.tools.setupRequired": "À configurer",
  "publicDemo.tools.productionOnly": "Nous contacter",
  "publicDemo.cta": "Mettre mon Agent en production",
  "publicDemo.agentStatus": "Aperçu personnalisé",
  "publicDemo.thinking": "L’Agent réfléchit…",
  "publicDemo.recentMessages": "Messages récents",
  "publicDemo.input": "Posez une question…",
  "publicDemo.inputLabel": "Message destiné à l’Agent",
  "publicDemo.sessionPreparing": "Préparation de la conversation…",
  "publicDemo.inputTemporarilyUnavailable":
    "Conversation temporairement indisponible",
  "publicDemo.inputUnavailable": "Limite de conversation atteinte",
  "publicDemo.send": "Envoyer",
  "publicDemo.disclaimer":
    "Les réponses de démonstration peuvent nécessiter une vérification.",
  "publicDemo.share.action": "Partager cette démo",
  "publicDemo.share.copied": "Lien copié",
  "publicDemo.share.error":
    "Le lien n’a pas pu être copié. Veuillez réessayer.",
  "publicDemo.preparingConversation": "Préparation de votre conversation…",
  "publicDemo.sessionError":
    "Cette démo ne peut pas démarrer une nouvelle conversation actuellement.",
  "publicDemo.quotaError":
    "Cette démo gratuite a atteint sa limite de conversation.",
  "publicDemo.promptError":
    "L’Agent n’a pas pu répondre cette fois. Veuillez réessayer.",
  "publicDemo.expired.title": "Cette démo est terminée",
  "publicDemo.expired.description":
    "L’aperçu personnalisé de {company} n’est plus public. Contactez son propriétaire ou créez votre propre démo.",
  "publicDemo.expired.cta": "Créer ma propre démo",
  "admin.page.leftMenu.acquisition": "Acquisition",
  "admin.page.leftMenu.entities.discussions": "Discussions",
  "admin.page.leftMenu.entities.subscriptionFormulas": "Formules d’abonnement",
  "navigation.sidebar.label": "Navigation de l’espace",
  "navigation.breadcrumb.label": "Fil d’Ariane",
  "navigation.breadcrumb.create": "Créer",
  "navigation.breadcrumb.edit": "Modifier",
  "navigation.breadcrumb.details": "Détails",
  "navigation.breadcrumb.agentDisplays": "Affichages de l’Agent",
  "navigation.breadcrumb.editDisplay": "Modifier l’affichage",
  "navigation.breadcrumb.editFacet": "Modifier la facette",
  "navigation.breadcrumb.visitorDiscussions": "Visiteur",
  "navigation.breadcrumb.byVisitor": "Par visiteur",
  "navigation.breadcrumb.discoveryArtifact": "Source de découverte",
  "navigation.breadcrumb.llmOperation": "Opération LLM",
  "navigation.breadcrumb.report": "Rapport",
  "navigation.breadcrumb.breakdown": "Analyse",
  "navigation.breadcrumb.profitability": "Rentabilité",
  "admin.acquisition.eyebrow": "Vue d’ensemble de la croissance",
  "admin.acquisition.title": "Acquisition",
  "admin.acquisition.subtitle":
    "Pilotez chaque canal d’acquisition grâce à son parcours, sa conversion et ses coûts fournisseurs exacts.",
  "admin.acquisition.channel": "Canal d’acquisition",
  "admin.acquisition.onboarding.title": "Onboarding personnalisé",
  "admin.acquisition.onboarding.subtitle":
    "Du site proposé à la démo partageable puis à la conversion payante. Les indicateurs ci-dessous concernent uniquement ce parcours d’acquisition.",
  "admin.acquisition.updated": "Calculé le",
  "admin.acquisition.error":
    "Le tableau de bord acquisition n’a pas pu être chargé. Veuillez réessayer.",
  "admin.acquisition.kpi.websites": "Sites proposés",
  "admin.acquisition.kpi.activated": "Démos activées",
  "admin.acquisition.kpi.conversion": "Conversion payante",
  "admin.acquisition.kpi.responses": "Réponses de démo terminées",
  "admin.acquisition.funnel.title": "Parcours de l’onboarding",
  "admin.acquisition.funnel.subtitle":
    "Les événements produit idempotents rendent visibles les abandons à chaque étape utile.",
  "admin.acquisition.funnel.website": "Site proposé",
  "admin.acquisition.funnel.discovery": "Analyse du site exploitable",
  "admin.acquisition.funnel.preview": "Aperçu consulté",
  "admin.acquisition.funnel.approved": "Proposition validée",
  "admin.acquisition.funnel.activated": "Démo activée",
  "admin.acquisition.funnel.firstResponse": "Première réponse terminée",
  "admin.acquisition.funnel.shared": "Démo partagée",
  "admin.acquisition.funnel.opened": "Démo partagée ouverte",
  "admin.acquisition.funnel.offer": "Offres de production consultées",
  "admin.acquisition.funnel.checkoutStarted": "Paiement sécurisé ouvert",
  "admin.acquisition.funnel.checkoutCompleted": "Conversion payante confirmée",
  "admin.acquisition.cost.today": "Coût fournisseur aujourd’hui",
  "admin.acquisition.cost.total": "Coût fournisseur depuis le lancement",
  "admin.acquisition.cost.empty": "Aucun coût fournisseur enregistré.",
  "admin.acquisition.unitEconomics.title": "Économie unitaire",
  "admin.acquisition.operations.title": "Garde-fous opérationnels",
  "admin.acquisition.operations.discovery": "Analyses à surveiller",
  "admin.acquisition.operations.unresolvedCosts":
    "Coûts fournisseur non résolus",
  "admin.acquisition.operations.activeCosts": "Appels fournisseur en cours",
  "admin.acquisition.operations.failedResponses":
    "Réponses échouées ou interrompues",
  "admin.acquisition.operations.exhausted": "Quotas épuisés",
  "admin.acquisition.unitEconomics.activated": "Coût par démo activée",
  "admin.acquisition.unitEconomics.converted": "Coût par conversion payante",
  "admin.acquisition.demos.title": "Démos récentes",
  "admin.acquisition.demos.subtitle":
    "État opérationnel, engagement et coût fournisseur exact des derniers parcours d’acquisition.",
  "admin.acquisition.demos.open": "Ouvrir",
  "admin.acquisition.personalization.retryable": "Personnalisation à relancer",
  "admin.acquisition.personalization.blocked": "Intervention requise",
  "admin.acquisition.table.company": "Entreprise",
  "admin.acquisition.table.status": "État",
  "admin.acquisition.table.engagement": "Engagement",
  "admin.acquisition.table.cost": "Coût fournisseur",
  "admin.acquisition.table.created": "Créée le",
  "admin.acquisition.table.responses": "réponses",
  "admin.acquisition.table.viewers": "visiteurs",
  "admin.acquisition.llm.title": "Opérations LLM de l’onboarding",
  "admin.acquisition.llm.subtitle":
    "Inspectez les appels de personnalisation, les fallbacks fournisseur, les preuves conservées et leur coût exact.",
  "admin.acquisition.llm.error":
    "Les opérations LLM n’ont pas pu être chargées.",
  "admin.acquisition.llm.empty":
    "Aucune opération LLM d’onboarding n’a encore été exécutée.",
  "admin.acquisition.llm.operation": "Opération",
  "admin.acquisition.llm.attempts": "Tentatives",
  "admin.acquisition.llm.inspect": "Inspecter",
  "admin.acquisition.llm.detail.error":
    "Cette opération LLM n’a pas pu être chargée.",
  "admin.acquisition.llm.detail.back": "Retour à l’acquisition",
  "admin.acquisition.llm.detail.schema": "Schéma",
  "admin.acquisition.llm.detail.prompt": "Prompt",
  "admin.acquisition.llm.detail.operationId": "ID de l’opération",
  "admin.acquisition.llm.detail.promptFingerprint": "Empreinte du prompt",
  "admin.acquisition.llm.detail.schemaFingerprint": "Empreinte du schéma",
  "admin.acquisition.llm.detail.payloadUnavailable":
    "Contenu expiré ou indisponible.",
  "admin.acquisition.llm.detail.context": "Contexte de l’opération",
  "admin.acquisition.llm.detail.created": "Créée le",
  "admin.acquisition.llm.detail.website": "Site analysé",
  "admin.acquisition.llm.detail.demo": "Démo publique",
  "admin.acquisition.llm.detail.attempts":
    "Tentatives fournisseur et fallbacks",
  "admin.acquisition.llm.detail.attempts.help":
    "Les captures sont bornées, expurgées et supprimées après leur durée de conservation. Le coût exact reste dans le journal fournisseur.",
  "admin.acquisition.llm.detail.request": "Requête conservée",
  "admin.acquisition.llm.detail.response": "Réponse conservée",
  "admin.acquisition.llm.detail.sources": "Preuves issues de la découverte",
  "admin.acquisition.llm.detail.sources.help":
    "Ouvrez la preuve HTTP ou Brave exacte et bornée qui a été conservée pour cette analyse.",
  "admin.acquisition.llm.detail.sources.empty":
    "Aucune preuve de découverte conservée n’est liée à cette opération.",
  "admin.acquisition.artifact.error":
    "Cette preuve source n’est plus disponible ou sa durée de conservation est terminée.",
  "admin.acquisition.artifact.title": "Preuve de découverte conservée",
  "admin.acquisition.artifact.size": "Taille originale / conservée",
  "admin.acquisition.artifact.expires": "Contenu conservé jusqu’au",
  "admin.acquisition.artifact.mediaType": "Type de média",
  "toolForm.acquisitionDemo.title": "Politique de démo personnalisée",
  "toolForm.acquisitionDemo.description":
    "Validez séparément si ce Tool public peut être recommandé et si une démo anonyme peut l’exécuter. Une recommandation n’accorde jamais le droit d’exécution.",
  "toolForm.acquisitionDemo.publicRequired":
    "Seuls les Tools publics actifs entrent dans le catalogue de démo. Rendez ce Tool public ou désactivez sa recommandation dans les démos.",
  "toolForm.acquisitionDemo.recommendationEnabled":
    "Peut apparaître dans les démos personnalisées",
  "toolForm.acquisitionDemo.selectedByDefault":
    "Recommandation forte par défaut",
  "toolForm.acquisitionDemo.availability": "Disponibilité présentée au client",
  "toolForm.acquisitionDemo.availability.demoReady": "Prêt dans cette démo",
  "toolForm.acquisitionDemo.availability.setupRequired":
    "Disponible après configuration",
  "toolForm.acquisitionDemo.availability.productionOnly":
    "Uniquement en production",
  "toolForm.acquisitionDemo.analysis.title":
    "Guide fonctionnel pour l’analyse du site",
  "toolForm.acquisitionDemo.analysis.purpose": "Ce que permet ce Tool",
  "toolForm.acquisitionDemo.analysis.purpose.help":
    "Expliquez le bénéfice pour le visiteur ou l’entreprise, indépendamment d’un site précis.",
  "toolForm.acquisitionDemo.analysis.recommendWhen":
    "À recommander lorsque (une condition par ligne)",
  "toolForm.acquisitionDemo.analysis.doNotRecommendWhen":
    "À ne pas recommander lorsque (une condition par ligne)",
  "toolForm.acquisitionDemo.analysis.setupContext": "Contexte de configuration",
  "toolForm.acquisitionDemo.analysis.setupContext.help":
    "Précisez honnêtement ce qui peut déjà être démontré et ce qui doit être configuré pour la production.",
  "toolForm.acquisitionDemo.language.en": "Anglais",
  "toolForm.acquisitionDemo.copy.title": "Titre présenté au client",
  "toolForm.acquisitionDemo.copy.description":
    "Description présentée au client",
  "toolForm.acquisitionDemo.executionEnabled":
    "Autoriser l’exécution anonyme dans la démo",
  "toolForm.acquisitionDemo.effect": "Effet du Tool",
  "toolForm.acquisitionDemo.effect.readOnly": "Lecture seule",
  "toolForm.acquisitionDemo.effect.sideEffecting": "Avec effets de bord",
  "onboarding.field.agentTone.professional": "Professionnel",
  "onboarding.field.agentTone.warm": "Chaleureux",
  "onboarding.field.agentTone.direct": "Direct",
  "onboarding.field.agentTone.playful": "Enjoué",
  "admin.page.tools.table.demo": "Démo personnalisée",
  "admin.page.tools.demo.ready": "Prêt en démo",
  "admin.page.tools.demo.setup": "Après configuration",
  "admin.page.tools.demo.production": "Production uniquement",
  "admin.page.tools.demo.notReviewed": "Non validé",
  "company.members.invitation.error":
    "Le lien d’invitation n’a pas pu être créé.",
  "common.cancel": "Annuler",
  "common.create": "Créer",
  "common.creating": "Création...",
  "common.paginatedEntities.loadError":
    "Les données n’ont pas pu être chargées.",
  "common.paginatedEntities.retry": "Réessayer",
  "projects.error": "Vos projets de démo n’ont pas pu être chargés.",
  "projects.badge": "Vos projets",
  "projects.title": "Mes démos",
  "projects.description":
    "Reprenez une proposition, partagez une démo active ou préparez l’Agent que vous souhaitez mettre en production.",
  "projects.create": "Créer une autre démo",
  "projects.creation.suspended.title": "Création temporairement indisponible",
  "projects.creation.suspended":
    "La création de nouvelles démos est momentanément suspendue pour votre entreprise. Contactez-nous pour en savoir plus.",
  "projects.creation.freeLimit.title":
    "Vos deux démos d’essai ont été utilisées",
  "projects.creation.freeLimit":
    "Vous avez profité de vos deux démos d’essai. Choisissez une formule ChatSystem pour créer de nouveaux projets toute l’année et mettre votre Agent en production.",
  "projects.creation.openLimit.title": "Deux démos sont déjà ouvertes",
  "projects.creation.openLimit":
    "Fermez une démo terminée depuis « Mes démos » avant d’en préparer une nouvelle. Votre travail reste conservé dans l’historique.",
  "projects.creation.thirtyDayLimit.title":
    "Votre rythme de création mensuel est atteint",
  "projects.creation.thirtyDayLimit":
    "Vous avez créé trois démos ces 30 derniers jours. Votre capacité se libérera progressivement au fil du mois.",
  "projects.creation.twelveMonthLimit.title":
    "Les dix démos annuelles ont été créées",
  "projects.creation.twelveMonthLimit":
    "Vous avez créé les dix démos incluses sur les 12 derniers mois. Contactez-nous si votre équipe prépare davantage de projets.",
  "projects.creation.action.manage": "Gérer mes démos",
  "projects.creation.action.plans": "Voir les formules",
  "projects.creation.action.contact": "Nous contacter",
  "projects.comparePlans": "Découvrir les formules de production",
  "projects.resume": "Reprendre la préparation",
  "projects.open": "Ouvrir la démo",
  "projects.production": "Mettre en production",
  "projects.close": "Fermer la démo",
  "projects.closing": "Fermeture…",
  "projects.close.success":
    "Votre démo a bien été fermée. Son lien n’est plus actif et son historique reste accessible.",
  "projects.close.error": "La démo n’a pas pu être fermée. Veuillez réessayer.",
  "projects.close.confirm":
    "Fermer ce lien de démo ? Son historique restera disponible, mais les visiteurs ne pourront plus l’utiliser.",
  "projects.responses":
    "{remaining} réponses restantes sur {total} dans cette démo",
  "projects.created": "Créée le {date}",
  "projects.usage": "Conversations de démonstration",
  "projects.status.draft": "En préparation",
  "projects.status.active": "Active",
  "projects.status.expired": "Expirée",
  "projects.status.revoked": "Fermée",
  "projects.status.converted": "En production",
  "projects.empty.title": "Créez votre première démo personnalisée",
  "projects.empty.description":
    "Indiquez un site et ChatSystem préparera un Agent que vous pourrez relire, tester et partager.",
  "production.empty.title": "Choisissez l’Agent que vous souhaitez lancer",
  "production.empty.description":
    "Commencez par créer une démo personnalisée. Le travail validé deviendra la base de votre Agent en production.",
  "production.empty.cta": "Créer une démo",
  "production.badge": "Guide de mise en ligne",
  "production.title": "Mettre votre Agent en production",
  "production.description":
    "Suivez ces étapes pour activer l’Agent préparé dans votre démo et l’installer sur votre site.",
  "production.demoSelector.label": "Démo à mettre en production",
  "production.demoSelector.help":
    "L’Agent, son identité et les capacités validées dans cette démo seront conservés.",
  "production.access.title":
    "Un abonnement ChatSystem est nécessaire pour mettre cet Agent en production.",
  "production.access.cta": "Voir les formules",
  "production.prepare.cta": "Continuer avec cet Agent",
  "production.agent.title": "Activez l’Agent que vous avez validé",
  "production.agent.activating":
    "Votre Agent est en cours d’ajout à votre espace…",
  "production.agent.readyToAdd":
    "Cet Agent est prêt à rejoindre votre espace. L’autorisation du domaine, le test et l’installation viendront ensuite.",
  "production.agent.addToWorkspace": "Continuer avec cet Agent",
  "production.agent.capacityLoadError":
    "La capacité de votre formule n’a pas pu être vérifiée. Veuillez réessayer.",
  "production.agent.activationError":
    "Votre Agent n’a pas pu être activé cette fois. Veuillez réessayer.",
  "production.agent.retry": "Réessayer",
  "production.agent.capacityReached.title":
    "Votre formule a atteint sa limite d’Agents actifs",
  "production.agent.capacityReached.description":
    "Votre formule comprend {limit} Agents actifs et les {current} places sont utilisées. Archivez un Agent existant pour continuer avec celui-ci.",
  "production.agent.archiveLabel": "Agent à archiver",
  "production.agent.archivePlaceholder": "Choisir un Agent à archiver",
  "production.agent.noArchivableAgent":
    "Aucun Agent actif ne peut être archivé depuis cet espace. Actualisez la page ou contactez le support.",
  "production.agent.cta": "Archiver cet Agent et continuer",
  "production.steps.title": "Les étapes de votre mise en ligne",
  "production.steps.description":
    "Commencez par l’étape mise en avant. Chaque bouton ouvre directement le bon réglage.",
  "production.steps.contractError.title":
    "Le guide de mise en ligne doit être actualisé",
  "production.steps.contractError.description":
    "L’application vient d’être mise à jour. Actualisez cette page dans quelques instants pour continuer.",
  "production.step.access": "Choisir une formule ChatSystem",
  "production.step.access.completed": "Formule ChatSystem active",
  "production.step.access.description":
    "Choisissez la formule adaptée au trafic attendu sur votre site.",
  "production.step.agent_readiness": "Activer votre Agent",
  "production.step.agent_readiness.completed": "Agent activé",
  "production.step.agent_readiness.description":
    "Votre Agent va être ajouté à votre espace. L’autorisation du domaine, le test et l’installation viendront ensuite.",
  "production.step.agent_readiness.description.completed":
    "Votre Agent est maintenant disponible dans votre espace. Autorisez ensuite votre domaine, testez-le puis installez-le.",
  "production.step.domain": "Autoriser votre domaine",
  "production.step.domain.completed": "Domaine autorisé pour votre société",
  "production.step.domain.description":
    "Autorisez pour votre société le domaine sur lequel votre Agent sera installé.",
  "production.step.domain.description.completed":
    "Le domaine utilisé pour votre démo est maintenant autorisé pour votre société.",
  "production.step.production_test": "Tester en conditions réelles",
  "production.step.production_test.description":
    "Essayez votre Agent de production avant de le présenter à vos visiteurs.",
  "production.step.install": "Installer sur votre site",
  "production.step.install.description":
    "Copiez le code d’installation et ajoutez-le à votre site.",
  "production.step.go_live": "Vérifier votre site",
  "production.step.go_live.description":
    "Ouvrez votre site et vérifiez l’expérience finale proposée à vos visiteurs.",
  "production.step.status.completed": "Terminé",
  "production.step.status.current": "Prochaine étape",
  "production.step.status.locked.paid_access":
    "Disponible après le choix d’une formule",
  "production.step.status.locked.active_agent":
    "Disponible après l’activation de l’Agent",
  "production.step.status.todo": "À faire",
  "production.action.review_agent": "Vérifier mon Agent",
  "production.action.configure_domain": "Autoriser mon domaine",
  "production.action.test_agent": "Tester mon Agent",
  "production.action.install_agent": "Voir les instructions d’installation",
  "production.action.open_website": "Ouvrir mon site",
  "production.finalActions.ready.title": "Votre Agent est prêt à être installé",
  "production.finalActions.ready.description":
    "Ajoutez ChatSystem à votre site, puis ouvrez-le pour vérifier l’expérience proposée à vos visiteurs.",
  "production.finalActions.locked.title":
    "L’installation viendra après ces vérifications",
  "production.finalActions.locked.description":
    "Terminez d’abord les étapes ci-dessus. Nous vous guiderons ensuite pour installer l’Agent et vérifier son fonctionnement sur votre site.",
  "production.error.prepare":
    "Le parcours de mise en production n’a pas pu être préparé.",
  "production.error.promote":
    "Cet Agent n’a pas pu être activé. Si la limite de votre formule est atteinte, sélectionnez un Agent existant à archiver.",
  "production.error.lifecycle":
    "Le statut de cet Agent n’a pas pu être modifié.",
  "production.agents.title": "Agents de votre espace",
  "production.agents.description":
    "Retrouvez et gérez les Agents déjà créés dans votre espace.",
  "production.agents.active": "Disponible",
  "production.agents.archived": "Archivé",
  "production.agents.archive": "Archiver",
  "production.agents.restore": "Restaurer",
  "myAccount.page.myAgents.lifecycle.actions": "Actions",
  "myAccount.page.myAgents.archive.confirm":
    "Archiver « {name} » ? Sa configuration sera conservée et vous pourrez le restaurer lorsqu’une place sera disponible.",
  "myAccount.page.myAgents.archived.title": "Agents archivés",
  "myAccount.page.myAgents.archived.description":
    "Leur configuration est conservée. Restaurez un Agent lorsqu’une place est disponible dans votre formule.",
  "pricing.production.title": "Votre Agent est prêt pour la production",
  "pricing.production.description":
    "Choisissez la formule adaptée à votre trafic. Votre Agent et les choix validés dans la démo sont conservés ; après l’abonnement, reprenez simplement depuis « Mettre en production ».",
  "admin.acquisition.policy.title": "Capacité de démo par entreprise",
  "admin.acquisition.policy.description":
    "Consultez le quota effectif et consignez toute capacité exceptionnelle ou suspension avec son motif d’audit.",
  "admin.acquisition.policy.company": "Choisir une entreprise",
  "admin.acquisition.policy.lifetime": "Total",
  "admin.acquisition.policy.open": "Ouvertes",
  "admin.acquisition.policy.thirtyDays": "30 jours",
  "admin.acquisition.policy.twelveMonths": "12 mois",
  "admin.acquisition.policy.allowed": "Création actuellement autorisée",
  "admin.acquisition.policy.blocked": "Création bloquée : {reason}",
  "admin.acquisition.policy.reason": "Motif d’audit obligatoire",
  "admin.acquisition.policy.grant": "Accorder une démo supplémentaire",
  "admin.acquisition.policy.revoke": "Retirer une démo supplémentaire",
  "admin.acquisition.policy.resume": "Réautoriser la création",
  "admin.acquisition.policy.suspend": "Suspendre la création",
  "publicDemo.tools.readyToAdd": "Prête à être utilisée",
  "discussion.agent.label": "Agent",
  "discussion.agent.id": "ID de l’Agent",
  "discussion.agent.filter.apply": "Appliquer le filtre",
};
